function tc(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default")
    ? e.default
    : e;
}
var Hi = { exports: {} },
  el = {},
  Wi = { exports: {} },
  L = {};
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var Xt = Symbol.for("react.element"),
  rc = Symbol.for("react.portal"),
  lc = Symbol.for("react.fragment"),
  oc = Symbol.for("react.strict_mode"),
  uc = Symbol.for("react.profiler"),
  ic = Symbol.for("react.provider"),
  sc = Symbol.for("react.context"),
  ac = Symbol.for("react.forward_ref"),
  cc = Symbol.for("react.suspense"),
  fc = Symbol.for("react.memo"),
  dc = Symbol.for("react.lazy"),
  Ou = Symbol.iterator;
function pc(e) {
  return e === null || typeof e != "object"
    ? null
    : ((e = (Ou && e[Ou]) || e["@@iterator"]),
      typeof e == "function" ? e : null);
}
var Qi = {
    isMounted: function () {
      return !1;
    },
    enqueueForceUpdate: function () {},
    enqueueReplaceState: function () {},
    enqueueSetState: function () {},
  },
  Ki = Object.assign,
  Yi = {};
function lt(e, n, t) {
  (this.props = e),
    (this.context = n),
    (this.refs = Yi),
    (this.updater = t || Qi);
}
lt.prototype.isReactComponent = {};
lt.prototype.setState = function (e, n) {
  if (typeof e != "object" && typeof e != "function" && e != null)
    throw Error(
      "setState(...): takes an object of state variables to update or a function which returns an object of state variables."
    );
  this.updater.enqueueSetState(this, e, n, "setState");
};
lt.prototype.forceUpdate = function (e) {
  this.updater.enqueueForceUpdate(this, e, "forceUpdate");
};
function Xi() {}
Xi.prototype = lt.prototype;
function $o(e, n, t) {
  (this.props = e),
    (this.context = n),
    (this.refs = Yi),
    (this.updater = t || Qi);
}
var Ao = ($o.prototype = new Xi());
Ao.constructor = $o;
Ki(Ao, lt.prototype);
Ao.isPureReactComponent = !0;
var Du = Array.isArray,
  Gi = Object.prototype.hasOwnProperty,
  Vo = { current: null },
  Zi = { key: !0, ref: !0, __self: !0, __source: !0 };
function Ji(e, n, t) {
  var r,
    l = {},
    o = null,
    u = null;
  if (n != null)
    for (r in (n.ref !== void 0 && (u = n.ref),
    n.key !== void 0 && (o = "" + n.key),
    n))
      Gi.call(n, r) && !Zi.hasOwnProperty(r) && (l[r] = n[r]);
  var i = arguments.length - 2;
  if (i === 1) l.children = t;
  else if (1 < i) {
    for (var s = Array(i), c = 0; c < i; c++) s[c] = arguments[c + 2];
    l.children = s;
  }
  if (e && e.defaultProps)
    for (r in ((i = e.defaultProps), i)) l[r] === void 0 && (l[r] = i[r]);
  return {
    $$typeof: Xt,
    type: e,
    key: o,
    ref: u,
    props: l,
    _owner: Vo.current,
  };
}
function mc(e, n) {
  return {
    $$typeof: Xt,
    type: e.type,
    key: n,
    ref: e.ref,
    props: e.props,
    _owner: e._owner,
  };
}
function Bo(e) {
  return typeof e == "object" && e !== null && e.$$typeof === Xt;
}
function hc(e) {
  var n = { "=": "=0", ":": "=2" };
  return (
    "$" +
    e.replace(/[=:]/g, function (t) {
      return n[t];
    })
  );
}
var Iu = /\/+/g;
function wl(e, n) {
  return typeof e == "object" && e !== null && e.key != null
    ? hc("" + e.key)
    : n.toString(36);
}
function gr(e, n, t, r, l) {
  var o = typeof e;
  (o === "undefined" || o === "boolean") && (e = null);
  var u = !1;
  if (e === null) u = !0;
  else
    switch (o) {
      case "string":
      case "number":
        u = !0;
        break;
      case "object":
        switch (e.$$typeof) {
          case Xt:
          case rc:
            u = !0;
        }
    }
  if (u)
    return (
      (u = e),
      (l = l(u)),
      (e = r === "" ? "." + wl(u, 0) : r),
      Du(l)
        ? ((t = ""),
          e != null && (t = e.replace(Iu, "$&/") + "/"),
          gr(l, n, t, "", function (c) {
            return c;
          }))
        : l != null &&
          (Bo(l) &&
            (l = mc(
              l,
              t +
                (!l.key || (u && u.key === l.key)
                  ? ""
                  : ("" + l.key).replace(Iu, "$&/") + "/") +
                e
            )),
          n.push(l)),
      1
    );
  if (((u = 0), (r = r === "" ? "." : r + ":"), Du(e)))
    for (var i = 0; i < e.length; i++) {
      o = e[i];
      var s = r + wl(o, i);
      u += gr(o, n, t, s, l);
    }
  else if (((s = pc(e)), typeof s == "function"))
    for (e = s.call(e), i = 0; !(o = e.next()).done; )
      (o = o.value), (s = r + wl(o, i++)), (u += gr(o, n, t, s, l));
  else if (o === "object")
    throw (
      ((n = String(e)),
      Error(
        "Objects are not valid as a React child (found: " +
          (n === "[object Object]"
            ? "object with keys {" + Object.keys(e).join(", ") + "}"
            : n) +
          "). If you meant to render a collection of children, use an array instead."
      ))
    );
  return u;
}
function nr(e, n, t) {
  if (e == null) return e;
  var r = [],
    l = 0;
  return (
    gr(e, r, "", "", function (o) {
      return n.call(t, o, l++);
    }),
    r
  );
}
function vc(e) {
  if (e._status === -1) {
    var n = e._result;
    (n = n()),
      n.then(
        function (t) {
          (e._status === 0 || e._status === -1) &&
            ((e._status = 1), (e._result = t));
        },
        function (t) {
          (e._status === 0 || e._status === -1) &&
            ((e._status = 2), (e._result = t));
        }
      ),
      e._status === -1 && ((e._status = 0), (e._result = n));
  }
  if (e._status === 1) return e._result.default;
  throw e._result;
}
var ie = { current: null },
  wr = { transition: null },
  yc = {
    ReactCurrentDispatcher: ie,
    ReactCurrentBatchConfig: wr,
    ReactCurrentOwner: Vo,
  };
function qi() {
  throw Error("act(...) is not supported in production builds of React.");
}
L.Children = {
  map: nr,
  forEach: function (e, n, t) {
    nr(
      e,
      function () {
        n.apply(this, arguments);
      },
      t
    );
  },
  count: function (e) {
    var n = 0;
    return (
      nr(e, function () {
        n++;
      }),
      n
    );
  },
  toArray: function (e) {
    return (
      nr(e, function (n) {
        return n;
      }) || []
    );
  },
  only: function (e) {
    if (!Bo(e))
      throw Error(
        "React.Children.only expected to receive a single React element child."
      );
    return e;
  },
};
L.Component = lt;
L.Fragment = lc;
L.Profiler = uc;
L.PureComponent = $o;
L.StrictMode = oc;
L.Suspense = cc;
L.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = yc;
L.act = qi;
L.cloneElement = function (e, n, t) {
  if (e == null)
    throw Error(
      "React.cloneElement(...): The argument must be a React element, but you passed " +
        e +
        "."
    );
  var r = Ki({}, e.props),
    l = e.key,
    o = e.ref,
    u = e._owner;
  if (n != null) {
    if (
      (n.ref !== void 0 && ((o = n.ref), (u = Vo.current)),
      n.key !== void 0 && (l = "" + n.key),
      e.type && e.type.defaultProps)
    )
      var i = e.type.defaultProps;
    for (s in n)
      Gi.call(n, s) &&
        !Zi.hasOwnProperty(s) &&
        (r[s] = n[s] === void 0 && i !== void 0 ? i[s] : n[s]);
  }
  var s = arguments.length - 2;
  if (s === 1) r.children = t;
  else if (1 < s) {
    i = Array(s);
    for (var c = 0; c < s; c++) i[c] = arguments[c + 2];
    r.children = i;
  }
  return { $$typeof: Xt, type: e.type, key: l, ref: o, props: r, _owner: u };
};
L.createContext = function (e) {
  return (
    (e = {
      $$typeof: sc,
      _currentValue: e,
      _currentValue2: e,
      _threadCount: 0,
      Provider: null,
      Consumer: null,
      _defaultValue: null,
      _globalName: null,
    }),
    (e.Provider = { $$typeof: ic, _context: e }),
    (e.Consumer = e)
  );
};
L.createElement = Ji;
L.createFactory = function (e) {
  var n = Ji.bind(null, e);
  return (n.type = e), n;
};
L.createRef = function () {
  return { current: null };
};
L.forwardRef = function (e) {
  return { $$typeof: ac, render: e };
};
L.isValidElement = Bo;
L.lazy = function (e) {
  return { $$typeof: dc, _payload: { _status: -1, _result: e }, _init: vc };
};
L.memo = function (e, n) {
  return { $$typeof: fc, type: e, compare: n === void 0 ? null : n };
};
L.startTransition = function (e) {
  var n = wr.transition;
  wr.transition = {};
  try {
    e();
  } finally {
    wr.transition = n;
  }
};
L.unstable_act = qi;
L.useCallback = function (e, n) {
  return ie.current.useCallback(e, n);
};
L.useContext = function (e) {
  return ie.current.useContext(e);
};
L.useDebugValue = function () {};
L.useDeferredValue = function (e) {
  return ie.current.useDeferredValue(e);
};
L.useEffect = function (e, n) {
  return ie.current.useEffect(e, n);
};
L.useId = function () {
  return ie.current.useId();
};
L.useImperativeHandle = function (e, n, t) {
  return ie.current.useImperativeHandle(e, n, t);
};
L.useInsertionEffect = function (e, n) {
  return ie.current.useInsertionEffect(e, n);
};
L.useLayoutEffect = function (e, n) {
  return ie.current.useLayoutEffect(e, n);
};
L.useMemo = function (e, n) {
  return ie.current.useMemo(e, n);
};
L.useReducer = function (e, n, t) {
  return ie.current.useReducer(e, n, t);
};
L.useRef = function (e) {
  return ie.current.useRef(e);
};
L.useState = function (e) {
  return ie.current.useState(e);
};
L.useSyncExternalStore = function (e, n, t) {
  return ie.current.useSyncExternalStore(e, n, t);
};
L.useTransition = function () {
  return ie.current.useTransition();
};
L.version = "18.3.1";
Wi.exports = L;
var Tt = Wi.exports;
const gc = tc(Tt);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var wc = Tt,
  Sc = Symbol.for("react.element"),
  kc = Symbol.for("react.fragment"),
  Ec = Object.prototype.hasOwnProperty,
  Cc = wc.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
  xc = { key: !0, ref: !0, __self: !0, __source: !0 };
function bi(e, n, t) {
  var r,
    l = {},
    o = null,
    u = null;
  t !== void 0 && (o = "" + t),
    n.key !== void 0 && (o = "" + n.key),
    n.ref !== void 0 && (u = n.ref);
  for (r in n) Ec.call(n, r) && !xc.hasOwnProperty(r) && (l[r] = n[r]);
  if (e && e.defaultProps)
    for (r in ((n = e.defaultProps), n)) l[r] === void 0 && (l[r] = n[r]);
  return {
    $$typeof: Sc,
    type: e,
    key: o,
    ref: u,
    props: l,
    _owner: Cc.current,
  };
}
el.Fragment = kc;
el.jsx = bi;
el.jsxs = bi;
Hi.exports = el;
var j = Hi.exports,
  Ql = {},
  es = { exports: {} },
  ge = {},
  ns = { exports: {} },
  ts = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ (function (e) {
  function n(C, P) {
    var z = C.length;
    C.push(P);
    e: for (; 0 < z; ) {
      var W = (z - 1) >>> 1,
        G = C[W];
      if (0 < l(G, P)) (C[W] = P), (C[z] = G), (z = W);
      else break e;
    }
  }
  function t(C) {
    return C.length === 0 ? null : C[0];
  }
  function r(C) {
    if (C.length === 0) return null;
    var P = C[0],
      z = C.pop();
    if (z !== P) {
      C[0] = z;
      e: for (var W = 0, G = C.length, bt = G >>> 1; W < bt; ) {
        var vn = 2 * (W + 1) - 1,
          gl = C[vn],
          yn = vn + 1,
          er = C[yn];
        if (0 > l(gl, z))
          yn < G && 0 > l(er, gl)
            ? ((C[W] = er), (C[yn] = z), (W = yn))
            : ((C[W] = gl), (C[vn] = z), (W = vn));
        else if (yn < G && 0 > l(er, z)) (C[W] = er), (C[yn] = z), (W = yn);
        else break e;
      }
    }
    return P;
  }
  function l(C, P) {
    var z = C.sortIndex - P.sortIndex;
    return z !== 0 ? z : C.id - P.id;
  }
  if (typeof performance == "object" && typeof performance.now == "function") {
    var o = performance;
    e.unstable_now = function () {
      return o.now();
    };
  } else {
    var u = Date,
      i = u.now();
    e.unstable_now = function () {
      return u.now() - i;
    };
  }
  var s = [],
    c = [],
    m = 1,
    h = null,
    p = 3,
    g = !1,
    w = !1,
    S = !1,
    O = typeof setTimeout == "function" ? setTimeout : null,
    d = typeof clearTimeout == "function" ? clearTimeout : null,
    a = typeof setImmediate < "u" ? setImmediate : null;
  typeof navigator < "u" &&
    navigator.scheduling !== void 0 &&
    navigator.scheduling.isInputPending !== void 0 &&
    navigator.scheduling.isInputPending.bind(navigator.scheduling);
  function f(C) {
    for (var P = t(c); P !== null; ) {
      if (P.callback === null) r(c);
      else if (P.startTime <= C)
        r(c), (P.sortIndex = P.expirationTime), n(s, P);
      else break;
      P = t(c);
    }
  }
  function v(C) {
    if (((S = !1), f(C), !w))
      if (t(s) !== null) (w = !0), vl(E);
      else {
        var P = t(c);
        P !== null && yl(v, P.startTime - C);
      }
  }
  function E(C, P) {
    (w = !1), S && ((S = !1), d(N), (N = -1)), (g = !0);
    var z = p;
    try {
      for (
        f(P), h = t(s);
        h !== null && (!(h.expirationTime > P) || (C && !Ne()));

      ) {
        var W = h.callback;
        if (typeof W == "function") {
          (h.callback = null), (p = h.priorityLevel);
          var G = W(h.expirationTime <= P);
          (P = e.unstable_now()),
            typeof G == "function" ? (h.callback = G) : h === t(s) && r(s),
            f(P);
        } else r(s);
        h = t(s);
      }
      if (h !== null) var bt = !0;
      else {
        var vn = t(c);
        vn !== null && yl(v, vn.startTime - P), (bt = !1);
      }
      return bt;
    } finally {
      (h = null), (p = z), (g = !1);
    }
  }
  var x = !1,
    _ = null,
    N = -1,
    H = 5,
    T = -1;
  function Ne() {
    return !(e.unstable_now() - T < H);
  }
  function it() {
    if (_ !== null) {
      var C = e.unstable_now();
      T = C;
      var P = !0;
      try {
        P = _(!0, C);
      } finally {
        P ? st() : ((x = !1), (_ = null));
      }
    } else x = !1;
  }
  var st;
  if (typeof a == "function")
    st = function () {
      a(it);
    };
  else if (typeof MessageChannel < "u") {
    var Mu = new MessageChannel(),
      nc = Mu.port2;
    (Mu.port1.onmessage = it),
      (st = function () {
        nc.postMessage(null);
      });
  } else
    st = function () {
      O(it, 0);
    };
  function vl(C) {
    (_ = C), x || ((x = !0), st());
  }
  function yl(C, P) {
    N = O(function () {
      C(e.unstable_now());
    }, P);
  }
  (e.unstable_IdlePriority = 5),
    (e.unstable_ImmediatePriority = 1),
    (e.unstable_LowPriority = 4),
    (e.unstable_NormalPriority = 3),
    (e.unstable_Profiling = null),
    (e.unstable_UserBlockingPriority = 2),
    (e.unstable_cancelCallback = function (C) {
      C.callback = null;
    }),
    (e.unstable_continueExecution = function () {
      w || g || ((w = !0), vl(E));
    }),
    (e.unstable_forceFrameRate = function (C) {
      0 > C || 125 < C
        ? console.error(
            "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
          )
        : (H = 0 < C ? Math.floor(1e3 / C) : 5);
    }),
    (e.unstable_getCurrentPriorityLevel = function () {
      return p;
    }),
    (e.unstable_getFirstCallbackNode = function () {
      return t(s);
    }),
    (e.unstable_next = function (C) {
      switch (p) {
        case 1:
        case 2:
        case 3:
          var P = 3;
          break;
        default:
          P = p;
      }
      var z = p;
      p = P;
      try {
        return C();
      } finally {
        p = z;
      }
    }),
    (e.unstable_pauseExecution = function () {}),
    (e.unstable_requestPaint = function () {}),
    (e.unstable_runWithPriority = function (C, P) {
      switch (C) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          C = 3;
      }
      var z = p;
      p = C;
      try {
        return P();
      } finally {
        p = z;
      }
    }),
    (e.unstable_scheduleCallback = function (C, P, z) {
      var W = e.unstable_now();
      switch (
        (typeof z == "object" && z !== null
          ? ((z = z.delay), (z = typeof z == "number" && 0 < z ? W + z : W))
          : (z = W),
        C)
      ) {
        case 1:
          var G = -1;
          break;
        case 2:
          G = 250;
          break;
        case 5:
          G = 1073741823;
          break;
        case 4:
          G = 1e4;
          break;
        default:
          G = 5e3;
      }
      return (
        (G = z + G),
        (C = {
          id: m++,
          callback: P,
          priorityLevel: C,
          startTime: z,
          expirationTime: G,
          sortIndex: -1,
        }),
        z > W
          ? ((C.sortIndex = z),
            n(c, C),
            t(s) === null &&
              C === t(c) &&
              (S ? (d(N), (N = -1)) : (S = !0), yl(v, z - W)))
          : ((C.sortIndex = G), n(s, C), w || g || ((w = !0), vl(E))),
        C
      );
    }),
    (e.unstable_shouldYield = Ne),
    (e.unstable_wrapCallback = function (C) {
      var P = p;
      return function () {
        var z = p;
        p = P;
        try {
          return C.apply(this, arguments);
        } finally {
          p = z;
        }
      };
    });
})(ts);
ns.exports = ts;
var _c = ns.exports;
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var Nc = Tt,
  ye = _c;
function y(e) {
  for (
    var n = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, t = 1;
    t < arguments.length;
    t++
  )
    n += "&args[]=" + encodeURIComponent(arguments[t]);
  return (
    "Minified React error #" +
    e +
    "; visit " +
    n +
    " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
  );
}
var rs = new Set(),
  Rt = {};
function Tn(e, n) {
  Jn(e, n), Jn(e + "Capture", n);
}
function Jn(e, n) {
  for (Rt[e] = n, e = 0; e < n.length; e++) rs.add(n[e]);
}
var We = !(
    typeof window > "u" ||
    typeof window.document > "u" ||
    typeof window.document.createElement > "u"
  ),
  Kl = Object.prototype.hasOwnProperty,
  Pc =
    /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
  Fu = {},
  Uu = {};
function zc(e) {
  return Kl.call(Uu, e)
    ? !0
    : Kl.call(Fu, e)
    ? !1
    : Pc.test(e)
    ? (Uu[e] = !0)
    : ((Fu[e] = !0), !1);
}
function Lc(e, n, t, r) {
  if (t !== null && t.type === 0) return !1;
  switch (typeof n) {
    case "function":
    case "symbol":
      return !0;
    case "boolean":
      return r
        ? !1
        : t !== null
        ? !t.acceptsBooleans
        : ((e = e.toLowerCase().slice(0, 5)), e !== "data-" && e !== "aria-");
    default:
      return !1;
  }
}
function Tc(e, n, t, r) {
  if (n === null || typeof n > "u" || Lc(e, n, t, r)) return !0;
  if (r) return !1;
  if (t !== null)
    switch (t.type) {
      case 3:
        return !n;
      case 4:
        return n === !1;
      case 5:
        return isNaN(n);
      case 6:
        return isNaN(n) || 1 > n;
    }
  return !1;
}
function se(e, n, t, r, l, o, u) {
  (this.acceptsBooleans = n === 2 || n === 3 || n === 4),
    (this.attributeName = r),
    (this.attributeNamespace = l),
    (this.mustUseProperty = t),
    (this.propertyName = e),
    (this.type = n),
    (this.sanitizeURL = o),
    (this.removeEmptyString = u);
}
var ee = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style"
  .split(" ")
  .forEach(function (e) {
    ee[e] = new se(e, 0, !1, e, null, !1, !1);
  });
[
  ["acceptCharset", "accept-charset"],
  ["className", "class"],
  ["htmlFor", "for"],
  ["httpEquiv", "http-equiv"],
].forEach(function (e) {
  var n = e[0];
  ee[n] = new se(n, 1, !1, e[1], null, !1, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function (e) {
  ee[e] = new se(e, 2, !1, e.toLowerCase(), null, !1, !1);
});
[
  "autoReverse",
  "externalResourcesRequired",
  "focusable",
  "preserveAlpha",
].forEach(function (e) {
  ee[e] = new se(e, 2, !1, e, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope"
  .split(" ")
  .forEach(function (e) {
    ee[e] = new se(e, 3, !1, e.toLowerCase(), null, !1, !1);
  });
["checked", "multiple", "muted", "selected"].forEach(function (e) {
  ee[e] = new se(e, 3, !0, e, null, !1, !1);
});
["capture", "download"].forEach(function (e) {
  ee[e] = new se(e, 4, !1, e, null, !1, !1);
});
["cols", "rows", "size", "span"].forEach(function (e) {
  ee[e] = new se(e, 6, !1, e, null, !1, !1);
});
["rowSpan", "start"].forEach(function (e) {
  ee[e] = new se(e, 5, !1, e.toLowerCase(), null, !1, !1);
});
var Ho = /[\-:]([a-z])/g;
function Wo(e) {
  return e[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height"
  .split(" ")
  .forEach(function (e) {
    var n = e.replace(Ho, Wo);
    ee[n] = new se(n, 1, !1, e, null, !1, !1);
  });
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type"
  .split(" ")
  .forEach(function (e) {
    var n = e.replace(Ho, Wo);
    ee[n] = new se(n, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
  });
["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
  var n = e.replace(Ho, Wo);
  ee[n] = new se(n, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
["tabIndex", "crossOrigin"].forEach(function (e) {
  ee[e] = new se(e, 1, !1, e.toLowerCase(), null, !1, !1);
});
ee.xlinkHref = new se(
  "xlinkHref",
  1,
  !1,
  "xlink:href",
  "http://www.w3.org/1999/xlink",
  !0,
  !1
);
["src", "href", "action", "formAction"].forEach(function (e) {
  ee[e] = new se(e, 1, !1, e.toLowerCase(), null, !0, !0);
});
function Qo(e, n, t, r) {
  var l = ee.hasOwnProperty(n) ? ee[n] : null;
  (l !== null
    ? l.type !== 0
    : r ||
      !(2 < n.length) ||
      (n[0] !== "o" && n[0] !== "O") ||
      (n[1] !== "n" && n[1] !== "N")) &&
    (Tc(n, t, l, r) && (t = null),
    r || l === null
      ? zc(n) && (t === null ? e.removeAttribute(n) : e.setAttribute(n, "" + t))
      : l.mustUseProperty
      ? (e[l.propertyName] = t === null ? (l.type === 3 ? !1 : "") : t)
      : ((n = l.attributeName),
        (r = l.attributeNamespace),
        t === null
          ? e.removeAttribute(n)
          : ((l = l.type),
            (t = l === 3 || (l === 4 && t === !0) ? "" : "" + t),
            r ? e.setAttributeNS(r, n, t) : e.setAttribute(n, t))));
}
var Xe = Nc.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
  tr = Symbol.for("react.element"),
  Mn = Symbol.for("react.portal"),
  On = Symbol.for("react.fragment"),
  Ko = Symbol.for("react.strict_mode"),
  Yl = Symbol.for("react.profiler"),
  ls = Symbol.for("react.provider"),
  os = Symbol.for("react.context"),
  Yo = Symbol.for("react.forward_ref"),
  Xl = Symbol.for("react.suspense"),
  Gl = Symbol.for("react.suspense_list"),
  Xo = Symbol.for("react.memo"),
  Ze = Symbol.for("react.lazy"),
  us = Symbol.for("react.offscreen"),
  $u = Symbol.iterator;
function at(e) {
  return e === null || typeof e != "object"
    ? null
    : ((e = ($u && e[$u]) || e["@@iterator"]),
      typeof e == "function" ? e : null);
}
var V = Object.assign,
  Sl;
function yt(e) {
  if (Sl === void 0)
    try {
      throw Error();
    } catch (t) {
      var n = t.stack.trim().match(/\n( *(at )?)/);
      Sl = (n && n[1]) || "";
    }
  return (
    `
` +
    Sl +
    e
  );
}
var kl = !1;
function El(e, n) {
  if (!e || kl) return "";
  kl = !0;
  var t = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;
  try {
    if (n)
      if (
        ((n = function () {
          throw Error();
        }),
        Object.defineProperty(n.prototype, "props", {
          set: function () {
            throw Error();
          },
        }),
        typeof Reflect == "object" && Reflect.construct)
      ) {
        try {
          Reflect.construct(n, []);
        } catch (c) {
          var r = c;
        }
        Reflect.construct(e, [], n);
      } else {
        try {
          n.call();
        } catch (c) {
          r = c;
        }
        e.call(n.prototype);
      }
    else {
      try {
        throw Error();
      } catch (c) {
        r = c;
      }
      e();
    }
  } catch (c) {
    if (c && r && typeof c.stack == "string") {
      for (
        var l = c.stack.split(`
`),
          o = r.stack.split(`
`),
          u = l.length - 1,
          i = o.length - 1;
        1 <= u && 0 <= i && l[u] !== o[i];

      )
        i--;
      for (; 1 <= u && 0 <= i; u--, i--)
        if (l[u] !== o[i]) {
          if (u !== 1 || i !== 1)
            do
              if ((u--, i--, 0 > i || l[u] !== o[i])) {
                var s =
                  `
` + l[u].replace(" at new ", " at ");
                return (
                  e.displayName &&
                    s.includes("<anonymous>") &&
                    (s = s.replace("<anonymous>", e.displayName)),
                  s
                );
              }
            while (1 <= u && 0 <= i);
          break;
        }
    }
  } finally {
    (kl = !1), (Error.prepareStackTrace = t);
  }
  return (e = e ? e.displayName || e.name : "") ? yt(e) : "";
}
function Rc(e) {
  switch (e.tag) {
    case 5:
      return yt(e.type);
    case 16:
      return yt("Lazy");
    case 13:
      return yt("Suspense");
    case 19:
      return yt("SuspenseList");
    case 0:
    case 2:
    case 15:
      return (e = El(e.type, !1)), e;
    case 11:
      return (e = El(e.type.render, !1)), e;
    case 1:
      return (e = El(e.type, !0)), e;
    default:
      return "";
  }
}
function Zl(e) {
  if (e == null) return null;
  if (typeof e == "function") return e.displayName || e.name || null;
  if (typeof e == "string") return e;
  switch (e) {
    case On:
      return "Fragment";
    case Mn:
      return "Portal";
    case Yl:
      return "Profiler";
    case Ko:
      return "StrictMode";
    case Xl:
      return "Suspense";
    case Gl:
      return "SuspenseList";
  }
  if (typeof e == "object")
    switch (e.$$typeof) {
      case os:
        return (e.displayName || "Context") + ".Consumer";
      case ls:
        return (e._context.displayName || "Context") + ".Provider";
      case Yo:
        var n = e.render;
        return (
          (e = e.displayName),
          e ||
            ((e = n.displayName || n.name || ""),
            (e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef")),
          e
        );
      case Xo:
        return (
          (n = e.displayName || null), n !== null ? n : Zl(e.type) || "Memo"
        );
      case Ze:
        (n = e._payload), (e = e._init);
        try {
          return Zl(e(n));
        } catch {}
    }
  return null;
}
function jc(e) {
  var n = e.type;
  switch (e.tag) {
    case 24:
      return "Cache";
    case 9:
      return (n.displayName || "Context") + ".Consumer";
    case 10:
      return (n._context.displayName || "Context") + ".Provider";
    case 18:
      return "DehydratedFragment";
    case 11:
      return (
        (e = n.render),
        (e = e.displayName || e.name || ""),
        n.displayName || (e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef")
      );
    case 7:
      return "Fragment";
    case 5:
      return n;
    case 4:
      return "Portal";
    case 3:
      return "Root";
    case 6:
      return "Text";
    case 16:
      return Zl(n);
    case 8:
      return n === Ko ? "StrictMode" : "Mode";
    case 22:
      return "Offscreen";
    case 12:
      return "Profiler";
    case 21:
      return "Scope";
    case 13:
      return "Suspense";
    case 19:
      return "SuspenseList";
    case 25:
      return "TracingMarker";
    case 1:
    case 0:
    case 17:
    case 2:
    case 14:
    case 15:
      if (typeof n == "function") return n.displayName || n.name || null;
      if (typeof n == "string") return n;
  }
  return null;
}
function fn(e) {
  switch (typeof e) {
    case "boolean":
    case "number":
    case "string":
    case "undefined":
      return e;
    case "object":
      return e;
    default:
      return "";
  }
}
function is(e) {
  var n = e.type;
  return (
    (e = e.nodeName) &&
    e.toLowerCase() === "input" &&
    (n === "checkbox" || n === "radio")
  );
}
function Mc(e) {
  var n = is(e) ? "checked" : "value",
    t = Object.getOwnPropertyDescriptor(e.constructor.prototype, n),
    r = "" + e[n];
  if (
    !e.hasOwnProperty(n) &&
    typeof t < "u" &&
    typeof t.get == "function" &&
    typeof t.set == "function"
  ) {
    var l = t.get,
      o = t.set;
    return (
      Object.defineProperty(e, n, {
        configurable: !0,
        get: function () {
          return l.call(this);
        },
        set: function (u) {
          (r = "" + u), o.call(this, u);
        },
      }),
      Object.defineProperty(e, n, { enumerable: t.enumerable }),
      {
        getValue: function () {
          return r;
        },
        setValue: function (u) {
          r = "" + u;
        },
        stopTracking: function () {
          (e._valueTracker = null), delete e[n];
        },
      }
    );
  }
}
function rr(e) {
  e._valueTracker || (e._valueTracker = Mc(e));
}
function ss(e) {
  if (!e) return !1;
  var n = e._valueTracker;
  if (!n) return !0;
  var t = n.getValue(),
    r = "";
  return (
    e && (r = is(e) ? (e.checked ? "true" : "false") : e.value),
    (e = r),
    e !== t ? (n.setValue(e), !0) : !1
  );
}
function Tr(e) {
  if (((e = e || (typeof document < "u" ? document : void 0)), typeof e > "u"))
    return null;
  try {
    return e.activeElement || e.body;
  } catch {
    return e.body;
  }
}
function Jl(e, n) {
  var t = n.checked;
  return V({}, n, {
    defaultChecked: void 0,
    defaultValue: void 0,
    value: void 0,
    checked: t ?? e._wrapperState.initialChecked,
  });
}
function Au(e, n) {
  var t = n.defaultValue == null ? "" : n.defaultValue,
    r = n.checked != null ? n.checked : n.defaultChecked;
  (t = fn(n.value != null ? n.value : t)),
    (e._wrapperState = {
      initialChecked: r,
      initialValue: t,
      controlled:
        n.type === "checkbox" || n.type === "radio"
          ? n.checked != null
          : n.value != null,
    });
}
function as(e, n) {
  (n = n.checked), n != null && Qo(e, "checked", n, !1);
}
function ql(e, n) {
  as(e, n);
  var t = fn(n.value),
    r = n.type;
  if (t != null)
    r === "number"
      ? ((t === 0 && e.value === "") || e.value != t) && (e.value = "" + t)
      : e.value !== "" + t && (e.value = "" + t);
  else if (r === "submit" || r === "reset") {
    e.removeAttribute("value");
    return;
  }
  n.hasOwnProperty("value")
    ? bl(e, n.type, t)
    : n.hasOwnProperty("defaultValue") && bl(e, n.type, fn(n.defaultValue)),
    n.checked == null &&
      n.defaultChecked != null &&
      (e.defaultChecked = !!n.defaultChecked);
}
function Vu(e, n, t) {
  if (n.hasOwnProperty("value") || n.hasOwnProperty("defaultValue")) {
    var r = n.type;
    if (
      !(
        (r !== "submit" && r !== "reset") ||
        (n.value !== void 0 && n.value !== null)
      )
    )
      return;
    (n = "" + e._wrapperState.initialValue),
      t || n === e.value || (e.value = n),
      (e.defaultValue = n);
  }
  (t = e.name),
    t !== "" && (e.name = ""),
    (e.defaultChecked = !!e._wrapperState.initialChecked),
    t !== "" && (e.name = t);
}
function bl(e, n, t) {
  (n !== "number" || Tr(e.ownerDocument) !== e) &&
    (t == null
      ? (e.defaultValue = "" + e._wrapperState.initialValue)
      : e.defaultValue !== "" + t && (e.defaultValue = "" + t));
}
var gt = Array.isArray;
function Qn(e, n, t, r) {
  if (((e = e.options), n)) {
    n = {};
    for (var l = 0; l < t.length; l++) n["$" + t[l]] = !0;
    for (t = 0; t < e.length; t++)
      (l = n.hasOwnProperty("$" + e[t].value)),
        e[t].selected !== l && (e[t].selected = l),
        l && r && (e[t].defaultSelected = !0);
  } else {
    for (t = "" + fn(t), n = null, l = 0; l < e.length; l++) {
      if (e[l].value === t) {
        (e[l].selected = !0), r && (e[l].defaultSelected = !0);
        return;
      }
      n !== null || e[l].disabled || (n = e[l]);
    }
    n !== null && (n.selected = !0);
  }
}
function eo(e, n) {
  if (n.dangerouslySetInnerHTML != null) throw Error(y(91));
  return V({}, n, {
    value: void 0,
    defaultValue: void 0,
    children: "" + e._wrapperState.initialValue,
  });
}
function Bu(e, n) {
  var t = n.value;
  if (t == null) {
    if (((t = n.children), (n = n.defaultValue), t != null)) {
      if (n != null) throw Error(y(92));
      if (gt(t)) {
        if (1 < t.length) throw Error(y(93));
        t = t[0];
      }
      n = t;
    }
    n == null && (n = ""), (t = n);
  }
  e._wrapperState = { initialValue: fn(t) };
}
function cs(e, n) {
  var t = fn(n.value),
    r = fn(n.defaultValue);
  t != null &&
    ((t = "" + t),
    t !== e.value && (e.value = t),
    n.defaultValue == null && e.defaultValue !== t && (e.defaultValue = t)),
    r != null && (e.defaultValue = "" + r);
}
function Hu(e) {
  var n = e.textContent;
  n === e._wrapperState.initialValue && n !== "" && n !== null && (e.value = n);
}
function fs(e) {
  switch (e) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
function no(e, n) {
  return e == null || e === "http://www.w3.org/1999/xhtml"
    ? fs(n)
    : e === "http://www.w3.org/2000/svg" && n === "foreignObject"
    ? "http://www.w3.org/1999/xhtml"
    : e;
}
var lr,
  ds = (function (e) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction
      ? function (n, t, r, l) {
          MSApp.execUnsafeLocalFunction(function () {
            return e(n, t, r, l);
          });
        }
      : e;
  })(function (e, n) {
    if (e.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in e)
      e.innerHTML = n;
    else {
      for (
        lr = lr || document.createElement("div"),
          lr.innerHTML = "<svg>" + n.valueOf().toString() + "</svg>",
          n = lr.firstChild;
        e.firstChild;

      )
        e.removeChild(e.firstChild);
      for (; n.firstChild; ) e.appendChild(n.firstChild);
    }
  });
function jt(e, n) {
  if (n) {
    var t = e.firstChild;
    if (t && t === e.lastChild && t.nodeType === 3) {
      t.nodeValue = n;
      return;
    }
  }
  e.textContent = n;
}
var kt = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0,
  },
  Oc = ["Webkit", "ms", "Moz", "O"];
Object.keys(kt).forEach(function (e) {
  Oc.forEach(function (n) {
    (n = n + e.charAt(0).toUpperCase() + e.substring(1)), (kt[n] = kt[e]);
  });
});
function ps(e, n, t) {
  return n == null || typeof n == "boolean" || n === ""
    ? ""
    : t || typeof n != "number" || n === 0 || (kt.hasOwnProperty(e) && kt[e])
    ? ("" + n).trim()
    : n + "px";
}
function ms(e, n) {
  e = e.style;
  for (var t in n)
    if (n.hasOwnProperty(t)) {
      var r = t.indexOf("--") === 0,
        l = ps(t, n[t], r);
      t === "float" && (t = "cssFloat"), r ? e.setProperty(t, l) : (e[t] = l);
    }
}
var Dc = V(
  { menuitem: !0 },
  {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0,
  }
);
function to(e, n) {
  if (n) {
    if (Dc[e] && (n.children != null || n.dangerouslySetInnerHTML != null))
      throw Error(y(137, e));
    if (n.dangerouslySetInnerHTML != null) {
      if (n.children != null) throw Error(y(60));
      if (
        typeof n.dangerouslySetInnerHTML != "object" ||
        !("__html" in n.dangerouslySetInnerHTML)
      )
        throw Error(y(61));
    }
    if (n.style != null && typeof n.style != "object") throw Error(y(62));
  }
}
function ro(e, n) {
  if (e.indexOf("-") === -1) return typeof n.is == "string";
  switch (e) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return !1;
    default:
      return !0;
  }
}
var lo = null;
function Go(e) {
  return (
    (e = e.target || e.srcElement || window),
    e.correspondingUseElement && (e = e.correspondingUseElement),
    e.nodeType === 3 ? e.parentNode : e
  );
}
var oo = null,
  Kn = null,
  Yn = null;
function Wu(e) {
  if ((e = Jt(e))) {
    if (typeof oo != "function") throw Error(y(280));
    var n = e.stateNode;
    n && ((n = ol(n)), oo(e.stateNode, e.type, n));
  }
}
function hs(e) {
  Kn ? (Yn ? Yn.push(e) : (Yn = [e])) : (Kn = e);
}
function vs() {
  if (Kn) {
    var e = Kn,
      n = Yn;
    if (((Yn = Kn = null), Wu(e), n)) for (e = 0; e < n.length; e++) Wu(n[e]);
  }
}
function ys(e, n) {
  return e(n);
}
function gs() {}
var Cl = !1;
function ws(e, n, t) {
  if (Cl) return e(n, t);
  Cl = !0;
  try {
    return ys(e, n, t);
  } finally {
    (Cl = !1), (Kn !== null || Yn !== null) && (gs(), vs());
  }
}
function Mt(e, n) {
  var t = e.stateNode;
  if (t === null) return null;
  var r = ol(t);
  if (r === null) return null;
  t = r[n];
  e: switch (n) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (r = !r.disabled) ||
        ((e = e.type),
        (r = !(
          e === "button" ||
          e === "input" ||
          e === "select" ||
          e === "textarea"
        ))),
        (e = !r);
      break e;
    default:
      e = !1;
  }
  if (e) return null;
  if (t && typeof t != "function") throw Error(y(231, n, typeof t));
  return t;
}
var uo = !1;
if (We)
  try {
    var ct = {};
    Object.defineProperty(ct, "passive", {
      get: function () {
        uo = !0;
      },
    }),
      window.addEventListener("test", ct, ct),
      window.removeEventListener("test", ct, ct);
  } catch {
    uo = !1;
  }
function Ic(e, n, t, r, l, o, u, i, s) {
  var c = Array.prototype.slice.call(arguments, 3);
  try {
    n.apply(t, c);
  } catch (m) {
    this.onError(m);
  }
}
var Et = !1,
  Rr = null,
  jr = !1,
  io = null,
  Fc = {
    onError: function (e) {
      (Et = !0), (Rr = e);
    },
  };
function Uc(e, n, t, r, l, o, u, i, s) {
  (Et = !1), (Rr = null), Ic.apply(Fc, arguments);
}
function $c(e, n, t, r, l, o, u, i, s) {
  if ((Uc.apply(this, arguments), Et)) {
    if (Et) {
      var c = Rr;
      (Et = !1), (Rr = null);
    } else throw Error(y(198));
    jr || ((jr = !0), (io = c));
  }
}
function Rn(e) {
  var n = e,
    t = e;
  if (e.alternate) for (; n.return; ) n = n.return;
  else {
    e = n;
    do (n = e), n.flags & 4098 && (t = n.return), (e = n.return);
    while (e);
  }
  return n.tag === 3 ? t : null;
}
function Ss(e) {
  if (e.tag === 13) {
    var n = e.memoizedState;
    if (
      (n === null && ((e = e.alternate), e !== null && (n = e.memoizedState)),
      n !== null)
    )
      return n.dehydrated;
  }
  return null;
}
function Qu(e) {
  if (Rn(e) !== e) throw Error(y(188));
}
function Ac(e) {
  var n = e.alternate;
  if (!n) {
    if (((n = Rn(e)), n === null)) throw Error(y(188));
    return n !== e ? null : e;
  }
  for (var t = e, r = n; ; ) {
    var l = t.return;
    if (l === null) break;
    var o = l.alternate;
    if (o === null) {
      if (((r = l.return), r !== null)) {
        t = r;
        continue;
      }
      break;
    }
    if (l.child === o.child) {
      for (o = l.child; o; ) {
        if (o === t) return Qu(l), e;
        if (o === r) return Qu(l), n;
        o = o.sibling;
      }
      throw Error(y(188));
    }
    if (t.return !== r.return) (t = l), (r = o);
    else {
      for (var u = !1, i = l.child; i; ) {
        if (i === t) {
          (u = !0), (t = l), (r = o);
          break;
        }
        if (i === r) {
          (u = !0), (r = l), (t = o);
          break;
        }
        i = i.sibling;
      }
      if (!u) {
        for (i = o.child; i; ) {
          if (i === t) {
            (u = !0), (t = o), (r = l);
            break;
          }
          if (i === r) {
            (u = !0), (r = o), (t = l);
            break;
          }
          i = i.sibling;
        }
        if (!u) throw Error(y(189));
      }
    }
    if (t.alternate !== r) throw Error(y(190));
  }
  if (t.tag !== 3) throw Error(y(188));
  return t.stateNode.current === t ? e : n;
}
function ks(e) {
  return (e = Ac(e)), e !== null ? Es(e) : null;
}
function Es(e) {
  if (e.tag === 5 || e.tag === 6) return e;
  for (e = e.child; e !== null; ) {
    var n = Es(e);
    if (n !== null) return n;
    e = e.sibling;
  }
  return null;
}
var Cs = ye.unstable_scheduleCallback,
  Ku = ye.unstable_cancelCallback,
  Vc = ye.unstable_shouldYield,
  Bc = ye.unstable_requestPaint,
  Q = ye.unstable_now,
  Hc = ye.unstable_getCurrentPriorityLevel,
  Zo = ye.unstable_ImmediatePriority,
  xs = ye.unstable_UserBlockingPriority,
  Mr = ye.unstable_NormalPriority,
  Wc = ye.unstable_LowPriority,
  _s = ye.unstable_IdlePriority,
  nl = null,
  Fe = null;
function Qc(e) {
  if (Fe && typeof Fe.onCommitFiberRoot == "function")
    try {
      Fe.onCommitFiberRoot(nl, e, void 0, (e.current.flags & 128) === 128);
    } catch {}
}
var Re = Math.clz32 ? Math.clz32 : Xc,
  Kc = Math.log,
  Yc = Math.LN2;
function Xc(e) {
  return (e >>>= 0), e === 0 ? 32 : (31 - ((Kc(e) / Yc) | 0)) | 0;
}
var or = 64,
  ur = 4194304;
function wt(e) {
  switch (e & -e) {
    case 1:
      return 1;
    case 2:
      return 2;
    case 4:
      return 4;
    case 8:
      return 8;
    case 16:
      return 16;
    case 32:
      return 32;
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return e & 4194240;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return e & 130023424;
    case 134217728:
      return 134217728;
    case 268435456:
      return 268435456;
    case 536870912:
      return 536870912;
    case 1073741824:
      return 1073741824;
    default:
      return e;
  }
}
function Or(e, n) {
  var t = e.pendingLanes;
  if (t === 0) return 0;
  var r = 0,
    l = e.suspendedLanes,
    o = e.pingedLanes,
    u = t & 268435455;
  if (u !== 0) {
    var i = u & ~l;
    i !== 0 ? (r = wt(i)) : ((o &= u), o !== 0 && (r = wt(o)));
  } else (u = t & ~l), u !== 0 ? (r = wt(u)) : o !== 0 && (r = wt(o));
  if (r === 0) return 0;
  if (
    n !== 0 &&
    n !== r &&
    !(n & l) &&
    ((l = r & -r), (o = n & -n), l >= o || (l === 16 && (o & 4194240) !== 0))
  )
    return n;
  if ((r & 4 && (r |= t & 16), (n = e.entangledLanes), n !== 0))
    for (e = e.entanglements, n &= r; 0 < n; )
      (t = 31 - Re(n)), (l = 1 << t), (r |= e[t]), (n &= ~l);
  return r;
}
function Gc(e, n) {
  switch (e) {
    case 1:
    case 2:
    case 4:
      return n + 250;
    case 8:
    case 16:
    case 32:
    case 64:
    case 128:
    case 256:
    case 512:
    case 1024:
    case 2048:
    case 4096:
    case 8192:
    case 16384:
    case 32768:
    case 65536:
    case 131072:
    case 262144:
    case 524288:
    case 1048576:
    case 2097152:
      return n + 5e3;
    case 4194304:
    case 8388608:
    case 16777216:
    case 33554432:
    case 67108864:
      return -1;
    case 134217728:
    case 268435456:
    case 536870912:
    case 1073741824:
      return -1;
    default:
      return -1;
  }
}
function Zc(e, n) {
  for (
    var t = e.suspendedLanes,
      r = e.pingedLanes,
      l = e.expirationTimes,
      o = e.pendingLanes;
    0 < o;

  ) {
    var u = 31 - Re(o),
      i = 1 << u,
      s = l[u];
    s === -1
      ? (!(i & t) || i & r) && (l[u] = Gc(i, n))
      : s <= n && (e.expiredLanes |= i),
      (o &= ~i);
  }
}
function so(e) {
  return (
    (e = e.pendingLanes & -1073741825),
    e !== 0 ? e : e & 1073741824 ? 1073741824 : 0
  );
}
function Ns() {
  var e = or;
  return (or <<= 1), !(or & 4194240) && (or = 64), e;
}
function xl(e) {
  for (var n = [], t = 0; 31 > t; t++) n.push(e);
  return n;
}
function Gt(e, n, t) {
  (e.pendingLanes |= n),
    n !== 536870912 && ((e.suspendedLanes = 0), (e.pingedLanes = 0)),
    (e = e.eventTimes),
    (n = 31 - Re(n)),
    (e[n] = t);
}
function Jc(e, n) {
  var t = e.pendingLanes & ~n;
  (e.pendingLanes = n),
    (e.suspendedLanes = 0),
    (e.pingedLanes = 0),
    (e.expiredLanes &= n),
    (e.mutableReadLanes &= n),
    (e.entangledLanes &= n),
    (n = e.entanglements);
  var r = e.eventTimes;
  for (e = e.expirationTimes; 0 < t; ) {
    var l = 31 - Re(t),
      o = 1 << l;
    (n[l] = 0), (r[l] = -1), (e[l] = -1), (t &= ~o);
  }
}
function Jo(e, n) {
  var t = (e.entangledLanes |= n);
  for (e = e.entanglements; t; ) {
    var r = 31 - Re(t),
      l = 1 << r;
    (l & n) | (e[r] & n) && (e[r] |= n), (t &= ~l);
  }
}
var M = 0;
function Ps(e) {
  return (e &= -e), 1 < e ? (4 < e ? (e & 268435455 ? 16 : 536870912) : 4) : 1;
}
var zs,
  qo,
  Ls,
  Ts,
  Rs,
  ao = !1,
  ir = [],
  tn = null,
  rn = null,
  ln = null,
  Ot = new Map(),
  Dt = new Map(),
  qe = [],
  qc =
    "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(
      " "
    );
function Yu(e, n) {
  switch (e) {
    case "focusin":
    case "focusout":
      tn = null;
      break;
    case "dragenter":
    case "dragleave":
      rn = null;
      break;
    case "mouseover":
    case "mouseout":
      ln = null;
      break;
    case "pointerover":
    case "pointerout":
      Ot.delete(n.pointerId);
      break;
    case "gotpointercapture":
    case "lostpointercapture":
      Dt.delete(n.pointerId);
  }
}
function ft(e, n, t, r, l, o) {
  return e === null || e.nativeEvent !== o
    ? ((e = {
        blockedOn: n,
        domEventName: t,
        eventSystemFlags: r,
        nativeEvent: o,
        targetContainers: [l],
      }),
      n !== null && ((n = Jt(n)), n !== null && qo(n)),
      e)
    : ((e.eventSystemFlags |= r),
      (n = e.targetContainers),
      l !== null && n.indexOf(l) === -1 && n.push(l),
      e);
}
function bc(e, n, t, r, l) {
  switch (n) {
    case "focusin":
      return (tn = ft(tn, e, n, t, r, l)), !0;
    case "dragenter":
      return (rn = ft(rn, e, n, t, r, l)), !0;
    case "mouseover":
      return (ln = ft(ln, e, n, t, r, l)), !0;
    case "pointerover":
      var o = l.pointerId;
      return Ot.set(o, ft(Ot.get(o) || null, e, n, t, r, l)), !0;
    case "gotpointercapture":
      return (
        (o = l.pointerId), Dt.set(o, ft(Dt.get(o) || null, e, n, t, r, l)), !0
      );
  }
  return !1;
}
function js(e) {
  var n = Sn(e.target);
  if (n !== null) {
    var t = Rn(n);
    if (t !== null) {
      if (((n = t.tag), n === 13)) {
        if (((n = Ss(t)), n !== null)) {
          (e.blockedOn = n),
            Rs(e.priority, function () {
              Ls(t);
            });
          return;
        }
      } else if (n === 3 && t.stateNode.current.memoizedState.isDehydrated) {
        e.blockedOn = t.tag === 3 ? t.stateNode.containerInfo : null;
        return;
      }
    }
  }
  e.blockedOn = null;
}
function Sr(e) {
  if (e.blockedOn !== null) return !1;
  for (var n = e.targetContainers; 0 < n.length; ) {
    var t = co(e.domEventName, e.eventSystemFlags, n[0], e.nativeEvent);
    if (t === null) {
      t = e.nativeEvent;
      var r = new t.constructor(t.type, t);
      (lo = r), t.target.dispatchEvent(r), (lo = null);
    } else return (n = Jt(t)), n !== null && qo(n), (e.blockedOn = t), !1;
    n.shift();
  }
  return !0;
}
function Xu(e, n, t) {
  Sr(e) && t.delete(n);
}
function ef() {
  (ao = !1),
    tn !== null && Sr(tn) && (tn = null),
    rn !== null && Sr(rn) && (rn = null),
    ln !== null && Sr(ln) && (ln = null),
    Ot.forEach(Xu),
    Dt.forEach(Xu);
}
function dt(e, n) {
  e.blockedOn === n &&
    ((e.blockedOn = null),
    ao ||
      ((ao = !0),
      ye.unstable_scheduleCallback(ye.unstable_NormalPriority, ef)));
}
function It(e) {
  function n(l) {
    return dt(l, e);
  }
  if (0 < ir.length) {
    dt(ir[0], e);
    for (var t = 1; t < ir.length; t++) {
      var r = ir[t];
      r.blockedOn === e && (r.blockedOn = null);
    }
  }
  for (
    tn !== null && dt(tn, e),
      rn !== null && dt(rn, e),
      ln !== null && dt(ln, e),
      Ot.forEach(n),
      Dt.forEach(n),
      t = 0;
    t < qe.length;
    t++
  )
    (r = qe[t]), r.blockedOn === e && (r.blockedOn = null);
  for (; 0 < qe.length && ((t = qe[0]), t.blockedOn === null); )
    js(t), t.blockedOn === null && qe.shift();
}
var Xn = Xe.ReactCurrentBatchConfig,
  Dr = !0;
function nf(e, n, t, r) {
  var l = M,
    o = Xn.transition;
  Xn.transition = null;
  try {
    (M = 1), bo(e, n, t, r);
  } finally {
    (M = l), (Xn.transition = o);
  }
}
function tf(e, n, t, r) {
  var l = M,
    o = Xn.transition;
  Xn.transition = null;
  try {
    (M = 4), bo(e, n, t, r);
  } finally {
    (M = l), (Xn.transition = o);
  }
}
function bo(e, n, t, r) {
  if (Dr) {
    var l = co(e, n, t, r);
    if (l === null) Ol(e, n, r, Ir, t), Yu(e, r);
    else if (bc(l, e, n, t, r)) r.stopPropagation();
    else if ((Yu(e, r), n & 4 && -1 < qc.indexOf(e))) {
      for (; l !== null; ) {
        var o = Jt(l);
        if (
          (o !== null && zs(o),
          (o = co(e, n, t, r)),
          o === null && Ol(e, n, r, Ir, t),
          o === l)
        )
          break;
        l = o;
      }
      l !== null && r.stopPropagation();
    } else Ol(e, n, r, null, t);
  }
}
var Ir = null;
function co(e, n, t, r) {
  if (((Ir = null), (e = Go(r)), (e = Sn(e)), e !== null))
    if (((n = Rn(e)), n === null)) e = null;
    else if (((t = n.tag), t === 13)) {
      if (((e = Ss(n)), e !== null)) return e;
      e = null;
    } else if (t === 3) {
      if (n.stateNode.current.memoizedState.isDehydrated)
        return n.tag === 3 ? n.stateNode.containerInfo : null;
      e = null;
    } else n !== e && (e = null);
  return (Ir = e), null;
}
function Ms(e) {
  switch (e) {
    case "cancel":
    case "click":
    case "close":
    case "contextmenu":
    case "copy":
    case "cut":
    case "auxclick":
    case "dblclick":
    case "dragend":
    case "dragstart":
    case "drop":
    case "focusin":
    case "focusout":
    case "input":
    case "invalid":
    case "keydown":
    case "keypress":
    case "keyup":
    case "mousedown":
    case "mouseup":
    case "paste":
    case "pause":
    case "play":
    case "pointercancel":
    case "pointerdown":
    case "pointerup":
    case "ratechange":
    case "reset":
    case "resize":
    case "seeked":
    case "submit":
    case "touchcancel":
    case "touchend":
    case "touchstart":
    case "volumechange":
    case "change":
    case "selectionchange":
    case "textInput":
    case "compositionstart":
    case "compositionend":
    case "compositionupdate":
    case "beforeblur":
    case "afterblur":
    case "beforeinput":
    case "blur":
    case "fullscreenchange":
    case "focus":
    case "hashchange":
    case "popstate":
    case "select":
    case "selectstart":
      return 1;
    case "drag":
    case "dragenter":
    case "dragexit":
    case "dragleave":
    case "dragover":
    case "mousemove":
    case "mouseout":
    case "mouseover":
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "scroll":
    case "toggle":
    case "touchmove":
    case "wheel":
    case "mouseenter":
    case "mouseleave":
    case "pointerenter":
    case "pointerleave":
      return 4;
    case "message":
      switch (Hc()) {
        case Zo:
          return 1;
        case xs:
          return 4;
        case Mr:
        case Wc:
          return 16;
        case _s:
          return 536870912;
        default:
          return 16;
      }
    default:
      return 16;
  }
}
var en = null,
  eu = null,
  kr = null;
function Os() {
  if (kr) return kr;
  var e,
    n = eu,
    t = n.length,
    r,
    l = "value" in en ? en.value : en.textContent,
    o = l.length;
  for (e = 0; e < t && n[e] === l[e]; e++);
  var u = t - e;
  for (r = 1; r <= u && n[t - r] === l[o - r]; r++);
  return (kr = l.slice(e, 1 < r ? 1 - r : void 0));
}
function Er(e) {
  var n = e.keyCode;
  return (
    "charCode" in e
      ? ((e = e.charCode), e === 0 && n === 13 && (e = 13))
      : (e = n),
    e === 10 && (e = 13),
    32 <= e || e === 13 ? e : 0
  );
}
function sr() {
  return !0;
}
function Gu() {
  return !1;
}
function we(e) {
  function n(t, r, l, o, u) {
    (this._reactName = t),
      (this._targetInst = l),
      (this.type = r),
      (this.nativeEvent = o),
      (this.target = u),
      (this.currentTarget = null);
    for (var i in e)
      e.hasOwnProperty(i) && ((t = e[i]), (this[i] = t ? t(o) : o[i]));
    return (
      (this.isDefaultPrevented = (
        o.defaultPrevented != null ? o.defaultPrevented : o.returnValue === !1
      )
        ? sr
        : Gu),
      (this.isPropagationStopped = Gu),
      this
    );
  }
  return (
    V(n.prototype, {
      preventDefault: function () {
        this.defaultPrevented = !0;
        var t = this.nativeEvent;
        t &&
          (t.preventDefault
            ? t.preventDefault()
            : typeof t.returnValue != "unknown" && (t.returnValue = !1),
          (this.isDefaultPrevented = sr));
      },
      stopPropagation: function () {
        var t = this.nativeEvent;
        t &&
          (t.stopPropagation
            ? t.stopPropagation()
            : typeof t.cancelBubble != "unknown" && (t.cancelBubble = !0),
          (this.isPropagationStopped = sr));
      },
      persist: function () {},
      isPersistent: sr,
    }),
    n
  );
}
var ot = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function (e) {
      return e.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0,
  },
  nu = we(ot),
  Zt = V({}, ot, { view: 0, detail: 0 }),
  rf = we(Zt),
  _l,
  Nl,
  pt,
  tl = V({}, Zt, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: tu,
    button: 0,
    buttons: 0,
    relatedTarget: function (e) {
      return e.relatedTarget === void 0
        ? e.fromElement === e.srcElement
          ? e.toElement
          : e.fromElement
        : e.relatedTarget;
    },
    movementX: function (e) {
      return "movementX" in e
        ? e.movementX
        : (e !== pt &&
            (pt && e.type === "mousemove"
              ? ((_l = e.screenX - pt.screenX), (Nl = e.screenY - pt.screenY))
              : (Nl = _l = 0),
            (pt = e)),
          _l);
    },
    movementY: function (e) {
      return "movementY" in e ? e.movementY : Nl;
    },
  }),
  Zu = we(tl),
  lf = V({}, tl, { dataTransfer: 0 }),
  of = we(lf),
  uf = V({}, Zt, { relatedTarget: 0 }),
  Pl = we(uf),
  sf = V({}, ot, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }),
  af = we(sf),
  cf = V({}, ot, {
    clipboardData: function (e) {
      return "clipboardData" in e ? e.clipboardData : window.clipboardData;
    },
  }),
  ff = we(cf),
  df = V({}, ot, { data: 0 }),
  Ju = we(df),
  pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified",
  },
  mf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta",
  },
  hf = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey",
  };
function vf(e) {
  var n = this.nativeEvent;
  return n.getModifierState ? n.getModifierState(e) : (e = hf[e]) ? !!n[e] : !1;
}
function tu() {
  return vf;
}
var yf = V({}, Zt, {
    key: function (e) {
      if (e.key) {
        var n = pf[e.key] || e.key;
        if (n !== "Unidentified") return n;
      }
      return e.type === "keypress"
        ? ((e = Er(e)), e === 13 ? "Enter" : String.fromCharCode(e))
        : e.type === "keydown" || e.type === "keyup"
        ? mf[e.keyCode] || "Unidentified"
        : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: tu,
    charCode: function (e) {
      return e.type === "keypress" ? Er(e) : 0;
    },
    keyCode: function (e) {
      return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
    },
    which: function (e) {
      return e.type === "keypress"
        ? Er(e)
        : e.type === "keydown" || e.type === "keyup"
        ? e.keyCode
        : 0;
    },
  }),
  gf = we(yf),
  wf = V({}, tl, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0,
  }),
  qu = we(wf),
  Sf = V({}, Zt, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: tu,
  }),
  kf = we(Sf),
  Ef = V({}, ot, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }),
  Cf = we(Ef),
  xf = V({}, tl, {
    deltaX: function (e) {
      return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
    },
    deltaY: function (e) {
      return "deltaY" in e
        ? e.deltaY
        : "wheelDeltaY" in e
        ? -e.wheelDeltaY
        : "wheelDelta" in e
        ? -e.wheelDelta
        : 0;
    },
    deltaZ: 0,
    deltaMode: 0,
  }),
  _f = we(xf),
  Nf = [9, 13, 27, 32],
  ru = We && "CompositionEvent" in window,
  Ct = null;
We && "documentMode" in document && (Ct = document.documentMode);
var Pf = We && "TextEvent" in window && !Ct,
  Ds = We && (!ru || (Ct && 8 < Ct && 11 >= Ct)),
  bu = " ",
  ei = !1;
function Is(e, n) {
  switch (e) {
    case "keyup":
      return Nf.indexOf(n.keyCode) !== -1;
    case "keydown":
      return n.keyCode !== 229;
    case "keypress":
    case "mousedown":
    case "focusout":
      return !0;
    default:
      return !1;
  }
}
function Fs(e) {
  return (e = e.detail), typeof e == "object" && "data" in e ? e.data : null;
}
var Dn = !1;
function zf(e, n) {
  switch (e) {
    case "compositionend":
      return Fs(n);
    case "keypress":
      return n.which !== 32 ? null : ((ei = !0), bu);
    case "textInput":
      return (e = n.data), e === bu && ei ? null : e;
    default:
      return null;
  }
}
function Lf(e, n) {
  if (Dn)
    return e === "compositionend" || (!ru && Is(e, n))
      ? ((e = Os()), (kr = eu = en = null), (Dn = !1), e)
      : null;
  switch (e) {
    case "paste":
      return null;
    case "keypress":
      if (!(n.ctrlKey || n.altKey || n.metaKey) || (n.ctrlKey && n.altKey)) {
        if (n.char && 1 < n.char.length) return n.char;
        if (n.which) return String.fromCharCode(n.which);
      }
      return null;
    case "compositionend":
      return Ds && n.locale !== "ko" ? null : n.data;
    default:
      return null;
  }
}
var Tf = {
  color: !0,
  date: !0,
  datetime: !0,
  "datetime-local": !0,
  email: !0,
  month: !0,
  number: !0,
  password: !0,
  range: !0,
  search: !0,
  tel: !0,
  text: !0,
  time: !0,
  url: !0,
  week: !0,
};
function ni(e) {
  var n = e && e.nodeName && e.nodeName.toLowerCase();
  return n === "input" ? !!Tf[e.type] : n === "textarea";
}
function Us(e, n, t, r) {
  hs(r),
    (n = Fr(n, "onChange")),
    0 < n.length &&
      ((t = new nu("onChange", "change", null, t, r)),
      e.push({ event: t, listeners: n }));
}
var xt = null,
  Ft = null;
function Rf(e) {
  Gs(e, 0);
}
function rl(e) {
  var n = Un(e);
  if (ss(n)) return e;
}
function jf(e, n) {
  if (e === "change") return n;
}
var $s = !1;
if (We) {
  var zl;
  if (We) {
    var Ll = "oninput" in document;
    if (!Ll) {
      var ti = document.createElement("div");
      ti.setAttribute("oninput", "return;"),
        (Ll = typeof ti.oninput == "function");
    }
    zl = Ll;
  } else zl = !1;
  $s = zl && (!document.documentMode || 9 < document.documentMode);
}
function ri() {
  xt && (xt.detachEvent("onpropertychange", As), (Ft = xt = null));
}
function As(e) {
  if (e.propertyName === "value" && rl(Ft)) {
    var n = [];
    Us(n, Ft, e, Go(e)), ws(Rf, n);
  }
}
function Mf(e, n, t) {
  e === "focusin"
    ? (ri(), (xt = n), (Ft = t), xt.attachEvent("onpropertychange", As))
    : e === "focusout" && ri();
}
function Of(e) {
  if (e === "selectionchange" || e === "keyup" || e === "keydown")
    return rl(Ft);
}
function Df(e, n) {
  if (e === "click") return rl(n);
}
function If(e, n) {
  if (e === "input" || e === "change") return rl(n);
}
function Ff(e, n) {
  return (e === n && (e !== 0 || 1 / e === 1 / n)) || (e !== e && n !== n);
}
var Me = typeof Object.is == "function" ? Object.is : Ff;
function Ut(e, n) {
  if (Me(e, n)) return !0;
  if (typeof e != "object" || e === null || typeof n != "object" || n === null)
    return !1;
  var t = Object.keys(e),
    r = Object.keys(n);
  if (t.length !== r.length) return !1;
  for (r = 0; r < t.length; r++) {
    var l = t[r];
    if (!Kl.call(n, l) || !Me(e[l], n[l])) return !1;
  }
  return !0;
}
function li(e) {
  for (; e && e.firstChild; ) e = e.firstChild;
  return e;
}
function oi(e, n) {
  var t = li(e);
  e = 0;
  for (var r; t; ) {
    if (t.nodeType === 3) {
      if (((r = e + t.textContent.length), e <= n && r >= n))
        return { node: t, offset: n - e };
      e = r;
    }
    e: {
      for (; t; ) {
        if (t.nextSibling) {
          t = t.nextSibling;
          break e;
        }
        t = t.parentNode;
      }
      t = void 0;
    }
    t = li(t);
  }
}
function Vs(e, n) {
  return e && n
    ? e === n
      ? !0
      : e && e.nodeType === 3
      ? !1
      : n && n.nodeType === 3
      ? Vs(e, n.parentNode)
      : "contains" in e
      ? e.contains(n)
      : e.compareDocumentPosition
      ? !!(e.compareDocumentPosition(n) & 16)
      : !1
    : !1;
}
function Bs() {
  for (var e = window, n = Tr(); n instanceof e.HTMLIFrameElement; ) {
    try {
      var t = typeof n.contentWindow.location.href == "string";
    } catch {
      t = !1;
    }
    if (t) e = n.contentWindow;
    else break;
    n = Tr(e.document);
  }
  return n;
}
function lu(e) {
  var n = e && e.nodeName && e.nodeName.toLowerCase();
  return (
    n &&
    ((n === "input" &&
      (e.type === "text" ||
        e.type === "search" ||
        e.type === "tel" ||
        e.type === "url" ||
        e.type === "password")) ||
      n === "textarea" ||
      e.contentEditable === "true")
  );
}
function Uf(e) {
  var n = Bs(),
    t = e.focusedElem,
    r = e.selectionRange;
  if (
    n !== t &&
    t &&
    t.ownerDocument &&
    Vs(t.ownerDocument.documentElement, t)
  ) {
    if (r !== null && lu(t)) {
      if (
        ((n = r.start),
        (e = r.end),
        e === void 0 && (e = n),
        "selectionStart" in t)
      )
        (t.selectionStart = n), (t.selectionEnd = Math.min(e, t.value.length));
      else if (
        ((e = ((n = t.ownerDocument || document) && n.defaultView) || window),
        e.getSelection)
      ) {
        e = e.getSelection();
        var l = t.textContent.length,
          o = Math.min(r.start, l);
        (r = r.end === void 0 ? o : Math.min(r.end, l)),
          !e.extend && o > r && ((l = r), (r = o), (o = l)),
          (l = oi(t, o));
        var u = oi(t, r);
        l &&
          u &&
          (e.rangeCount !== 1 ||
            e.anchorNode !== l.node ||
            e.anchorOffset !== l.offset ||
            e.focusNode !== u.node ||
            e.focusOffset !== u.offset) &&
          ((n = n.createRange()),
          n.setStart(l.node, l.offset),
          e.removeAllRanges(),
          o > r
            ? (e.addRange(n), e.extend(u.node, u.offset))
            : (n.setEnd(u.node, u.offset), e.addRange(n)));
      }
    }
    for (n = [], e = t; (e = e.parentNode); )
      e.nodeType === 1 &&
        n.push({ element: e, left: e.scrollLeft, top: e.scrollTop });
    for (typeof t.focus == "function" && t.focus(), t = 0; t < n.length; t++)
      (e = n[t]),
        (e.element.scrollLeft = e.left),
        (e.element.scrollTop = e.top);
  }
}
var $f = We && "documentMode" in document && 11 >= document.documentMode,
  In = null,
  fo = null,
  _t = null,
  po = !1;
function ui(e, n, t) {
  var r = t.window === t ? t.document : t.nodeType === 9 ? t : t.ownerDocument;
  po ||
    In == null ||
    In !== Tr(r) ||
    ((r = In),
    "selectionStart" in r && lu(r)
      ? (r = { start: r.selectionStart, end: r.selectionEnd })
      : ((r = (
          (r.ownerDocument && r.ownerDocument.defaultView) ||
          window
        ).getSelection()),
        (r = {
          anchorNode: r.anchorNode,
          anchorOffset: r.anchorOffset,
          focusNode: r.focusNode,
          focusOffset: r.focusOffset,
        })),
    (_t && Ut(_t, r)) ||
      ((_t = r),
      (r = Fr(fo, "onSelect")),
      0 < r.length &&
        ((n = new nu("onSelect", "select", null, n, t)),
        e.push({ event: n, listeners: r }),
        (n.target = In))));
}
function ar(e, n) {
  var t = {};
  return (
    (t[e.toLowerCase()] = n.toLowerCase()),
    (t["Webkit" + e] = "webkit" + n),
    (t["Moz" + e] = "moz" + n),
    t
  );
}
var Fn = {
    animationend: ar("Animation", "AnimationEnd"),
    animationiteration: ar("Animation", "AnimationIteration"),
    animationstart: ar("Animation", "AnimationStart"),
    transitionend: ar("Transition", "TransitionEnd"),
  },
  Tl = {},
  Hs = {};
We &&
  ((Hs = document.createElement("div").style),
  "AnimationEvent" in window ||
    (delete Fn.animationend.animation,
    delete Fn.animationiteration.animation,
    delete Fn.animationstart.animation),
  "TransitionEvent" in window || delete Fn.transitionend.transition);
function ll(e) {
  if (Tl[e]) return Tl[e];
  if (!Fn[e]) return e;
  var n = Fn[e],
    t;
  for (t in n) if (n.hasOwnProperty(t) && t in Hs) return (Tl[e] = n[t]);
  return e;
}
var Ws = ll("animationend"),
  Qs = ll("animationiteration"),
  Ks = ll("animationstart"),
  Ys = ll("transitionend"),
  Xs = new Map(),
  ii =
    "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
      " "
    );
function pn(e, n) {
  Xs.set(e, n), Tn(n, [e]);
}
for (var Rl = 0; Rl < ii.length; Rl++) {
  var jl = ii[Rl],
    Af = jl.toLowerCase(),
    Vf = jl[0].toUpperCase() + jl.slice(1);
  pn(Af, "on" + Vf);
}
pn(Ws, "onAnimationEnd");
pn(Qs, "onAnimationIteration");
pn(Ks, "onAnimationStart");
pn("dblclick", "onDoubleClick");
pn("focusin", "onFocus");
pn("focusout", "onBlur");
pn(Ys, "onTransitionEnd");
Jn("onMouseEnter", ["mouseout", "mouseover"]);
Jn("onMouseLeave", ["mouseout", "mouseover"]);
Jn("onPointerEnter", ["pointerout", "pointerover"]);
Jn("onPointerLeave", ["pointerout", "pointerover"]);
Tn(
  "onChange",
  "change click focusin focusout input keydown keyup selectionchange".split(" ")
);
Tn(
  "onSelect",
  "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
    " "
  )
);
Tn("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
Tn(
  "onCompositionEnd",
  "compositionend focusout keydown keypress keyup mousedown".split(" ")
);
Tn(
  "onCompositionStart",
  "compositionstart focusout keydown keypress keyup mousedown".split(" ")
);
Tn(
  "onCompositionUpdate",
  "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
);
var St =
    "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
      " "
    ),
  Bf = new Set("cancel close invalid load scroll toggle".split(" ").concat(St));
function si(e, n, t) {
  var r = e.type || "unknown-event";
  (e.currentTarget = t), $c(r, n, void 0, e), (e.currentTarget = null);
}
function Gs(e, n) {
  n = (n & 4) !== 0;
  for (var t = 0; t < e.length; t++) {
    var r = e[t],
      l = r.event;
    r = r.listeners;
    e: {
      var o = void 0;
      if (n)
        for (var u = r.length - 1; 0 <= u; u--) {
          var i = r[u],
            s = i.instance,
            c = i.currentTarget;
          if (((i = i.listener), s !== o && l.isPropagationStopped())) break e;
          si(l, i, c), (o = s);
        }
      else
        for (u = 0; u < r.length; u++) {
          if (
            ((i = r[u]),
            (s = i.instance),
            (c = i.currentTarget),
            (i = i.listener),
            s !== o && l.isPropagationStopped())
          )
            break e;
          si(l, i, c), (o = s);
        }
    }
  }
  if (jr) throw ((e = io), (jr = !1), (io = null), e);
}
function I(e, n) {
  var t = n[go];
  t === void 0 && (t = n[go] = new Set());
  var r = e + "__bubble";
  t.has(r) || (Zs(n, e, 2, !1), t.add(r));
}
function Ml(e, n, t) {
  var r = 0;
  n && (r |= 4), Zs(t, e, r, n);
}
var cr = "_reactListening" + Math.random().toString(36).slice(2);
function $t(e) {
  if (!e[cr]) {
    (e[cr] = !0),
      rs.forEach(function (t) {
        t !== "selectionchange" && (Bf.has(t) || Ml(t, !1, e), Ml(t, !0, e));
      });
    var n = e.nodeType === 9 ? e : e.ownerDocument;
    n === null || n[cr] || ((n[cr] = !0), Ml("selectionchange", !1, n));
  }
}
function Zs(e, n, t, r) {
  switch (Ms(n)) {
    case 1:
      var l = nf;
      break;
    case 4:
      l = tf;
      break;
    default:
      l = bo;
  }
  (t = l.bind(null, n, t, e)),
    (l = void 0),
    !uo ||
      (n !== "touchstart" && n !== "touchmove" && n !== "wheel") ||
      (l = !0),
    r
      ? l !== void 0
        ? e.addEventListener(n, t, { capture: !0, passive: l })
        : e.addEventListener(n, t, !0)
      : l !== void 0
      ? e.addEventListener(n, t, { passive: l })
      : e.addEventListener(n, t, !1);
}
function Ol(e, n, t, r, l) {
  var o = r;
  if (!(n & 1) && !(n & 2) && r !== null)
    e: for (;;) {
      if (r === null) return;
      var u = r.tag;
      if (u === 3 || u === 4) {
        var i = r.stateNode.containerInfo;
        if (i === l || (i.nodeType === 8 && i.parentNode === l)) break;
        if (u === 4)
          for (u = r.return; u !== null; ) {
            var s = u.tag;
            if (
              (s === 3 || s === 4) &&
              ((s = u.stateNode.containerInfo),
              s === l || (s.nodeType === 8 && s.parentNode === l))
            )
              return;
            u = u.return;
          }
        for (; i !== null; ) {
          if (((u = Sn(i)), u === null)) return;
          if (((s = u.tag), s === 5 || s === 6)) {
            r = o = u;
            continue e;
          }
          i = i.parentNode;
        }
      }
      r = r.return;
    }
  ws(function () {
    var c = o,
      m = Go(t),
      h = [];
    e: {
      var p = Xs.get(e);
      if (p !== void 0) {
        var g = nu,
          w = e;
        switch (e) {
          case "keypress":
            if (Er(t) === 0) break e;
          case "keydown":
          case "keyup":
            g = gf;
            break;
          case "focusin":
            (w = "focus"), (g = Pl);
            break;
          case "focusout":
            (w = "blur"), (g = Pl);
            break;
          case "beforeblur":
          case "afterblur":
            g = Pl;
            break;
          case "click":
            if (t.button === 2) break e;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            g = Zu;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            g = of;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            g = kf;
            break;
          case Ws:
          case Qs:
          case Ks:
            g = af;
            break;
          case Ys:
            g = Cf;
            break;
          case "scroll":
            g = rf;
            break;
          case "wheel":
            g = _f;
            break;
          case "copy":
          case "cut":
          case "paste":
            g = ff;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            g = qu;
        }
        var S = (n & 4) !== 0,
          O = !S && e === "scroll",
          d = S ? (p !== null ? p + "Capture" : null) : p;
        S = [];
        for (var a = c, f; a !== null; ) {
          f = a;
          var v = f.stateNode;
          if (
            (f.tag === 5 &&
              v !== null &&
              ((f = v),
              d !== null && ((v = Mt(a, d)), v != null && S.push(At(a, v, f)))),
            O)
          )
            break;
          a = a.return;
        }
        0 < S.length &&
          ((p = new g(p, w, null, t, m)), h.push({ event: p, listeners: S }));
      }
    }
    if (!(n & 7)) {
      e: {
        if (
          ((p = e === "mouseover" || e === "pointerover"),
          (g = e === "mouseout" || e === "pointerout"),
          p &&
            t !== lo &&
            (w = t.relatedTarget || t.fromElement) &&
            (Sn(w) || w[Qe]))
        )
          break e;
        if (
          (g || p) &&
          ((p =
            m.window === m
              ? m
              : (p = m.ownerDocument)
              ? p.defaultView || p.parentWindow
              : window),
          g
            ? ((w = t.relatedTarget || t.toElement),
              (g = c),
              (w = w ? Sn(w) : null),
              w !== null &&
                ((O = Rn(w)), w !== O || (w.tag !== 5 && w.tag !== 6)) &&
                (w = null))
            : ((g = null), (w = c)),
          g !== w)
        ) {
          if (
            ((S = Zu),
            (v = "onMouseLeave"),
            (d = "onMouseEnter"),
            (a = "mouse"),
            (e === "pointerout" || e === "pointerover") &&
              ((S = qu),
              (v = "onPointerLeave"),
              (d = "onPointerEnter"),
              (a = "pointer")),
            (O = g == null ? p : Un(g)),
            (f = w == null ? p : Un(w)),
            (p = new S(v, a + "leave", g, t, m)),
            (p.target = O),
            (p.relatedTarget = f),
            (v = null),
            Sn(m) === c &&
              ((S = new S(d, a + "enter", w, t, m)),
              (S.target = f),
              (S.relatedTarget = O),
              (v = S)),
            (O = v),
            g && w)
          )
            n: {
              for (S = g, d = w, a = 0, f = S; f; f = jn(f)) a++;
              for (f = 0, v = d; v; v = jn(v)) f++;
              for (; 0 < a - f; ) (S = jn(S)), a--;
              for (; 0 < f - a; ) (d = jn(d)), f--;
              for (; a--; ) {
                if (S === d || (d !== null && S === d.alternate)) break n;
                (S = jn(S)), (d = jn(d));
              }
              S = null;
            }
          else S = null;
          g !== null && ai(h, p, g, S, !1),
            w !== null && O !== null && ai(h, O, w, S, !0);
        }
      }
      e: {
        if (
          ((p = c ? Un(c) : window),
          (g = p.nodeName && p.nodeName.toLowerCase()),
          g === "select" || (g === "input" && p.type === "file"))
        )
          var E = jf;
        else if (ni(p))
          if ($s) E = If;
          else {
            E = Of;
            var x = Mf;
          }
        else
          (g = p.nodeName) &&
            g.toLowerCase() === "input" &&
            (p.type === "checkbox" || p.type === "radio") &&
            (E = Df);
        if (E && (E = E(e, c))) {
          Us(h, E, t, m);
          break e;
        }
        x && x(e, p, c),
          e === "focusout" &&
            (x = p._wrapperState) &&
            x.controlled &&
            p.type === "number" &&
            bl(p, "number", p.value);
      }
      switch (((x = c ? Un(c) : window), e)) {
        case "focusin":
          (ni(x) || x.contentEditable === "true") &&
            ((In = x), (fo = c), (_t = null));
          break;
        case "focusout":
          _t = fo = In = null;
          break;
        case "mousedown":
          po = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          (po = !1), ui(h, t, m);
          break;
        case "selectionchange":
          if ($f) break;
        case "keydown":
        case "keyup":
          ui(h, t, m);
      }
      var _;
      if (ru)
        e: {
          switch (e) {
            case "compositionstart":
              var N = "onCompositionStart";
              break e;
            case "compositionend":
              N = "onCompositionEnd";
              break e;
            case "compositionupdate":
              N = "onCompositionUpdate";
              break e;
          }
          N = void 0;
        }
      else
        Dn
          ? Is(e, t) && (N = "onCompositionEnd")
          : e === "keydown" && t.keyCode === 229 && (N = "onCompositionStart");
      N &&
        (Ds &&
          t.locale !== "ko" &&
          (Dn || N !== "onCompositionStart"
            ? N === "onCompositionEnd" && Dn && (_ = Os())
            : ((en = m),
              (eu = "value" in en ? en.value : en.textContent),
              (Dn = !0))),
        (x = Fr(c, N)),
        0 < x.length &&
          ((N = new Ju(N, e, null, t, m)),
          h.push({ event: N, listeners: x }),
          _ ? (N.data = _) : ((_ = Fs(t)), _ !== null && (N.data = _)))),
        (_ = Pf ? zf(e, t) : Lf(e, t)) &&
          ((c = Fr(c, "onBeforeInput")),
          0 < c.length &&
            ((m = new Ju("onBeforeInput", "beforeinput", null, t, m)),
            h.push({ event: m, listeners: c }),
            (m.data = _)));
    }
    Gs(h, n);
  });
}
function At(e, n, t) {
  return { instance: e, listener: n, currentTarget: t };
}
function Fr(e, n) {
  for (var t = n + "Capture", r = []; e !== null; ) {
    var l = e,
      o = l.stateNode;
    l.tag === 5 &&
      o !== null &&
      ((l = o),
      (o = Mt(e, t)),
      o != null && r.unshift(At(e, o, l)),
      (o = Mt(e, n)),
      o != null && r.push(At(e, o, l))),
      (e = e.return);
  }
  return r;
}
function jn(e) {
  if (e === null) return null;
  do e = e.return;
  while (e && e.tag !== 5);
  return e || null;
}
function ai(e, n, t, r, l) {
  for (var o = n._reactName, u = []; t !== null && t !== r; ) {
    var i = t,
      s = i.alternate,
      c = i.stateNode;
    if (s !== null && s === r) break;
    i.tag === 5 &&
      c !== null &&
      ((i = c),
      l
        ? ((s = Mt(t, o)), s != null && u.unshift(At(t, s, i)))
        : l || ((s = Mt(t, o)), s != null && u.push(At(t, s, i)))),
      (t = t.return);
  }
  u.length !== 0 && e.push({ event: n, listeners: u });
}
var Hf = /\r\n?/g,
  Wf = /\u0000|\uFFFD/g;
function ci(e) {
  return (typeof e == "string" ? e : "" + e)
    .replace(
      Hf,
      `
`
    )
    .replace(Wf, "");
}
function fr(e, n, t) {
  if (((n = ci(n)), ci(e) !== n && t)) throw Error(y(425));
}
function Ur() {}
var mo = null,
  ho = null;
function vo(e, n) {
  return (
    e === "textarea" ||
    e === "noscript" ||
    typeof n.children == "string" ||
    typeof n.children == "number" ||
    (typeof n.dangerouslySetInnerHTML == "object" &&
      n.dangerouslySetInnerHTML !== null &&
      n.dangerouslySetInnerHTML.__html != null)
  );
}
var yo = typeof setTimeout == "function" ? setTimeout : void 0,
  Qf = typeof clearTimeout == "function" ? clearTimeout : void 0,
  fi = typeof Promise == "function" ? Promise : void 0,
  Kf =
    typeof queueMicrotask == "function"
      ? queueMicrotask
      : typeof fi < "u"
      ? function (e) {
          return fi.resolve(null).then(e).catch(Yf);
        }
      : yo;
function Yf(e) {
  setTimeout(function () {
    throw e;
  });
}
function Dl(e, n) {
  var t = n,
    r = 0;
  do {
    var l = t.nextSibling;
    if ((e.removeChild(t), l && l.nodeType === 8))
      if (((t = l.data), t === "/$")) {
        if (r === 0) {
          e.removeChild(l), It(n);
          return;
        }
        r--;
      } else (t !== "$" && t !== "$?" && t !== "$!") || r++;
    t = l;
  } while (t);
  It(n);
}
function on(e) {
  for (; e != null; e = e.nextSibling) {
    var n = e.nodeType;
    if (n === 1 || n === 3) break;
    if (n === 8) {
      if (((n = e.data), n === "$" || n === "$!" || n === "$?")) break;
      if (n === "/$") return null;
    }
  }
  return e;
}
function di(e) {
  e = e.previousSibling;
  for (var n = 0; e; ) {
    if (e.nodeType === 8) {
      var t = e.data;
      if (t === "$" || t === "$!" || t === "$?") {
        if (n === 0) return e;
        n--;
      } else t === "/$" && n++;
    }
    e = e.previousSibling;
  }
  return null;
}
var ut = Math.random().toString(36).slice(2),
  Ie = "__reactFiber$" + ut,
  Vt = "__reactProps$" + ut,
  Qe = "__reactContainer$" + ut,
  go = "__reactEvents$" + ut,
  Xf = "__reactListeners$" + ut,
  Gf = "__reactHandles$" + ut;
function Sn(e) {
  var n = e[Ie];
  if (n) return n;
  for (var t = e.parentNode; t; ) {
    if ((n = t[Qe] || t[Ie])) {
      if (
        ((t = n.alternate),
        n.child !== null || (t !== null && t.child !== null))
      )
        for (e = di(e); e !== null; ) {
          if ((t = e[Ie])) return t;
          e = di(e);
        }
      return n;
    }
    (e = t), (t = e.parentNode);
  }
  return null;
}
function Jt(e) {
  return (
    (e = e[Ie] || e[Qe]),
    !e || (e.tag !== 5 && e.tag !== 6 && e.tag !== 13 && e.tag !== 3) ? null : e
  );
}
function Un(e) {
  if (e.tag === 5 || e.tag === 6) return e.stateNode;
  throw Error(y(33));
}
function ol(e) {
  return e[Vt] || null;
}
var wo = [],
  $n = -1;
function mn(e) {
  return { current: e };
}
function F(e) {
  0 > $n || ((e.current = wo[$n]), (wo[$n] = null), $n--);
}
function D(e, n) {
  $n++, (wo[$n] = e.current), (e.current = n);
}
var dn = {},
  le = mn(dn),
  fe = mn(!1),
  _n = dn;
function qn(e, n) {
  var t = e.type.contextTypes;
  if (!t) return dn;
  var r = e.stateNode;
  if (r && r.__reactInternalMemoizedUnmaskedChildContext === n)
    return r.__reactInternalMemoizedMaskedChildContext;
  var l = {},
    o;
  for (o in t) l[o] = n[o];
  return (
    r &&
      ((e = e.stateNode),
      (e.__reactInternalMemoizedUnmaskedChildContext = n),
      (e.__reactInternalMemoizedMaskedChildContext = l)),
    l
  );
}
function de(e) {
  return (e = e.childContextTypes), e != null;
}
function $r() {
  F(fe), F(le);
}
function pi(e, n, t) {
  if (le.current !== dn) throw Error(y(168));
  D(le, n), D(fe, t);
}
function Js(e, n, t) {
  var r = e.stateNode;
  if (((n = n.childContextTypes), typeof r.getChildContext != "function"))
    return t;
  r = r.getChildContext();
  for (var l in r) if (!(l in n)) throw Error(y(108, jc(e) || "Unknown", l));
  return V({}, t, r);
}
function Ar(e) {
  return (
    (e =
      ((e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext) || dn),
    (_n = le.current),
    D(le, e),
    D(fe, fe.current),
    !0
  );
}
function mi(e, n, t) {
  var r = e.stateNode;
  if (!r) throw Error(y(169));
  t
    ? ((e = Js(e, n, _n)),
      (r.__reactInternalMemoizedMergedChildContext = e),
      F(fe),
      F(le),
      D(le, e))
    : F(fe),
    D(fe, t);
}
var Ae = null,
  ul = !1,
  Il = !1;
function qs(e) {
  Ae === null ? (Ae = [e]) : Ae.push(e);
}
function Zf(e) {
  (ul = !0), qs(e);
}
function hn() {
  if (!Il && Ae !== null) {
    Il = !0;
    var e = 0,
      n = M;
    try {
      var t = Ae;
      for (M = 1; e < t.length; e++) {
        var r = t[e];
        do r = r(!0);
        while (r !== null);
      }
      (Ae = null), (ul = !1);
    } catch (l) {
      throw (Ae !== null && (Ae = Ae.slice(e + 1)), Cs(Zo, hn), l);
    } finally {
      (M = n), (Il = !1);
    }
  }
  return null;
}
var An = [],
  Vn = 0,
  Vr = null,
  Br = 0,
  Se = [],
  ke = 0,
  Nn = null,
  Ve = 1,
  Be = "";
function gn(e, n) {
  (An[Vn++] = Br), (An[Vn++] = Vr), (Vr = e), (Br = n);
}
function bs(e, n, t) {
  (Se[ke++] = Ve), (Se[ke++] = Be), (Se[ke++] = Nn), (Nn = e);
  var r = Ve;
  e = Be;
  var l = 32 - Re(r) - 1;
  (r &= ~(1 << l)), (t += 1);
  var o = 32 - Re(n) + l;
  if (30 < o) {
    var u = l - (l % 5);
    (o = (r & ((1 << u) - 1)).toString(32)),
      (r >>= u),
      (l -= u),
      (Ve = (1 << (32 - Re(n) + l)) | (t << l) | r),
      (Be = o + e);
  } else (Ve = (1 << o) | (t << l) | r), (Be = e);
}
function ou(e) {
  e.return !== null && (gn(e, 1), bs(e, 1, 0));
}
function uu(e) {
  for (; e === Vr; )
    (Vr = An[--Vn]), (An[Vn] = null), (Br = An[--Vn]), (An[Vn] = null);
  for (; e === Nn; )
    (Nn = Se[--ke]),
      (Se[ke] = null),
      (Be = Se[--ke]),
      (Se[ke] = null),
      (Ve = Se[--ke]),
      (Se[ke] = null);
}
var ve = null,
  he = null,
  U = !1,
  Te = null;
function ea(e, n) {
  var t = Ee(5, null, null, 0);
  (t.elementType = "DELETED"),
    (t.stateNode = n),
    (t.return = e),
    (n = e.deletions),
    n === null ? ((e.deletions = [t]), (e.flags |= 16)) : n.push(t);
}
function hi(e, n) {
  switch (e.tag) {
    case 5:
      var t = e.type;
      return (
        (n =
          n.nodeType !== 1 || t.toLowerCase() !== n.nodeName.toLowerCase()
            ? null
            : n),
        n !== null
          ? ((e.stateNode = n), (ve = e), (he = on(n.firstChild)), !0)
          : !1
      );
    case 6:
      return (
        (n = e.pendingProps === "" || n.nodeType !== 3 ? null : n),
        n !== null ? ((e.stateNode = n), (ve = e), (he = null), !0) : !1
      );
    case 13:
      return (
        (n = n.nodeType !== 8 ? null : n),
        n !== null
          ? ((t = Nn !== null ? { id: Ve, overflow: Be } : null),
            (e.memoizedState = {
              dehydrated: n,
              treeContext: t,
              retryLane: 1073741824,
            }),
            (t = Ee(18, null, null, 0)),
            (t.stateNode = n),
            (t.return = e),
            (e.child = t),
            (ve = e),
            (he = null),
            !0)
          : !1
      );
    default:
      return !1;
  }
}
function So(e) {
  return (e.mode & 1) !== 0 && (e.flags & 128) === 0;
}
function ko(e) {
  if (U) {
    var n = he;
    if (n) {
      var t = n;
      if (!hi(e, n)) {
        if (So(e)) throw Error(y(418));
        n = on(t.nextSibling);
        var r = ve;
        n && hi(e, n)
          ? ea(r, t)
          : ((e.flags = (e.flags & -4097) | 2), (U = !1), (ve = e));
      }
    } else {
      if (So(e)) throw Error(y(418));
      (e.flags = (e.flags & -4097) | 2), (U = !1), (ve = e);
    }
  }
}
function vi(e) {
  for (e = e.return; e !== null && e.tag !== 5 && e.tag !== 3 && e.tag !== 13; )
    e = e.return;
  ve = e;
}
function dr(e) {
  if (e !== ve) return !1;
  if (!U) return vi(e), (U = !0), !1;
  var n;
  if (
    ((n = e.tag !== 3) &&
      !(n = e.tag !== 5) &&
      ((n = e.type),
      (n = n !== "head" && n !== "body" && !vo(e.type, e.memoizedProps))),
    n && (n = he))
  ) {
    if (So(e)) throw (na(), Error(y(418)));
    for (; n; ) ea(e, n), (n = on(n.nextSibling));
  }
  if ((vi(e), e.tag === 13)) {
    if (((e = e.memoizedState), (e = e !== null ? e.dehydrated : null), !e))
      throw Error(y(317));
    e: {
      for (e = e.nextSibling, n = 0; e; ) {
        if (e.nodeType === 8) {
          var t = e.data;
          if (t === "/$") {
            if (n === 0) {
              he = on(e.nextSibling);
              break e;
            }
            n--;
          } else (t !== "$" && t !== "$!" && t !== "$?") || n++;
        }
        e = e.nextSibling;
      }
      he = null;
    }
  } else he = ve ? on(e.stateNode.nextSibling) : null;
  return !0;
}
function na() {
  for (var e = he; e; ) e = on(e.nextSibling);
}
function bn() {
  (he = ve = null), (U = !1);
}
function iu(e) {
  Te === null ? (Te = [e]) : Te.push(e);
}
var Jf = Xe.ReactCurrentBatchConfig;
function mt(e, n, t) {
  if (
    ((e = t.ref), e !== null && typeof e != "function" && typeof e != "object")
  ) {
    if (t._owner) {
      if (((t = t._owner), t)) {
        if (t.tag !== 1) throw Error(y(309));
        var r = t.stateNode;
      }
      if (!r) throw Error(y(147, e));
      var l = r,
        o = "" + e;
      return n !== null &&
        n.ref !== null &&
        typeof n.ref == "function" &&
        n.ref._stringRef === o
        ? n.ref
        : ((n = function (u) {
            var i = l.refs;
            u === null ? delete i[o] : (i[o] = u);
          }),
          (n._stringRef = o),
          n);
    }
    if (typeof e != "string") throw Error(y(284));
    if (!t._owner) throw Error(y(290, e));
  }
  return e;
}
function pr(e, n) {
  throw (
    ((e = Object.prototype.toString.call(n)),
    Error(
      y(
        31,
        e === "[object Object]"
          ? "object with keys {" + Object.keys(n).join(", ") + "}"
          : e
      )
    ))
  );
}
function yi(e) {
  var n = e._init;
  return n(e._payload);
}
function ta(e) {
  function n(d, a) {
    if (e) {
      var f = d.deletions;
      f === null ? ((d.deletions = [a]), (d.flags |= 16)) : f.push(a);
    }
  }
  function t(d, a) {
    if (!e) return null;
    for (; a !== null; ) n(d, a), (a = a.sibling);
    return null;
  }
  function r(d, a) {
    for (d = new Map(); a !== null; )
      a.key !== null ? d.set(a.key, a) : d.set(a.index, a), (a = a.sibling);
    return d;
  }
  function l(d, a) {
    return (d = cn(d, a)), (d.index = 0), (d.sibling = null), d;
  }
  function o(d, a, f) {
    return (
      (d.index = f),
      e
        ? ((f = d.alternate),
          f !== null
            ? ((f = f.index), f < a ? ((d.flags |= 2), a) : f)
            : ((d.flags |= 2), a))
        : ((d.flags |= 1048576), a)
    );
  }
  function u(d) {
    return e && d.alternate === null && (d.flags |= 2), d;
  }
  function i(d, a, f, v) {
    return a === null || a.tag !== 6
      ? ((a = Hl(f, d.mode, v)), (a.return = d), a)
      : ((a = l(a, f)), (a.return = d), a);
  }
  function s(d, a, f, v) {
    var E = f.type;
    return E === On
      ? m(d, a, f.props.children, v, f.key)
      : a !== null &&
        (a.elementType === E ||
          (typeof E == "object" &&
            E !== null &&
            E.$$typeof === Ze &&
            yi(E) === a.type))
      ? ((v = l(a, f.props)), (v.ref = mt(d, a, f)), (v.return = d), v)
      : ((v = Lr(f.type, f.key, f.props, null, d.mode, v)),
        (v.ref = mt(d, a, f)),
        (v.return = d),
        v);
  }
  function c(d, a, f, v) {
    return a === null ||
      a.tag !== 4 ||
      a.stateNode.containerInfo !== f.containerInfo ||
      a.stateNode.implementation !== f.implementation
      ? ((a = Wl(f, d.mode, v)), (a.return = d), a)
      : ((a = l(a, f.children || [])), (a.return = d), a);
  }
  function m(d, a, f, v, E) {
    return a === null || a.tag !== 7
      ? ((a = xn(f, d.mode, v, E)), (a.return = d), a)
      : ((a = l(a, f)), (a.return = d), a);
  }
  function h(d, a, f) {
    if ((typeof a == "string" && a !== "") || typeof a == "number")
      return (a = Hl("" + a, d.mode, f)), (a.return = d), a;
    if (typeof a == "object" && a !== null) {
      switch (a.$$typeof) {
        case tr:
          return (
            (f = Lr(a.type, a.key, a.props, null, d.mode, f)),
            (f.ref = mt(d, null, a)),
            (f.return = d),
            f
          );
        case Mn:
          return (a = Wl(a, d.mode, f)), (a.return = d), a;
        case Ze:
          var v = a._init;
          return h(d, v(a._payload), f);
      }
      if (gt(a) || at(a))
        return (a = xn(a, d.mode, f, null)), (a.return = d), a;
      pr(d, a);
    }
    return null;
  }
  function p(d, a, f, v) {
    var E = a !== null ? a.key : null;
    if ((typeof f == "string" && f !== "") || typeof f == "number")
      return E !== null ? null : i(d, a, "" + f, v);
    if (typeof f == "object" && f !== null) {
      switch (f.$$typeof) {
        case tr:
          return f.key === E ? s(d, a, f, v) : null;
        case Mn:
          return f.key === E ? c(d, a, f, v) : null;
        case Ze:
          return (E = f._init), p(d, a, E(f._payload), v);
      }
      if (gt(f) || at(f)) return E !== null ? null : m(d, a, f, v, null);
      pr(d, f);
    }
    return null;
  }
  function g(d, a, f, v, E) {
    if ((typeof v == "string" && v !== "") || typeof v == "number")
      return (d = d.get(f) || null), i(a, d, "" + v, E);
    if (typeof v == "object" && v !== null) {
      switch (v.$$typeof) {
        case tr:
          return (d = d.get(v.key === null ? f : v.key) || null), s(a, d, v, E);
        case Mn:
          return (d = d.get(v.key === null ? f : v.key) || null), c(a, d, v, E);
        case Ze:
          var x = v._init;
          return g(d, a, f, x(v._payload), E);
      }
      if (gt(v) || at(v)) return (d = d.get(f) || null), m(a, d, v, E, null);
      pr(a, v);
    }
    return null;
  }
  function w(d, a, f, v) {
    for (
      var E = null, x = null, _ = a, N = (a = 0), H = null;
      _ !== null && N < f.length;
      N++
    ) {
      _.index > N ? ((H = _), (_ = null)) : (H = _.sibling);
      var T = p(d, _, f[N], v);
      if (T === null) {
        _ === null && (_ = H);
        break;
      }
      e && _ && T.alternate === null && n(d, _),
        (a = o(T, a, N)),
        x === null ? (E = T) : (x.sibling = T),
        (x = T),
        (_ = H);
    }
    if (N === f.length) return t(d, _), U && gn(d, N), E;
    if (_ === null) {
      for (; N < f.length; N++)
        (_ = h(d, f[N], v)),
          _ !== null &&
            ((a = o(_, a, N)), x === null ? (E = _) : (x.sibling = _), (x = _));
      return U && gn(d, N), E;
    }
    for (_ = r(d, _); N < f.length; N++)
      (H = g(_, d, N, f[N], v)),
        H !== null &&
          (e && H.alternate !== null && _.delete(H.key === null ? N : H.key),
          (a = o(H, a, N)),
          x === null ? (E = H) : (x.sibling = H),
          (x = H));
    return (
      e &&
        _.forEach(function (Ne) {
          return n(d, Ne);
        }),
      U && gn(d, N),
      E
    );
  }
  function S(d, a, f, v) {
    var E = at(f);
    if (typeof E != "function") throw Error(y(150));
    if (((f = E.call(f)), f == null)) throw Error(y(151));
    for (
      var x = (E = null), _ = a, N = (a = 0), H = null, T = f.next();
      _ !== null && !T.done;
      N++, T = f.next()
    ) {
      _.index > N ? ((H = _), (_ = null)) : (H = _.sibling);
      var Ne = p(d, _, T.value, v);
      if (Ne === null) {
        _ === null && (_ = H);
        break;
      }
      e && _ && Ne.alternate === null && n(d, _),
        (a = o(Ne, a, N)),
        x === null ? (E = Ne) : (x.sibling = Ne),
        (x = Ne),
        (_ = H);
    }
    if (T.done) return t(d, _), U && gn(d, N), E;
    if (_ === null) {
      for (; !T.done; N++, T = f.next())
        (T = h(d, T.value, v)),
          T !== null &&
            ((a = o(T, a, N)), x === null ? (E = T) : (x.sibling = T), (x = T));
      return U && gn(d, N), E;
    }
    for (_ = r(d, _); !T.done; N++, T = f.next())
      (T = g(_, d, N, T.value, v)),
        T !== null &&
          (e && T.alternate !== null && _.delete(T.key === null ? N : T.key),
          (a = o(T, a, N)),
          x === null ? (E = T) : (x.sibling = T),
          (x = T));
    return (
      e &&
        _.forEach(function (it) {
          return n(d, it);
        }),
      U && gn(d, N),
      E
    );
  }
  function O(d, a, f, v) {
    if (
      (typeof f == "object" &&
        f !== null &&
        f.type === On &&
        f.key === null &&
        (f = f.props.children),
      typeof f == "object" && f !== null)
    ) {
      switch (f.$$typeof) {
        case tr:
          e: {
            for (var E = f.key, x = a; x !== null; ) {
              if (x.key === E) {
                if (((E = f.type), E === On)) {
                  if (x.tag === 7) {
                    t(d, x.sibling),
                      (a = l(x, f.props.children)),
                      (a.return = d),
                      (d = a);
                    break e;
                  }
                } else if (
                  x.elementType === E ||
                  (typeof E == "object" &&
                    E !== null &&
                    E.$$typeof === Ze &&
                    yi(E) === x.type)
                ) {
                  t(d, x.sibling),
                    (a = l(x, f.props)),
                    (a.ref = mt(d, x, f)),
                    (a.return = d),
                    (d = a);
                  break e;
                }
                t(d, x);
                break;
              } else n(d, x);
              x = x.sibling;
            }
            f.type === On
              ? ((a = xn(f.props.children, d.mode, v, f.key)),
                (a.return = d),
                (d = a))
              : ((v = Lr(f.type, f.key, f.props, null, d.mode, v)),
                (v.ref = mt(d, a, f)),
                (v.return = d),
                (d = v));
          }
          return u(d);
        case Mn:
          e: {
            for (x = f.key; a !== null; ) {
              if (a.key === x)
                if (
                  a.tag === 4 &&
                  a.stateNode.containerInfo === f.containerInfo &&
                  a.stateNode.implementation === f.implementation
                ) {
                  t(d, a.sibling),
                    (a = l(a, f.children || [])),
                    (a.return = d),
                    (d = a);
                  break e;
                } else {
                  t(d, a);
                  break;
                }
              else n(d, a);
              a = a.sibling;
            }
            (a = Wl(f, d.mode, v)), (a.return = d), (d = a);
          }
          return u(d);
        case Ze:
          return (x = f._init), O(d, a, x(f._payload), v);
      }
      if (gt(f)) return w(d, a, f, v);
      if (at(f)) return S(d, a, f, v);
      pr(d, f);
    }
    return (typeof f == "string" && f !== "") || typeof f == "number"
      ? ((f = "" + f),
        a !== null && a.tag === 6
          ? (t(d, a.sibling), (a = l(a, f)), (a.return = d), (d = a))
          : (t(d, a), (a = Hl(f, d.mode, v)), (a.return = d), (d = a)),
        u(d))
      : t(d, a);
  }
  return O;
}
var et = ta(!0),
  ra = ta(!1),
  Hr = mn(null),
  Wr = null,
  Bn = null,
  su = null;
function au() {
  su = Bn = Wr = null;
}
function cu(e) {
  var n = Hr.current;
  F(Hr), (e._currentValue = n);
}
function Eo(e, n, t) {
  for (; e !== null; ) {
    var r = e.alternate;
    if (
      ((e.childLanes & n) !== n
        ? ((e.childLanes |= n), r !== null && (r.childLanes |= n))
        : r !== null && (r.childLanes & n) !== n && (r.childLanes |= n),
      e === t)
    )
      break;
    e = e.return;
  }
}
function Gn(e, n) {
  (Wr = e),
    (su = Bn = null),
    (e = e.dependencies),
    e !== null &&
      e.firstContext !== null &&
      (e.lanes & n && (ce = !0), (e.firstContext = null));
}
function xe(e) {
  var n = e._currentValue;
  if (su !== e)
    if (((e = { context: e, memoizedValue: n, next: null }), Bn === null)) {
      if (Wr === null) throw Error(y(308));
      (Bn = e), (Wr.dependencies = { lanes: 0, firstContext: e });
    } else Bn = Bn.next = e;
  return n;
}
var kn = null;
function fu(e) {
  kn === null ? (kn = [e]) : kn.push(e);
}
function la(e, n, t, r) {
  var l = n.interleaved;
  return (
    l === null ? ((t.next = t), fu(n)) : ((t.next = l.next), (l.next = t)),
    (n.interleaved = t),
    Ke(e, r)
  );
}
function Ke(e, n) {
  e.lanes |= n;
  var t = e.alternate;
  for (t !== null && (t.lanes |= n), t = e, e = e.return; e !== null; )
    (e.childLanes |= n),
      (t = e.alternate),
      t !== null && (t.childLanes |= n),
      (t = e),
      (e = e.return);
  return t.tag === 3 ? t.stateNode : null;
}
var Je = !1;
function du(e) {
  e.updateQueue = {
    baseState: e.memoizedState,
    firstBaseUpdate: null,
    lastBaseUpdate: null,
    shared: { pending: null, interleaved: null, lanes: 0 },
    effects: null,
  };
}
function oa(e, n) {
  (e = e.updateQueue),
    n.updateQueue === e &&
      (n.updateQueue = {
        baseState: e.baseState,
        firstBaseUpdate: e.firstBaseUpdate,
        lastBaseUpdate: e.lastBaseUpdate,
        shared: e.shared,
        effects: e.effects,
      });
}
function He(e, n) {
  return {
    eventTime: e,
    lane: n,
    tag: 0,
    payload: null,
    callback: null,
    next: null,
  };
}
function un(e, n, t) {
  var r = e.updateQueue;
  if (r === null) return null;
  if (((r = r.shared), R & 2)) {
    var l = r.pending;
    return (
      l === null ? (n.next = n) : ((n.next = l.next), (l.next = n)),
      (r.pending = n),
      Ke(e, t)
    );
  }
  return (
    (l = r.interleaved),
    l === null ? ((n.next = n), fu(r)) : ((n.next = l.next), (l.next = n)),
    (r.interleaved = n),
    Ke(e, t)
  );
}
function Cr(e, n, t) {
  if (
    ((n = n.updateQueue), n !== null && ((n = n.shared), (t & 4194240) !== 0))
  ) {
    var r = n.lanes;
    (r &= e.pendingLanes), (t |= r), (n.lanes = t), Jo(e, t);
  }
}
function gi(e, n) {
  var t = e.updateQueue,
    r = e.alternate;
  if (r !== null && ((r = r.updateQueue), t === r)) {
    var l = null,
      o = null;
    if (((t = t.firstBaseUpdate), t !== null)) {
      do {
        var u = {
          eventTime: t.eventTime,
          lane: t.lane,
          tag: t.tag,
          payload: t.payload,
          callback: t.callback,
          next: null,
        };
        o === null ? (l = o = u) : (o = o.next = u), (t = t.next);
      } while (t !== null);
      o === null ? (l = o = n) : (o = o.next = n);
    } else l = o = n;
    (t = {
      baseState: r.baseState,
      firstBaseUpdate: l,
      lastBaseUpdate: o,
      shared: r.shared,
      effects: r.effects,
    }),
      (e.updateQueue = t);
    return;
  }
  (e = t.lastBaseUpdate),
    e === null ? (t.firstBaseUpdate = n) : (e.next = n),
    (t.lastBaseUpdate = n);
}
function Qr(e, n, t, r) {
  var l = e.updateQueue;
  Je = !1;
  var o = l.firstBaseUpdate,
    u = l.lastBaseUpdate,
    i = l.shared.pending;
  if (i !== null) {
    l.shared.pending = null;
    var s = i,
      c = s.next;
    (s.next = null), u === null ? (o = c) : (u.next = c), (u = s);
    var m = e.alternate;
    m !== null &&
      ((m = m.updateQueue),
      (i = m.lastBaseUpdate),
      i !== u &&
        (i === null ? (m.firstBaseUpdate = c) : (i.next = c),
        (m.lastBaseUpdate = s)));
  }
  if (o !== null) {
    var h = l.baseState;
    (u = 0), (m = c = s = null), (i = o);
    do {
      var p = i.lane,
        g = i.eventTime;
      if ((r & p) === p) {
        m !== null &&
          (m = m.next =
            {
              eventTime: g,
              lane: 0,
              tag: i.tag,
              payload: i.payload,
              callback: i.callback,
              next: null,
            });
        e: {
          var w = e,
            S = i;
          switch (((p = n), (g = t), S.tag)) {
            case 1:
              if (((w = S.payload), typeof w == "function")) {
                h = w.call(g, h, p);
                break e;
              }
              h = w;
              break e;
            case 3:
              w.flags = (w.flags & -65537) | 128;
            case 0:
              if (
                ((w = S.payload),
                (p = typeof w == "function" ? w.call(g, h, p) : w),
                p == null)
              )
                break e;
              h = V({}, h, p);
              break e;
            case 2:
              Je = !0;
          }
        }
        i.callback !== null &&
          i.lane !== 0 &&
          ((e.flags |= 64),
          (p = l.effects),
          p === null ? (l.effects = [i]) : p.push(i));
      } else
        (g = {
          eventTime: g,
          lane: p,
          tag: i.tag,
          payload: i.payload,
          callback: i.callback,
          next: null,
        }),
          m === null ? ((c = m = g), (s = h)) : (m = m.next = g),
          (u |= p);
      if (((i = i.next), i === null)) {
        if (((i = l.shared.pending), i === null)) break;
        (p = i),
          (i = p.next),
          (p.next = null),
          (l.lastBaseUpdate = p),
          (l.shared.pending = null);
      }
    } while (!0);
    if (
      (m === null && (s = h),
      (l.baseState = s),
      (l.firstBaseUpdate = c),
      (l.lastBaseUpdate = m),
      (n = l.shared.interleaved),
      n !== null)
    ) {
      l = n;
      do (u |= l.lane), (l = l.next);
      while (l !== n);
    } else o === null && (l.shared.lanes = 0);
    (zn |= u), (e.lanes = u), (e.memoizedState = h);
  }
}
function wi(e, n, t) {
  if (((e = n.effects), (n.effects = null), e !== null))
    for (n = 0; n < e.length; n++) {
      var r = e[n],
        l = r.callback;
      if (l !== null) {
        if (((r.callback = null), (r = t), typeof l != "function"))
          throw Error(y(191, l));
        l.call(r);
      }
    }
}
var qt = {},
  Ue = mn(qt),
  Bt = mn(qt),
  Ht = mn(qt);
function En(e) {
  if (e === qt) throw Error(y(174));
  return e;
}
function pu(e, n) {
  switch ((D(Ht, n), D(Bt, e), D(Ue, qt), (e = n.nodeType), e)) {
    case 9:
    case 11:
      n = (n = n.documentElement) ? n.namespaceURI : no(null, "");
      break;
    default:
      (e = e === 8 ? n.parentNode : n),
        (n = e.namespaceURI || null),
        (e = e.tagName),
        (n = no(n, e));
  }
  F(Ue), D(Ue, n);
}
function nt() {
  F(Ue), F(Bt), F(Ht);
}
function ua(e) {
  En(Ht.current);
  var n = En(Ue.current),
    t = no(n, e.type);
  n !== t && (D(Bt, e), D(Ue, t));
}
function mu(e) {
  Bt.current === e && (F(Ue), F(Bt));
}
var $ = mn(0);
function Kr(e) {
  for (var n = e; n !== null; ) {
    if (n.tag === 13) {
      var t = n.memoizedState;
      if (
        t !== null &&
        ((t = t.dehydrated), t === null || t.data === "$?" || t.data === "$!")
      )
        return n;
    } else if (n.tag === 19 && n.memoizedProps.revealOrder !== void 0) {
      if (n.flags & 128) return n;
    } else if (n.child !== null) {
      (n.child.return = n), (n = n.child);
      continue;
    }
    if (n === e) break;
    for (; n.sibling === null; ) {
      if (n.return === null || n.return === e) return null;
      n = n.return;
    }
    (n.sibling.return = n.return), (n = n.sibling);
  }
  return null;
}
var Fl = [];
function hu() {
  for (var e = 0; e < Fl.length; e++)
    Fl[e]._workInProgressVersionPrimary = null;
  Fl.length = 0;
}
var xr = Xe.ReactCurrentDispatcher,
  Ul = Xe.ReactCurrentBatchConfig,
  Pn = 0,
  A = null,
  Y = null,
  Z = null,
  Yr = !1,
  Nt = !1,
  Wt = 0,
  qf = 0;
function ne() {
  throw Error(y(321));
}
function vu(e, n) {
  if (n === null) return !1;
  for (var t = 0; t < n.length && t < e.length; t++)
    if (!Me(e[t], n[t])) return !1;
  return !0;
}
function yu(e, n, t, r, l, o) {
  if (
    ((Pn = o),
    (A = n),
    (n.memoizedState = null),
    (n.updateQueue = null),
    (n.lanes = 0),
    (xr.current = e === null || e.memoizedState === null ? td : rd),
    (e = t(r, l)),
    Nt)
  ) {
    o = 0;
    do {
      if (((Nt = !1), (Wt = 0), 25 <= o)) throw Error(y(301));
      (o += 1),
        (Z = Y = null),
        (n.updateQueue = null),
        (xr.current = ld),
        (e = t(r, l));
    } while (Nt);
  }
  if (
    ((xr.current = Xr),
    (n = Y !== null && Y.next !== null),
    (Pn = 0),
    (Z = Y = A = null),
    (Yr = !1),
    n)
  )
    throw Error(y(300));
  return e;
}
function gu() {
  var e = Wt !== 0;
  return (Wt = 0), e;
}
function De() {
  var e = {
    memoizedState: null,
    baseState: null,
    baseQueue: null,
    queue: null,
    next: null,
  };
  return Z === null ? (A.memoizedState = Z = e) : (Z = Z.next = e), Z;
}
function _e() {
  if (Y === null) {
    var e = A.alternate;
    e = e !== null ? e.memoizedState : null;
  } else e = Y.next;
  var n = Z === null ? A.memoizedState : Z.next;
  if (n !== null) (Z = n), (Y = e);
  else {
    if (e === null) throw Error(y(310));
    (Y = e),
      (e = {
        memoizedState: Y.memoizedState,
        baseState: Y.baseState,
        baseQueue: Y.baseQueue,
        queue: Y.queue,
        next: null,
      }),
      Z === null ? (A.memoizedState = Z = e) : (Z = Z.next = e);
  }
  return Z;
}
function Qt(e, n) {
  return typeof n == "function" ? n(e) : n;
}
function $l(e) {
  var n = _e(),
    t = n.queue;
  if (t === null) throw Error(y(311));
  t.lastRenderedReducer = e;
  var r = Y,
    l = r.baseQueue,
    o = t.pending;
  if (o !== null) {
    if (l !== null) {
      var u = l.next;
      (l.next = o.next), (o.next = u);
    }
    (r.baseQueue = l = o), (t.pending = null);
  }
  if (l !== null) {
    (o = l.next), (r = r.baseState);
    var i = (u = null),
      s = null,
      c = o;
    do {
      var m = c.lane;
      if ((Pn & m) === m)
        s !== null &&
          (s = s.next =
            {
              lane: 0,
              action: c.action,
              hasEagerState: c.hasEagerState,
              eagerState: c.eagerState,
              next: null,
            }),
          (r = c.hasEagerState ? c.eagerState : e(r, c.action));
      else {
        var h = {
          lane: m,
          action: c.action,
          hasEagerState: c.hasEagerState,
          eagerState: c.eagerState,
          next: null,
        };
        s === null ? ((i = s = h), (u = r)) : (s = s.next = h),
          (A.lanes |= m),
          (zn |= m);
      }
      c = c.next;
    } while (c !== null && c !== o);
    s === null ? (u = r) : (s.next = i),
      Me(r, n.memoizedState) || (ce = !0),
      (n.memoizedState = r),
      (n.baseState = u),
      (n.baseQueue = s),
      (t.lastRenderedState = r);
  }
  if (((e = t.interleaved), e !== null)) {
    l = e;
    do (o = l.lane), (A.lanes |= o), (zn |= o), (l = l.next);
    while (l !== e);
  } else l === null && (t.lanes = 0);
  return [n.memoizedState, t.dispatch];
}
function Al(e) {
  var n = _e(),
    t = n.queue;
  if (t === null) throw Error(y(311));
  t.lastRenderedReducer = e;
  var r = t.dispatch,
    l = t.pending,
    o = n.memoizedState;
  if (l !== null) {
    t.pending = null;
    var u = (l = l.next);
    do (o = e(o, u.action)), (u = u.next);
    while (u !== l);
    Me(o, n.memoizedState) || (ce = !0),
      (n.memoizedState = o),
      n.baseQueue === null && (n.baseState = o),
      (t.lastRenderedState = o);
  }
  return [o, r];
}
function ia() {}
function sa(e, n) {
  var t = A,
    r = _e(),
    l = n(),
    o = !Me(r.memoizedState, l);
  if (
    (o && ((r.memoizedState = l), (ce = !0)),
    (r = r.queue),
    wu(fa.bind(null, t, r, e), [e]),
    r.getSnapshot !== n || o || (Z !== null && Z.memoizedState.tag & 1))
  ) {
    if (
      ((t.flags |= 2048),
      Kt(9, ca.bind(null, t, r, l, n), void 0, null),
      J === null)
    )
      throw Error(y(349));
    Pn & 30 || aa(t, n, l);
  }
  return l;
}
function aa(e, n, t) {
  (e.flags |= 16384),
    (e = { getSnapshot: n, value: t }),
    (n = A.updateQueue),
    n === null
      ? ((n = { lastEffect: null, stores: null }),
        (A.updateQueue = n),
        (n.stores = [e]))
      : ((t = n.stores), t === null ? (n.stores = [e]) : t.push(e));
}
function ca(e, n, t, r) {
  (n.value = t), (n.getSnapshot = r), da(n) && pa(e);
}
function fa(e, n, t) {
  return t(function () {
    da(n) && pa(e);
  });
}
function da(e) {
  var n = e.getSnapshot;
  e = e.value;
  try {
    var t = n();
    return !Me(e, t);
  } catch {
    return !0;
  }
}
function pa(e) {
  var n = Ke(e, 1);
  n !== null && je(n, e, 1, -1);
}
function Si(e) {
  var n = De();
  return (
    typeof e == "function" && (e = e()),
    (n.memoizedState = n.baseState = e),
    (e = {
      pending: null,
      interleaved: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Qt,
      lastRenderedState: e,
    }),
    (n.queue = e),
    (e = e.dispatch = nd.bind(null, A, e)),
    [n.memoizedState, e]
  );
}
function Kt(e, n, t, r) {
  return (
    (e = { tag: e, create: n, destroy: t, deps: r, next: null }),
    (n = A.updateQueue),
    n === null
      ? ((n = { lastEffect: null, stores: null }),
        (A.updateQueue = n),
        (n.lastEffect = e.next = e))
      : ((t = n.lastEffect),
        t === null
          ? (n.lastEffect = e.next = e)
          : ((r = t.next), (t.next = e), (e.next = r), (n.lastEffect = e))),
    e
  );
}
function ma() {
  return _e().memoizedState;
}
function _r(e, n, t, r) {
  var l = De();
  (A.flags |= e),
    (l.memoizedState = Kt(1 | n, t, void 0, r === void 0 ? null : r));
}
function il(e, n, t, r) {
  var l = _e();
  r = r === void 0 ? null : r;
  var o = void 0;
  if (Y !== null) {
    var u = Y.memoizedState;
    if (((o = u.destroy), r !== null && vu(r, u.deps))) {
      l.memoizedState = Kt(n, t, o, r);
      return;
    }
  }
  (A.flags |= e), (l.memoizedState = Kt(1 | n, t, o, r));
}
function ki(e, n) {
  return _r(8390656, 8, e, n);
}
function wu(e, n) {
  return il(2048, 8, e, n);
}
function ha(e, n) {
  return il(4, 2, e, n);
}
function va(e, n) {
  return il(4, 4, e, n);
}
function ya(e, n) {
  if (typeof n == "function")
    return (
      (e = e()),
      n(e),
      function () {
        n(null);
      }
    );
  if (n != null)
    return (
      (e = e()),
      (n.current = e),
      function () {
        n.current = null;
      }
    );
}
function ga(e, n, t) {
  return (
    (t = t != null ? t.concat([e]) : null), il(4, 4, ya.bind(null, n, e), t)
  );
}
function Su() {}
function wa(e, n) {
  var t = _e();
  n = n === void 0 ? null : n;
  var r = t.memoizedState;
  return r !== null && n !== null && vu(n, r[1])
    ? r[0]
    : ((t.memoizedState = [e, n]), e);
}
function Sa(e, n) {
  var t = _e();
  n = n === void 0 ? null : n;
  var r = t.memoizedState;
  return r !== null && n !== null && vu(n, r[1])
    ? r[0]
    : ((e = e()), (t.memoizedState = [e, n]), e);
}
function ka(e, n, t) {
  return Pn & 21
    ? (Me(t, n) || ((t = Ns()), (A.lanes |= t), (zn |= t), (e.baseState = !0)),
      n)
    : (e.baseState && ((e.baseState = !1), (ce = !0)), (e.memoizedState = t));
}
function bf(e, n) {
  var t = M;
  (M = t !== 0 && 4 > t ? t : 4), e(!0);
  var r = Ul.transition;
  Ul.transition = {};
  try {
    e(!1), n();
  } finally {
    (M = t), (Ul.transition = r);
  }
}
function Ea() {
  return _e().memoizedState;
}
function ed(e, n, t) {
  var r = an(e);
  if (
    ((t = {
      lane: r,
      action: t,
      hasEagerState: !1,
      eagerState: null,
      next: null,
    }),
    Ca(e))
  )
    xa(n, t);
  else if (((t = la(e, n, t, r)), t !== null)) {
    var l = ue();
    je(t, e, r, l), _a(t, n, r);
  }
}
function nd(e, n, t) {
  var r = an(e),
    l = { lane: r, action: t, hasEagerState: !1, eagerState: null, next: null };
  if (Ca(e)) xa(n, l);
  else {
    var o = e.alternate;
    if (
      e.lanes === 0 &&
      (o === null || o.lanes === 0) &&
      ((o = n.lastRenderedReducer), o !== null)
    )
      try {
        var u = n.lastRenderedState,
          i = o(u, t);
        if (((l.hasEagerState = !0), (l.eagerState = i), Me(i, u))) {
          var s = n.interleaved;
          s === null
            ? ((l.next = l), fu(n))
            : ((l.next = s.next), (s.next = l)),
            (n.interleaved = l);
          return;
        }
      } catch {
      } finally {
      }
    (t = la(e, n, l, r)),
      t !== null && ((l = ue()), je(t, e, r, l), _a(t, n, r));
  }
}
function Ca(e) {
  var n = e.alternate;
  return e === A || (n !== null && n === A);
}
function xa(e, n) {
  Nt = Yr = !0;
  var t = e.pending;
  t === null ? (n.next = n) : ((n.next = t.next), (t.next = n)),
    (e.pending = n);
}
function _a(e, n, t) {
  if (t & 4194240) {
    var r = n.lanes;
    (r &= e.pendingLanes), (t |= r), (n.lanes = t), Jo(e, t);
  }
}
var Xr = {
    readContext: xe,
    useCallback: ne,
    useContext: ne,
    useEffect: ne,
    useImperativeHandle: ne,
    useInsertionEffect: ne,
    useLayoutEffect: ne,
    useMemo: ne,
    useReducer: ne,
    useRef: ne,
    useState: ne,
    useDebugValue: ne,
    useDeferredValue: ne,
    useTransition: ne,
    useMutableSource: ne,
    useSyncExternalStore: ne,
    useId: ne,
    unstable_isNewReconciler: !1,
  },
  td = {
    readContext: xe,
    useCallback: function (e, n) {
      return (De().memoizedState = [e, n === void 0 ? null : n]), e;
    },
    useContext: xe,
    useEffect: ki,
    useImperativeHandle: function (e, n, t) {
      return (
        (t = t != null ? t.concat([e]) : null),
        _r(4194308, 4, ya.bind(null, n, e), t)
      );
    },
    useLayoutEffect: function (e, n) {
      return _r(4194308, 4, e, n);
    },
    useInsertionEffect: function (e, n) {
      return _r(4, 2, e, n);
    },
    useMemo: function (e, n) {
      var t = De();
      return (
        (n = n === void 0 ? null : n), (e = e()), (t.memoizedState = [e, n]), e
      );
    },
    useReducer: function (e, n, t) {
      var r = De();
      return (
        (n = t !== void 0 ? t(n) : n),
        (r.memoizedState = r.baseState = n),
        (e = {
          pending: null,
          interleaved: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: e,
          lastRenderedState: n,
        }),
        (r.queue = e),
        (e = e.dispatch = ed.bind(null, A, e)),
        [r.memoizedState, e]
      );
    },
    useRef: function (e) {
      var n = De();
      return (e = { current: e }), (n.memoizedState = e);
    },
    useState: Si,
    useDebugValue: Su,
    useDeferredValue: function (e) {
      return (De().memoizedState = e);
    },
    useTransition: function () {
      var e = Si(!1),
        n = e[0];
      return (e = bf.bind(null, e[1])), (De().memoizedState = e), [n, e];
    },
    useMutableSource: function () {},
    useSyncExternalStore: function (e, n, t) {
      var r = A,
        l = De();
      if (U) {
        if (t === void 0) throw Error(y(407));
        t = t();
      } else {
        if (((t = n()), J === null)) throw Error(y(349));
        Pn & 30 || aa(r, n, t);
      }
      l.memoizedState = t;
      var o = { value: t, getSnapshot: n };
      return (
        (l.queue = o),
        ki(fa.bind(null, r, o, e), [e]),
        (r.flags |= 2048),
        Kt(9, ca.bind(null, r, o, t, n), void 0, null),
        t
      );
    },
    useId: function () {
      var e = De(),
        n = J.identifierPrefix;
      if (U) {
        var t = Be,
          r = Ve;
        (t = (r & ~(1 << (32 - Re(r) - 1))).toString(32) + t),
          (n = ":" + n + "R" + t),
          (t = Wt++),
          0 < t && (n += "H" + t.toString(32)),
          (n += ":");
      } else (t = qf++), (n = ":" + n + "r" + t.toString(32) + ":");
      return (e.memoizedState = n);
    },
    unstable_isNewReconciler: !1,
  },
  rd = {
    readContext: xe,
    useCallback: wa,
    useContext: xe,
    useEffect: wu,
    useImperativeHandle: ga,
    useInsertionEffect: ha,
    useLayoutEffect: va,
    useMemo: Sa,
    useReducer: $l,
    useRef: ma,
    useState: function () {
      return $l(Qt);
    },
    useDebugValue: Su,
    useDeferredValue: function (e) {
      var n = _e();
      return ka(n, Y.memoizedState, e);
    },
    useTransition: function () {
      var e = $l(Qt)[0],
        n = _e().memoizedState;
      return [e, n];
    },
    useMutableSource: ia,
    useSyncExternalStore: sa,
    useId: Ea,
    unstable_isNewReconciler: !1,
  },
  ld = {
    readContext: xe,
    useCallback: wa,
    useContext: xe,
    useEffect: wu,
    useImperativeHandle: ga,
    useInsertionEffect: ha,
    useLayoutEffect: va,
    useMemo: Sa,
    useReducer: Al,
    useRef: ma,
    useState: function () {
      return Al(Qt);
    },
    useDebugValue: Su,
    useDeferredValue: function (e) {
      var n = _e();
      return Y === null ? (n.memoizedState = e) : ka(n, Y.memoizedState, e);
    },
    useTransition: function () {
      var e = Al(Qt)[0],
        n = _e().memoizedState;
      return [e, n];
    },
    useMutableSource: ia,
    useSyncExternalStore: sa,
    useId: Ea,
    unstable_isNewReconciler: !1,
  };
function ze(e, n) {
  if (e && e.defaultProps) {
    (n = V({}, n)), (e = e.defaultProps);
    for (var t in e) n[t] === void 0 && (n[t] = e[t]);
    return n;
  }
  return n;
}
function Co(e, n, t, r) {
  (n = e.memoizedState),
    (t = t(r, n)),
    (t = t == null ? n : V({}, n, t)),
    (e.memoizedState = t),
    e.lanes === 0 && (e.updateQueue.baseState = t);
}
var sl = {
  isMounted: function (e) {
    return (e = e._reactInternals) ? Rn(e) === e : !1;
  },
  enqueueSetState: function (e, n, t) {
    e = e._reactInternals;
    var r = ue(),
      l = an(e),
      o = He(r, l);
    (o.payload = n),
      t != null && (o.callback = t),
      (n = un(e, o, l)),
      n !== null && (je(n, e, l, r), Cr(n, e, l));
  },
  enqueueReplaceState: function (e, n, t) {
    e = e._reactInternals;
    var r = ue(),
      l = an(e),
      o = He(r, l);
    (o.tag = 1),
      (o.payload = n),
      t != null && (o.callback = t),
      (n = un(e, o, l)),
      n !== null && (je(n, e, l, r), Cr(n, e, l));
  },
  enqueueForceUpdate: function (e, n) {
    e = e._reactInternals;
    var t = ue(),
      r = an(e),
      l = He(t, r);
    (l.tag = 2),
      n != null && (l.callback = n),
      (n = un(e, l, r)),
      n !== null && (je(n, e, r, t), Cr(n, e, r));
  },
};
function Ei(e, n, t, r, l, o, u) {
  return (
    (e = e.stateNode),
    typeof e.shouldComponentUpdate == "function"
      ? e.shouldComponentUpdate(r, o, u)
      : n.prototype && n.prototype.isPureReactComponent
      ? !Ut(t, r) || !Ut(l, o)
      : !0
  );
}
function Na(e, n, t) {
  var r = !1,
    l = dn,
    o = n.contextType;
  return (
    typeof o == "object" && o !== null
      ? (o = xe(o))
      : ((l = de(n) ? _n : le.current),
        (r = n.contextTypes),
        (o = (r = r != null) ? qn(e, l) : dn)),
    (n = new n(t, o)),
    (e.memoizedState = n.state !== null && n.state !== void 0 ? n.state : null),
    (n.updater = sl),
    (e.stateNode = n),
    (n._reactInternals = e),
    r &&
      ((e = e.stateNode),
      (e.__reactInternalMemoizedUnmaskedChildContext = l),
      (e.__reactInternalMemoizedMaskedChildContext = o)),
    n
  );
}
function Ci(e, n, t, r) {
  (e = n.state),
    typeof n.componentWillReceiveProps == "function" &&
      n.componentWillReceiveProps(t, r),
    typeof n.UNSAFE_componentWillReceiveProps == "function" &&
      n.UNSAFE_componentWillReceiveProps(t, r),
    n.state !== e && sl.enqueueReplaceState(n, n.state, null);
}
function xo(e, n, t, r) {
  var l = e.stateNode;
  (l.props = t), (l.state = e.memoizedState), (l.refs = {}), du(e);
  var o = n.contextType;
  typeof o == "object" && o !== null
    ? (l.context = xe(o))
    : ((o = de(n) ? _n : le.current), (l.context = qn(e, o))),
    (l.state = e.memoizedState),
    (o = n.getDerivedStateFromProps),
    typeof o == "function" && (Co(e, n, o, t), (l.state = e.memoizedState)),
    typeof n.getDerivedStateFromProps == "function" ||
      typeof l.getSnapshotBeforeUpdate == "function" ||
      (typeof l.UNSAFE_componentWillMount != "function" &&
        typeof l.componentWillMount != "function") ||
      ((n = l.state),
      typeof l.componentWillMount == "function" && l.componentWillMount(),
      typeof l.UNSAFE_componentWillMount == "function" &&
        l.UNSAFE_componentWillMount(),
      n !== l.state && sl.enqueueReplaceState(l, l.state, null),
      Qr(e, t, l, r),
      (l.state = e.memoizedState)),
    typeof l.componentDidMount == "function" && (e.flags |= 4194308);
}
function tt(e, n) {
  try {
    var t = "",
      r = n;
    do (t += Rc(r)), (r = r.return);
    while (r);
    var l = t;
  } catch (o) {
    l =
      `
Error generating stack: ` +
      o.message +
      `
` +
      o.stack;
  }
  return { value: e, source: n, stack: l, digest: null };
}
function Vl(e, n, t) {
  return { value: e, source: null, stack: t ?? null, digest: n ?? null };
}
function _o(e, n) {
  try {
    console.error(n.value);
  } catch (t) {
    setTimeout(function () {
      throw t;
    });
  }
}
var od = typeof WeakMap == "function" ? WeakMap : Map;
function Pa(e, n, t) {
  (t = He(-1, t)), (t.tag = 3), (t.payload = { element: null });
  var r = n.value;
  return (
    (t.callback = function () {
      Zr || ((Zr = !0), (Do = r)), _o(e, n);
    }),
    t
  );
}
function za(e, n, t) {
  (t = He(-1, t)), (t.tag = 3);
  var r = e.type.getDerivedStateFromError;
  if (typeof r == "function") {
    var l = n.value;
    (t.payload = function () {
      return r(l);
    }),
      (t.callback = function () {
        _o(e, n);
      });
  }
  var o = e.stateNode;
  return (
    o !== null &&
      typeof o.componentDidCatch == "function" &&
      (t.callback = function () {
        _o(e, n),
          typeof r != "function" &&
            (sn === null ? (sn = new Set([this])) : sn.add(this));
        var u = n.stack;
        this.componentDidCatch(n.value, {
          componentStack: u !== null ? u : "",
        });
      }),
    t
  );
}
function xi(e, n, t) {
  var r = e.pingCache;
  if (r === null) {
    r = e.pingCache = new od();
    var l = new Set();
    r.set(n, l);
  } else (l = r.get(n)), l === void 0 && ((l = new Set()), r.set(n, l));
  l.has(t) || (l.add(t), (e = wd.bind(null, e, n, t)), n.then(e, e));
}
function _i(e) {
  do {
    var n;
    if (
      ((n = e.tag === 13) &&
        ((n = e.memoizedState), (n = n !== null ? n.dehydrated !== null : !0)),
      n)
    )
      return e;
    e = e.return;
  } while (e !== null);
  return null;
}
function Ni(e, n, t, r, l) {
  return e.mode & 1
    ? ((e.flags |= 65536), (e.lanes = l), e)
    : (e === n
        ? (e.flags |= 65536)
        : ((e.flags |= 128),
          (t.flags |= 131072),
          (t.flags &= -52805),
          t.tag === 1 &&
            (t.alternate === null
              ? (t.tag = 17)
              : ((n = He(-1, 1)), (n.tag = 2), un(t, n, 1))),
          (t.lanes |= 1)),
      e);
}
var ud = Xe.ReactCurrentOwner,
  ce = !1;
function oe(e, n, t, r) {
  n.child = e === null ? ra(n, null, t, r) : et(n, e.child, t, r);
}
function Pi(e, n, t, r, l) {
  t = t.render;
  var o = n.ref;
  return (
    Gn(n, l),
    (r = yu(e, n, t, r, o, l)),
    (t = gu()),
    e !== null && !ce
      ? ((n.updateQueue = e.updateQueue),
        (n.flags &= -2053),
        (e.lanes &= ~l),
        Ye(e, n, l))
      : (U && t && ou(n), (n.flags |= 1), oe(e, n, r, l), n.child)
  );
}
function zi(e, n, t, r, l) {
  if (e === null) {
    var o = t.type;
    return typeof o == "function" &&
      !zu(o) &&
      o.defaultProps === void 0 &&
      t.compare === null &&
      t.defaultProps === void 0
      ? ((n.tag = 15), (n.type = o), La(e, n, o, r, l))
      : ((e = Lr(t.type, null, r, n, n.mode, l)),
        (e.ref = n.ref),
        (e.return = n),
        (n.child = e));
  }
  if (((o = e.child), !(e.lanes & l))) {
    var u = o.memoizedProps;
    if (
      ((t = t.compare), (t = t !== null ? t : Ut), t(u, r) && e.ref === n.ref)
    )
      return Ye(e, n, l);
  }
  return (
    (n.flags |= 1),
    (e = cn(o, r)),
    (e.ref = n.ref),
    (e.return = n),
    (n.child = e)
  );
}
function La(e, n, t, r, l) {
  if (e !== null) {
    var o = e.memoizedProps;
    if (Ut(o, r) && e.ref === n.ref)
      if (((ce = !1), (n.pendingProps = r = o), (e.lanes & l) !== 0))
        e.flags & 131072 && (ce = !0);
      else return (n.lanes = e.lanes), Ye(e, n, l);
  }
  return No(e, n, t, r, l);
}
function Ta(e, n, t) {
  var r = n.pendingProps,
    l = r.children,
    o = e !== null ? e.memoizedState : null;
  if (r.mode === "hidden")
    if (!(n.mode & 1))
      (n.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }),
        D(Wn, me),
        (me |= t);
    else {
      if (!(t & 1073741824))
        return (
          (e = o !== null ? o.baseLanes | t : t),
          (n.lanes = n.childLanes = 1073741824),
          (n.memoizedState = {
            baseLanes: e,
            cachePool: null,
            transitions: null,
          }),
          (n.updateQueue = null),
          D(Wn, me),
          (me |= e),
          null
        );
      (n.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }),
        (r = o !== null ? o.baseLanes : t),
        D(Wn, me),
        (me |= r);
    }
  else
    o !== null ? ((r = o.baseLanes | t), (n.memoizedState = null)) : (r = t),
      D(Wn, me),
      (me |= r);
  return oe(e, n, l, t), n.child;
}
function Ra(e, n) {
  var t = n.ref;
  ((e === null && t !== null) || (e !== null && e.ref !== t)) &&
    ((n.flags |= 512), (n.flags |= 2097152));
}
function No(e, n, t, r, l) {
  var o = de(t) ? _n : le.current;
  return (
    (o = qn(n, o)),
    Gn(n, l),
    (t = yu(e, n, t, r, o, l)),
    (r = gu()),
    e !== null && !ce
      ? ((n.updateQueue = e.updateQueue),
        (n.flags &= -2053),
        (e.lanes &= ~l),
        Ye(e, n, l))
      : (U && r && ou(n), (n.flags |= 1), oe(e, n, t, l), n.child)
  );
}
function Li(e, n, t, r, l) {
  if (de(t)) {
    var o = !0;
    Ar(n);
  } else o = !1;
  if ((Gn(n, l), n.stateNode === null))
    Nr(e, n), Na(n, t, r), xo(n, t, r, l), (r = !0);
  else if (e === null) {
    var u = n.stateNode,
      i = n.memoizedProps;
    u.props = i;
    var s = u.context,
      c = t.contextType;
    typeof c == "object" && c !== null
      ? (c = xe(c))
      : ((c = de(t) ? _n : le.current), (c = qn(n, c)));
    var m = t.getDerivedStateFromProps,
      h =
        typeof m == "function" ||
        typeof u.getSnapshotBeforeUpdate == "function";
    h ||
      (typeof u.UNSAFE_componentWillReceiveProps != "function" &&
        typeof u.componentWillReceiveProps != "function") ||
      ((i !== r || s !== c) && Ci(n, u, r, c)),
      (Je = !1);
    var p = n.memoizedState;
    (u.state = p),
      Qr(n, r, u, l),
      (s = n.memoizedState),
      i !== r || p !== s || fe.current || Je
        ? (typeof m == "function" && (Co(n, t, m, r), (s = n.memoizedState)),
          (i = Je || Ei(n, t, i, r, p, s, c))
            ? (h ||
                (typeof u.UNSAFE_componentWillMount != "function" &&
                  typeof u.componentWillMount != "function") ||
                (typeof u.componentWillMount == "function" &&
                  u.componentWillMount(),
                typeof u.UNSAFE_componentWillMount == "function" &&
                  u.UNSAFE_componentWillMount()),
              typeof u.componentDidMount == "function" && (n.flags |= 4194308))
            : (typeof u.componentDidMount == "function" && (n.flags |= 4194308),
              (n.memoizedProps = r),
              (n.memoizedState = s)),
          (u.props = r),
          (u.state = s),
          (u.context = c),
          (r = i))
        : (typeof u.componentDidMount == "function" && (n.flags |= 4194308),
          (r = !1));
  } else {
    (u = n.stateNode),
      oa(e, n),
      (i = n.memoizedProps),
      (c = n.type === n.elementType ? i : ze(n.type, i)),
      (u.props = c),
      (h = n.pendingProps),
      (p = u.context),
      (s = t.contextType),
      typeof s == "object" && s !== null
        ? (s = xe(s))
        : ((s = de(t) ? _n : le.current), (s = qn(n, s)));
    var g = t.getDerivedStateFromProps;
    (m =
      typeof g == "function" ||
      typeof u.getSnapshotBeforeUpdate == "function") ||
      (typeof u.UNSAFE_componentWillReceiveProps != "function" &&
        typeof u.componentWillReceiveProps != "function") ||
      ((i !== h || p !== s) && Ci(n, u, r, s)),
      (Je = !1),
      (p = n.memoizedState),
      (u.state = p),
      Qr(n, r, u, l);
    var w = n.memoizedState;
    i !== h || p !== w || fe.current || Je
      ? (typeof g == "function" && (Co(n, t, g, r), (w = n.memoizedState)),
        (c = Je || Ei(n, t, c, r, p, w, s) || !1)
          ? (m ||
              (typeof u.UNSAFE_componentWillUpdate != "function" &&
                typeof u.componentWillUpdate != "function") ||
              (typeof u.componentWillUpdate == "function" &&
                u.componentWillUpdate(r, w, s),
              typeof u.UNSAFE_componentWillUpdate == "function" &&
                u.UNSAFE_componentWillUpdate(r, w, s)),
            typeof u.componentDidUpdate == "function" && (n.flags |= 4),
            typeof u.getSnapshotBeforeUpdate == "function" && (n.flags |= 1024))
          : (typeof u.componentDidUpdate != "function" ||
              (i === e.memoizedProps && p === e.memoizedState) ||
              (n.flags |= 4),
            typeof u.getSnapshotBeforeUpdate != "function" ||
              (i === e.memoizedProps && p === e.memoizedState) ||
              (n.flags |= 1024),
            (n.memoizedProps = r),
            (n.memoizedState = w)),
        (u.props = r),
        (u.state = w),
        (u.context = s),
        (r = c))
      : (typeof u.componentDidUpdate != "function" ||
          (i === e.memoizedProps && p === e.memoizedState) ||
          (n.flags |= 4),
        typeof u.getSnapshotBeforeUpdate != "function" ||
          (i === e.memoizedProps && p === e.memoizedState) ||
          (n.flags |= 1024),
        (r = !1));
  }
  return Po(e, n, t, r, o, l);
}
function Po(e, n, t, r, l, o) {
  Ra(e, n);
  var u = (n.flags & 128) !== 0;
  if (!r && !u) return l && mi(n, t, !1), Ye(e, n, o);
  (r = n.stateNode), (ud.current = n);
  var i =
    u && typeof t.getDerivedStateFromError != "function" ? null : r.render();
  return (
    (n.flags |= 1),
    e !== null && u
      ? ((n.child = et(n, e.child, null, o)), (n.child = et(n, null, i, o)))
      : oe(e, n, i, o),
    (n.memoizedState = r.state),
    l && mi(n, t, !0),
    n.child
  );
}
function ja(e) {
  var n = e.stateNode;
  n.pendingContext
    ? pi(e, n.pendingContext, n.pendingContext !== n.context)
    : n.context && pi(e, n.context, !1),
    pu(e, n.containerInfo);
}
function Ti(e, n, t, r, l) {
  return bn(), iu(l), (n.flags |= 256), oe(e, n, t, r), n.child;
}
var zo = { dehydrated: null, treeContext: null, retryLane: 0 };
function Lo(e) {
  return { baseLanes: e, cachePool: null, transitions: null };
}
function Ma(e, n, t) {
  var r = n.pendingProps,
    l = $.current,
    o = !1,
    u = (n.flags & 128) !== 0,
    i;
  if (
    ((i = u) ||
      (i = e !== null && e.memoizedState === null ? !1 : (l & 2) !== 0),
    i
      ? ((o = !0), (n.flags &= -129))
      : (e === null || e.memoizedState !== null) && (l |= 1),
    D($, l & 1),
    e === null)
  )
    return (
      ko(n),
      (e = n.memoizedState),
      e !== null && ((e = e.dehydrated), e !== null)
        ? (n.mode & 1
            ? e.data === "$!"
              ? (n.lanes = 8)
              : (n.lanes = 1073741824)
            : (n.lanes = 1),
          null)
        : ((u = r.children),
          (e = r.fallback),
          o
            ? ((r = n.mode),
              (o = n.child),
              (u = { mode: "hidden", children: u }),
              !(r & 1) && o !== null
                ? ((o.childLanes = 0), (o.pendingProps = u))
                : (o = fl(u, r, 0, null)),
              (e = xn(e, r, t, null)),
              (o.return = n),
              (e.return = n),
              (o.sibling = e),
              (n.child = o),
              (n.child.memoizedState = Lo(t)),
              (n.memoizedState = zo),
              e)
            : ku(n, u))
    );
  if (((l = e.memoizedState), l !== null && ((i = l.dehydrated), i !== null)))
    return id(e, n, u, r, i, l, t);
  if (o) {
    (o = r.fallback), (u = n.mode), (l = e.child), (i = l.sibling);
    var s = { mode: "hidden", children: r.children };
    return (
      !(u & 1) && n.child !== l
        ? ((r = n.child),
          (r.childLanes = 0),
          (r.pendingProps = s),
          (n.deletions = null))
        : ((r = cn(l, s)), (r.subtreeFlags = l.subtreeFlags & 14680064)),
      i !== null ? (o = cn(i, o)) : ((o = xn(o, u, t, null)), (o.flags |= 2)),
      (o.return = n),
      (r.return = n),
      (r.sibling = o),
      (n.child = r),
      (r = o),
      (o = n.child),
      (u = e.child.memoizedState),
      (u =
        u === null
          ? Lo(t)
          : {
              baseLanes: u.baseLanes | t,
              cachePool: null,
              transitions: u.transitions,
            }),
      (o.memoizedState = u),
      (o.childLanes = e.childLanes & ~t),
      (n.memoizedState = zo),
      r
    );
  }
  return (
    (o = e.child),
    (e = o.sibling),
    (r = cn(o, { mode: "visible", children: r.children })),
    !(n.mode & 1) && (r.lanes = t),
    (r.return = n),
    (r.sibling = null),
    e !== null &&
      ((t = n.deletions),
      t === null ? ((n.deletions = [e]), (n.flags |= 16)) : t.push(e)),
    (n.child = r),
    (n.memoizedState = null),
    r
  );
}
function ku(e, n) {
  return (
    (n = fl({ mode: "visible", children: n }, e.mode, 0, null)),
    (n.return = e),
    (e.child = n)
  );
}
function mr(e, n, t, r) {
  return (
    r !== null && iu(r),
    et(n, e.child, null, t),
    (e = ku(n, n.pendingProps.children)),
    (e.flags |= 2),
    (n.memoizedState = null),
    e
  );
}
function id(e, n, t, r, l, o, u) {
  if (t)
    return n.flags & 256
      ? ((n.flags &= -257), (r = Vl(Error(y(422)))), mr(e, n, u, r))
      : n.memoizedState !== null
      ? ((n.child = e.child), (n.flags |= 128), null)
      : ((o = r.fallback),
        (l = n.mode),
        (r = fl({ mode: "visible", children: r.children }, l, 0, null)),
        (o = xn(o, l, u, null)),
        (o.flags |= 2),
        (r.return = n),
        (o.return = n),
        (r.sibling = o),
        (n.child = r),
        n.mode & 1 && et(n, e.child, null, u),
        (n.child.memoizedState = Lo(u)),
        (n.memoizedState = zo),
        o);
  if (!(n.mode & 1)) return mr(e, n, u, null);
  if (l.data === "$!") {
    if (((r = l.nextSibling && l.nextSibling.dataset), r)) var i = r.dgst;
    return (r = i), (o = Error(y(419))), (r = Vl(o, r, void 0)), mr(e, n, u, r);
  }
  if (((i = (u & e.childLanes) !== 0), ce || i)) {
    if (((r = J), r !== null)) {
      switch (u & -u) {
        case 4:
          l = 2;
          break;
        case 16:
          l = 8;
          break;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          l = 32;
          break;
        case 536870912:
          l = 268435456;
          break;
        default:
          l = 0;
      }
      (l = l & (r.suspendedLanes | u) ? 0 : l),
        l !== 0 &&
          l !== o.retryLane &&
          ((o.retryLane = l), Ke(e, l), je(r, e, l, -1));
    }
    return Pu(), (r = Vl(Error(y(421)))), mr(e, n, u, r);
  }
  return l.data === "$?"
    ? ((n.flags |= 128),
      (n.child = e.child),
      (n = Sd.bind(null, e)),
      (l._reactRetry = n),
      null)
    : ((e = o.treeContext),
      (he = on(l.nextSibling)),
      (ve = n),
      (U = !0),
      (Te = null),
      e !== null &&
        ((Se[ke++] = Ve),
        (Se[ke++] = Be),
        (Se[ke++] = Nn),
        (Ve = e.id),
        (Be = e.overflow),
        (Nn = n)),
      (n = ku(n, r.children)),
      (n.flags |= 4096),
      n);
}
function Ri(e, n, t) {
  e.lanes |= n;
  var r = e.alternate;
  r !== null && (r.lanes |= n), Eo(e.return, n, t);
}
function Bl(e, n, t, r, l) {
  var o = e.memoizedState;
  o === null
    ? (e.memoizedState = {
        isBackwards: n,
        rendering: null,
        renderingStartTime: 0,
        last: r,
        tail: t,
        tailMode: l,
      })
    : ((o.isBackwards = n),
      (o.rendering = null),
      (o.renderingStartTime = 0),
      (o.last = r),
      (o.tail = t),
      (o.tailMode = l));
}
function Oa(e, n, t) {
  var r = n.pendingProps,
    l = r.revealOrder,
    o = r.tail;
  if ((oe(e, n, r.children, t), (r = $.current), r & 2))
    (r = (r & 1) | 2), (n.flags |= 128);
  else {
    if (e !== null && e.flags & 128)
      e: for (e = n.child; e !== null; ) {
        if (e.tag === 13) e.memoizedState !== null && Ri(e, t, n);
        else if (e.tag === 19) Ri(e, t, n);
        else if (e.child !== null) {
          (e.child.return = e), (e = e.child);
          continue;
        }
        if (e === n) break e;
        for (; e.sibling === null; ) {
          if (e.return === null || e.return === n) break e;
          e = e.return;
        }
        (e.sibling.return = e.return), (e = e.sibling);
      }
    r &= 1;
  }
  if ((D($, r), !(n.mode & 1))) n.memoizedState = null;
  else
    switch (l) {
      case "forwards":
        for (t = n.child, l = null; t !== null; )
          (e = t.alternate),
            e !== null && Kr(e) === null && (l = t),
            (t = t.sibling);
        (t = l),
          t === null
            ? ((l = n.child), (n.child = null))
            : ((l = t.sibling), (t.sibling = null)),
          Bl(n, !1, l, t, o);
        break;
      case "backwards":
        for (t = null, l = n.child, n.child = null; l !== null; ) {
          if (((e = l.alternate), e !== null && Kr(e) === null)) {
            n.child = l;
            break;
          }
          (e = l.sibling), (l.sibling = t), (t = l), (l = e);
        }
        Bl(n, !0, t, null, o);
        break;
      case "together":
        Bl(n, !1, null, null, void 0);
        break;
      default:
        n.memoizedState = null;
    }
  return n.child;
}
function Nr(e, n) {
  !(n.mode & 1) &&
    e !== null &&
    ((e.alternate = null), (n.alternate = null), (n.flags |= 2));
}
function Ye(e, n, t) {
  if (
    (e !== null && (n.dependencies = e.dependencies),
    (zn |= n.lanes),
    !(t & n.childLanes))
  )
    return null;
  if (e !== null && n.child !== e.child) throw Error(y(153));
  if (n.child !== null) {
    for (
      e = n.child, t = cn(e, e.pendingProps), n.child = t, t.return = n;
      e.sibling !== null;

    )
      (e = e.sibling), (t = t.sibling = cn(e, e.pendingProps)), (t.return = n);
    t.sibling = null;
  }
  return n.child;
}
function sd(e, n, t) {
  switch (n.tag) {
    case 3:
      ja(n), bn();
      break;
    case 5:
      ua(n);
      break;
    case 1:
      de(n.type) && Ar(n);
      break;
    case 4:
      pu(n, n.stateNode.containerInfo);
      break;
    case 10:
      var r = n.type._context,
        l = n.memoizedProps.value;
      D(Hr, r._currentValue), (r._currentValue = l);
      break;
    case 13:
      if (((r = n.memoizedState), r !== null))
        return r.dehydrated !== null
          ? (D($, $.current & 1), (n.flags |= 128), null)
          : t & n.child.childLanes
          ? Ma(e, n, t)
          : (D($, $.current & 1),
            (e = Ye(e, n, t)),
            e !== null ? e.sibling : null);
      D($, $.current & 1);
      break;
    case 19:
      if (((r = (t & n.childLanes) !== 0), e.flags & 128)) {
        if (r) return Oa(e, n, t);
        n.flags |= 128;
      }
      if (
        ((l = n.memoizedState),
        l !== null &&
          ((l.rendering = null), (l.tail = null), (l.lastEffect = null)),
        D($, $.current),
        r)
      )
        break;
      return null;
    case 22:
    case 23:
      return (n.lanes = 0), Ta(e, n, t);
  }
  return Ye(e, n, t);
}
var Da, To, Ia, Fa;
Da = function (e, n) {
  for (var t = n.child; t !== null; ) {
    if (t.tag === 5 || t.tag === 6) e.appendChild(t.stateNode);
    else if (t.tag !== 4 && t.child !== null) {
      (t.child.return = t), (t = t.child);
      continue;
    }
    if (t === n) break;
    for (; t.sibling === null; ) {
      if (t.return === null || t.return === n) return;
      t = t.return;
    }
    (t.sibling.return = t.return), (t = t.sibling);
  }
};
To = function () {};
Ia = function (e, n, t, r) {
  var l = e.memoizedProps;
  if (l !== r) {
    (e = n.stateNode), En(Ue.current);
    var o = null;
    switch (t) {
      case "input":
        (l = Jl(e, l)), (r = Jl(e, r)), (o = []);
        break;
      case "select":
        (l = V({}, l, { value: void 0 })),
          (r = V({}, r, { value: void 0 })),
          (o = []);
        break;
      case "textarea":
        (l = eo(e, l)), (r = eo(e, r)), (o = []);
        break;
      default:
        typeof l.onClick != "function" &&
          typeof r.onClick == "function" &&
          (e.onclick = Ur);
    }
    to(t, r);
    var u;
    t = null;
    for (c in l)
      if (!r.hasOwnProperty(c) && l.hasOwnProperty(c) && l[c] != null)
        if (c === "style") {
          var i = l[c];
          for (u in i) i.hasOwnProperty(u) && (t || (t = {}), (t[u] = ""));
        } else
          c !== "dangerouslySetInnerHTML" &&
            c !== "children" &&
            c !== "suppressContentEditableWarning" &&
            c !== "suppressHydrationWarning" &&
            c !== "autoFocus" &&
            (Rt.hasOwnProperty(c)
              ? o || (o = [])
              : (o = o || []).push(c, null));
    for (c in r) {
      var s = r[c];
      if (
        ((i = l != null ? l[c] : void 0),
        r.hasOwnProperty(c) && s !== i && (s != null || i != null))
      )
        if (c === "style")
          if (i) {
            for (u in i)
              !i.hasOwnProperty(u) ||
                (s && s.hasOwnProperty(u)) ||
                (t || (t = {}), (t[u] = ""));
            for (u in s)
              s.hasOwnProperty(u) &&
                i[u] !== s[u] &&
                (t || (t = {}), (t[u] = s[u]));
          } else t || (o || (o = []), o.push(c, t)), (t = s);
        else
          c === "dangerouslySetInnerHTML"
            ? ((s = s ? s.__html : void 0),
              (i = i ? i.__html : void 0),
              s != null && i !== s && (o = o || []).push(c, s))
            : c === "children"
            ? (typeof s != "string" && typeof s != "number") ||
              (o = o || []).push(c, "" + s)
            : c !== "suppressContentEditableWarning" &&
              c !== "suppressHydrationWarning" &&
              (Rt.hasOwnProperty(c)
                ? (s != null && c === "onScroll" && I("scroll", e),
                  o || i === s || (o = []))
                : (o = o || []).push(c, s));
    }
    t && (o = o || []).push("style", t);
    var c = o;
    (n.updateQueue = c) && (n.flags |= 4);
  }
};
Fa = function (e, n, t, r) {
  t !== r && (n.flags |= 4);
};
function ht(e, n) {
  if (!U)
    switch (e.tailMode) {
      case "hidden":
        n = e.tail;
        for (var t = null; n !== null; )
          n.alternate !== null && (t = n), (n = n.sibling);
        t === null ? (e.tail = null) : (t.sibling = null);
        break;
      case "collapsed":
        t = e.tail;
        for (var r = null; t !== null; )
          t.alternate !== null && (r = t), (t = t.sibling);
        r === null
          ? n || e.tail === null
            ? (e.tail = null)
            : (e.tail.sibling = null)
          : (r.sibling = null);
    }
}
function te(e) {
  var n = e.alternate !== null && e.alternate.child === e.child,
    t = 0,
    r = 0;
  if (n)
    for (var l = e.child; l !== null; )
      (t |= l.lanes | l.childLanes),
        (r |= l.subtreeFlags & 14680064),
        (r |= l.flags & 14680064),
        (l.return = e),
        (l = l.sibling);
  else
    for (l = e.child; l !== null; )
      (t |= l.lanes | l.childLanes),
        (r |= l.subtreeFlags),
        (r |= l.flags),
        (l.return = e),
        (l = l.sibling);
  return (e.subtreeFlags |= r), (e.childLanes = t), n;
}
function ad(e, n, t) {
  var r = n.pendingProps;
  switch ((uu(n), n.tag)) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return te(n), null;
    case 1:
      return de(n.type) && $r(), te(n), null;
    case 3:
      return (
        (r = n.stateNode),
        nt(),
        F(fe),
        F(le),
        hu(),
        r.pendingContext &&
          ((r.context = r.pendingContext), (r.pendingContext = null)),
        (e === null || e.child === null) &&
          (dr(n)
            ? (n.flags |= 4)
            : e === null ||
              (e.memoizedState.isDehydrated && !(n.flags & 256)) ||
              ((n.flags |= 1024), Te !== null && (Uo(Te), (Te = null)))),
        To(e, n),
        te(n),
        null
      );
    case 5:
      mu(n);
      var l = En(Ht.current);
      if (((t = n.type), e !== null && n.stateNode != null))
        Ia(e, n, t, r, l),
          e.ref !== n.ref && ((n.flags |= 512), (n.flags |= 2097152));
      else {
        if (!r) {
          if (n.stateNode === null) throw Error(y(166));
          return te(n), null;
        }
        if (((e = En(Ue.current)), dr(n))) {
          (r = n.stateNode), (t = n.type);
          var o = n.memoizedProps;
          switch (((r[Ie] = n), (r[Vt] = o), (e = (n.mode & 1) !== 0), t)) {
            case "dialog":
              I("cancel", r), I("close", r);
              break;
            case "iframe":
            case "object":
            case "embed":
              I("load", r);
              break;
            case "video":
            case "audio":
              for (l = 0; l < St.length; l++) I(St[l], r);
              break;
            case "source":
              I("error", r);
              break;
            case "img":
            case "image":
            case "link":
              I("error", r), I("load", r);
              break;
            case "details":
              I("toggle", r);
              break;
            case "input":
              Au(r, o), I("invalid", r);
              break;
            case "select":
              (r._wrapperState = { wasMultiple: !!o.multiple }),
                I("invalid", r);
              break;
            case "textarea":
              Bu(r, o), I("invalid", r);
          }
          to(t, o), (l = null);
          for (var u in o)
            if (o.hasOwnProperty(u)) {
              var i = o[u];
              u === "children"
                ? typeof i == "string"
                  ? r.textContent !== i &&
                    (o.suppressHydrationWarning !== !0 &&
                      fr(r.textContent, i, e),
                    (l = ["children", i]))
                  : typeof i == "number" &&
                    r.textContent !== "" + i &&
                    (o.suppressHydrationWarning !== !0 &&
                      fr(r.textContent, i, e),
                    (l = ["children", "" + i]))
                : Rt.hasOwnProperty(u) &&
                  i != null &&
                  u === "onScroll" &&
                  I("scroll", r);
            }
          switch (t) {
            case "input":
              rr(r), Vu(r, o, !0);
              break;
            case "textarea":
              rr(r), Hu(r);
              break;
            case "select":
            case "option":
              break;
            default:
              typeof o.onClick == "function" && (r.onclick = Ur);
          }
          (r = l), (n.updateQueue = r), r !== null && (n.flags |= 4);
        } else {
          (u = l.nodeType === 9 ? l : l.ownerDocument),
            e === "http://www.w3.org/1999/xhtml" && (e = fs(t)),
            e === "http://www.w3.org/1999/xhtml"
              ? t === "script"
                ? ((e = u.createElement("div")),
                  (e.innerHTML = "<script></script>"),
                  (e = e.removeChild(e.firstChild)))
                : typeof r.is == "string"
                ? (e = u.createElement(t, { is: r.is }))
                : ((e = u.createElement(t)),
                  t === "select" &&
                    ((u = e),
                    r.multiple
                      ? (u.multiple = !0)
                      : r.size && (u.size = r.size)))
              : (e = u.createElementNS(e, t)),
            (e[Ie] = n),
            (e[Vt] = r),
            Da(e, n, !1, !1),
            (n.stateNode = e);
          e: {
            switch (((u = ro(t, r)), t)) {
              case "dialog":
                I("cancel", e), I("close", e), (l = r);
                break;
              case "iframe":
              case "object":
              case "embed":
                I("load", e), (l = r);
                break;
              case "video":
              case "audio":
                for (l = 0; l < St.length; l++) I(St[l], e);
                l = r;
                break;
              case "source":
                I("error", e), (l = r);
                break;
              case "img":
              case "image":
              case "link":
                I("error", e), I("load", e), (l = r);
                break;
              case "details":
                I("toggle", e), (l = r);
                break;
              case "input":
                Au(e, r), (l = Jl(e, r)), I("invalid", e);
                break;
              case "option":
                l = r;
                break;
              case "select":
                (e._wrapperState = { wasMultiple: !!r.multiple }),
                  (l = V({}, r, { value: void 0 })),
                  I("invalid", e);
                break;
              case "textarea":
                Bu(e, r), (l = eo(e, r)), I("invalid", e);
                break;
              default:
                l = r;
            }
            to(t, l), (i = l);
            for (o in i)
              if (i.hasOwnProperty(o)) {
                var s = i[o];
                o === "style"
                  ? ms(e, s)
                  : o === "dangerouslySetInnerHTML"
                  ? ((s = s ? s.__html : void 0), s != null && ds(e, s))
                  : o === "children"
                  ? typeof s == "string"
                    ? (t !== "textarea" || s !== "") && jt(e, s)
                    : typeof s == "number" && jt(e, "" + s)
                  : o !== "suppressContentEditableWarning" &&
                    o !== "suppressHydrationWarning" &&
                    o !== "autoFocus" &&
                    (Rt.hasOwnProperty(o)
                      ? s != null && o === "onScroll" && I("scroll", e)
                      : s != null && Qo(e, o, s, u));
              }
            switch (t) {
              case "input":
                rr(e), Vu(e, r, !1);
                break;
              case "textarea":
                rr(e), Hu(e);
                break;
              case "option":
                r.value != null && e.setAttribute("value", "" + fn(r.value));
                break;
              case "select":
                (e.multiple = !!r.multiple),
                  (o = r.value),
                  o != null
                    ? Qn(e, !!r.multiple, o, !1)
                    : r.defaultValue != null &&
                      Qn(e, !!r.multiple, r.defaultValue, !0);
                break;
              default:
                typeof l.onClick == "function" && (e.onclick = Ur);
            }
            switch (t) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                r = !!r.autoFocus;
                break e;
              case "img":
                r = !0;
                break e;
              default:
                r = !1;
            }
          }
          r && (n.flags |= 4);
        }
        n.ref !== null && ((n.flags |= 512), (n.flags |= 2097152));
      }
      return te(n), null;
    case 6:
      if (e && n.stateNode != null) Fa(e, n, e.memoizedProps, r);
      else {
        if (typeof r != "string" && n.stateNode === null) throw Error(y(166));
        if (((t = En(Ht.current)), En(Ue.current), dr(n))) {
          if (
            ((r = n.stateNode),
            (t = n.memoizedProps),
            (r[Ie] = n),
            (o = r.nodeValue !== t) && ((e = ve), e !== null))
          )
            switch (e.tag) {
              case 3:
                fr(r.nodeValue, t, (e.mode & 1) !== 0);
                break;
              case 5:
                e.memoizedProps.suppressHydrationWarning !== !0 &&
                  fr(r.nodeValue, t, (e.mode & 1) !== 0);
            }
          o && (n.flags |= 4);
        } else
          (r = (t.nodeType === 9 ? t : t.ownerDocument).createTextNode(r)),
            (r[Ie] = n),
            (n.stateNode = r);
      }
      return te(n), null;
    case 13:
      if (
        (F($),
        (r = n.memoizedState),
        e === null ||
          (e.memoizedState !== null && e.memoizedState.dehydrated !== null))
      ) {
        if (U && he !== null && n.mode & 1 && !(n.flags & 128))
          na(), bn(), (n.flags |= 98560), (o = !1);
        else if (((o = dr(n)), r !== null && r.dehydrated !== null)) {
          if (e === null) {
            if (!o) throw Error(y(318));
            if (
              ((o = n.memoizedState),
              (o = o !== null ? o.dehydrated : null),
              !o)
            )
              throw Error(y(317));
            o[Ie] = n;
          } else
            bn(), !(n.flags & 128) && (n.memoizedState = null), (n.flags |= 4);
          te(n), (o = !1);
        } else Te !== null && (Uo(Te), (Te = null)), (o = !0);
        if (!o) return n.flags & 65536 ? n : null;
      }
      return n.flags & 128
        ? ((n.lanes = t), n)
        : ((r = r !== null),
          r !== (e !== null && e.memoizedState !== null) &&
            r &&
            ((n.child.flags |= 8192),
            n.mode & 1 &&
              (e === null || $.current & 1 ? X === 0 && (X = 3) : Pu())),
          n.updateQueue !== null && (n.flags |= 4),
          te(n),
          null);
    case 4:
      return (
        nt(), To(e, n), e === null && $t(n.stateNode.containerInfo), te(n), null
      );
    case 10:
      return cu(n.type._context), te(n), null;
    case 17:
      return de(n.type) && $r(), te(n), null;
    case 19:
      if ((F($), (o = n.memoizedState), o === null)) return te(n), null;
      if (((r = (n.flags & 128) !== 0), (u = o.rendering), u === null))
        if (r) ht(o, !1);
        else {
          if (X !== 0 || (e !== null && e.flags & 128))
            for (e = n.child; e !== null; ) {
              if (((u = Kr(e)), u !== null)) {
                for (
                  n.flags |= 128,
                    ht(o, !1),
                    r = u.updateQueue,
                    r !== null && ((n.updateQueue = r), (n.flags |= 4)),
                    n.subtreeFlags = 0,
                    r = t,
                    t = n.child;
                  t !== null;

                )
                  (o = t),
                    (e = r),
                    (o.flags &= 14680066),
                    (u = o.alternate),
                    u === null
                      ? ((o.childLanes = 0),
                        (o.lanes = e),
                        (o.child = null),
                        (o.subtreeFlags = 0),
                        (o.memoizedProps = null),
                        (o.memoizedState = null),
                        (o.updateQueue = null),
                        (o.dependencies = null),
                        (o.stateNode = null))
                      : ((o.childLanes = u.childLanes),
                        (o.lanes = u.lanes),
                        (o.child = u.child),
                        (o.subtreeFlags = 0),
                        (o.deletions = null),
                        (o.memoizedProps = u.memoizedProps),
                        (o.memoizedState = u.memoizedState),
                        (o.updateQueue = u.updateQueue),
                        (o.type = u.type),
                        (e = u.dependencies),
                        (o.dependencies =
                          e === null
                            ? null
                            : {
                                lanes: e.lanes,
                                firstContext: e.firstContext,
                              })),
                    (t = t.sibling);
                return D($, ($.current & 1) | 2), n.child;
              }
              e = e.sibling;
            }
          o.tail !== null &&
            Q() > rt &&
            ((n.flags |= 128), (r = !0), ht(o, !1), (n.lanes = 4194304));
        }
      else {
        if (!r)
          if (((e = Kr(u)), e !== null)) {
            if (
              ((n.flags |= 128),
              (r = !0),
              (t = e.updateQueue),
              t !== null && ((n.updateQueue = t), (n.flags |= 4)),
              ht(o, !0),
              o.tail === null && o.tailMode === "hidden" && !u.alternate && !U)
            )
              return te(n), null;
          } else
            2 * Q() - o.renderingStartTime > rt &&
              t !== 1073741824 &&
              ((n.flags |= 128), (r = !0), ht(o, !1), (n.lanes = 4194304));
        o.isBackwards
          ? ((u.sibling = n.child), (n.child = u))
          : ((t = o.last),
            t !== null ? (t.sibling = u) : (n.child = u),
            (o.last = u));
      }
      return o.tail !== null
        ? ((n = o.tail),
          (o.rendering = n),
          (o.tail = n.sibling),
          (o.renderingStartTime = Q()),
          (n.sibling = null),
          (t = $.current),
          D($, r ? (t & 1) | 2 : t & 1),
          n)
        : (te(n), null);
    case 22:
    case 23:
      return (
        Nu(),
        (r = n.memoizedState !== null),
        e !== null && (e.memoizedState !== null) !== r && (n.flags |= 8192),
        r && n.mode & 1
          ? me & 1073741824 && (te(n), n.subtreeFlags & 6 && (n.flags |= 8192))
          : te(n),
        null
      );
    case 24:
      return null;
    case 25:
      return null;
  }
  throw Error(y(156, n.tag));
}
function cd(e, n) {
  switch ((uu(n), n.tag)) {
    case 1:
      return (
        de(n.type) && $r(),
        (e = n.flags),
        e & 65536 ? ((n.flags = (e & -65537) | 128), n) : null
      );
    case 3:
      return (
        nt(),
        F(fe),
        F(le),
        hu(),
        (e = n.flags),
        e & 65536 && !(e & 128) ? ((n.flags = (e & -65537) | 128), n) : null
      );
    case 5:
      return mu(n), null;
    case 13:
      if ((F($), (e = n.memoizedState), e !== null && e.dehydrated !== null)) {
        if (n.alternate === null) throw Error(y(340));
        bn();
      }
      return (
        (e = n.flags), e & 65536 ? ((n.flags = (e & -65537) | 128), n) : null
      );
    case 19:
      return F($), null;
    case 4:
      return nt(), null;
    case 10:
      return cu(n.type._context), null;
    case 22:
    case 23:
      return Nu(), null;
    case 24:
      return null;
    default:
      return null;
  }
}
var hr = !1,
  re = !1,
  fd = typeof WeakSet == "function" ? WeakSet : Set,
  k = null;
function Hn(e, n) {
  var t = e.ref;
  if (t !== null)
    if (typeof t == "function")
      try {
        t(null);
      } catch (r) {
        B(e, n, r);
      }
    else t.current = null;
}
function Ro(e, n, t) {
  try {
    t();
  } catch (r) {
    B(e, n, r);
  }
}
var ji = !1;
function dd(e, n) {
  if (((mo = Dr), (e = Bs()), lu(e))) {
    if ("selectionStart" in e)
      var t = { start: e.selectionStart, end: e.selectionEnd };
    else
      e: {
        t = ((t = e.ownerDocument) && t.defaultView) || window;
        var r = t.getSelection && t.getSelection();
        if (r && r.rangeCount !== 0) {
          t = r.anchorNode;
          var l = r.anchorOffset,
            o = r.focusNode;
          r = r.focusOffset;
          try {
            t.nodeType, o.nodeType;
          } catch {
            t = null;
            break e;
          }
          var u = 0,
            i = -1,
            s = -1,
            c = 0,
            m = 0,
            h = e,
            p = null;
          n: for (;;) {
            for (
              var g;
              h !== t || (l !== 0 && h.nodeType !== 3) || (i = u + l),
                h !== o || (r !== 0 && h.nodeType !== 3) || (s = u + r),
                h.nodeType === 3 && (u += h.nodeValue.length),
                (g = h.firstChild) !== null;

            )
              (p = h), (h = g);
            for (;;) {
              if (h === e) break n;
              if (
                (p === t && ++c === l && (i = u),
                p === o && ++m === r && (s = u),
                (g = h.nextSibling) !== null)
              )
                break;
              (h = p), (p = h.parentNode);
            }
            h = g;
          }
          t = i === -1 || s === -1 ? null : { start: i, end: s };
        } else t = null;
      }
    t = t || { start: 0, end: 0 };
  } else t = null;
  for (ho = { focusedElem: e, selectionRange: t }, Dr = !1, k = n; k !== null; )
    if (((n = k), (e = n.child), (n.subtreeFlags & 1028) !== 0 && e !== null))
      (e.return = n), (k = e);
    else
      for (; k !== null; ) {
        n = k;
        try {
          var w = n.alternate;
          if (n.flags & 1024)
            switch (n.tag) {
              case 0:
              case 11:
              case 15:
                break;
              case 1:
                if (w !== null) {
                  var S = w.memoizedProps,
                    O = w.memoizedState,
                    d = n.stateNode,
                    a = d.getSnapshotBeforeUpdate(
                      n.elementType === n.type ? S : ze(n.type, S),
                      O
                    );
                  d.__reactInternalSnapshotBeforeUpdate = a;
                }
                break;
              case 3:
                var f = n.stateNode.containerInfo;
                f.nodeType === 1
                  ? (f.textContent = "")
                  : f.nodeType === 9 &&
                    f.documentElement &&
                    f.removeChild(f.documentElement);
                break;
              case 5:
              case 6:
              case 4:
              case 17:
                break;
              default:
                throw Error(y(163));
            }
        } catch (v) {
          B(n, n.return, v);
        }
        if (((e = n.sibling), e !== null)) {
          (e.return = n.return), (k = e);
          break;
        }
        k = n.return;
      }
  return (w = ji), (ji = !1), w;
}
function Pt(e, n, t) {
  var r = n.updateQueue;
  if (((r = r !== null ? r.lastEffect : null), r !== null)) {
    var l = (r = r.next);
    do {
      if ((l.tag & e) === e) {
        var o = l.destroy;
        (l.destroy = void 0), o !== void 0 && Ro(n, t, o);
      }
      l = l.next;
    } while (l !== r);
  }
}
function al(e, n) {
  if (
    ((n = n.updateQueue), (n = n !== null ? n.lastEffect : null), n !== null)
  ) {
    var t = (n = n.next);
    do {
      if ((t.tag & e) === e) {
        var r = t.create;
        t.destroy = r();
      }
      t = t.next;
    } while (t !== n);
  }
}
function jo(e) {
  var n = e.ref;
  if (n !== null) {
    var t = e.stateNode;
    switch (e.tag) {
      case 5:
        e = t;
        break;
      default:
        e = t;
    }
    typeof n == "function" ? n(e) : (n.current = e);
  }
}
function Ua(e) {
  var n = e.alternate;
  n !== null && ((e.alternate = null), Ua(n)),
    (e.child = null),
    (e.deletions = null),
    (e.sibling = null),
    e.tag === 5 &&
      ((n = e.stateNode),
      n !== null &&
        (delete n[Ie], delete n[Vt], delete n[go], delete n[Xf], delete n[Gf])),
    (e.stateNode = null),
    (e.return = null),
    (e.dependencies = null),
    (e.memoizedProps = null),
    (e.memoizedState = null),
    (e.pendingProps = null),
    (e.stateNode = null),
    (e.updateQueue = null);
}
function $a(e) {
  return e.tag === 5 || e.tag === 3 || e.tag === 4;
}
function Mi(e) {
  e: for (;;) {
    for (; e.sibling === null; ) {
      if (e.return === null || $a(e.return)) return null;
      e = e.return;
    }
    for (
      e.sibling.return = e.return, e = e.sibling;
      e.tag !== 5 && e.tag !== 6 && e.tag !== 18;

    ) {
      if (e.flags & 2 || e.child === null || e.tag === 4) continue e;
      (e.child.return = e), (e = e.child);
    }
    if (!(e.flags & 2)) return e.stateNode;
  }
}
function Mo(e, n, t) {
  var r = e.tag;
  if (r === 5 || r === 6)
    (e = e.stateNode),
      n
        ? t.nodeType === 8
          ? t.parentNode.insertBefore(e, n)
          : t.insertBefore(e, n)
        : (t.nodeType === 8
            ? ((n = t.parentNode), n.insertBefore(e, t))
            : ((n = t), n.appendChild(e)),
          (t = t._reactRootContainer),
          t != null || n.onclick !== null || (n.onclick = Ur));
  else if (r !== 4 && ((e = e.child), e !== null))
    for (Mo(e, n, t), e = e.sibling; e !== null; ) Mo(e, n, t), (e = e.sibling);
}
function Oo(e, n, t) {
  var r = e.tag;
  if (r === 5 || r === 6)
    (e = e.stateNode), n ? t.insertBefore(e, n) : t.appendChild(e);
  else if (r !== 4 && ((e = e.child), e !== null))
    for (Oo(e, n, t), e = e.sibling; e !== null; ) Oo(e, n, t), (e = e.sibling);
}
var q = null,
  Le = !1;
function Ge(e, n, t) {
  for (t = t.child; t !== null; ) Aa(e, n, t), (t = t.sibling);
}
function Aa(e, n, t) {
  if (Fe && typeof Fe.onCommitFiberUnmount == "function")
    try {
      Fe.onCommitFiberUnmount(nl, t);
    } catch {}
  switch (t.tag) {
    case 5:
      re || Hn(t, n);
    case 6:
      var r = q,
        l = Le;
      (q = null),
        Ge(e, n, t),
        (q = r),
        (Le = l),
        q !== null &&
          (Le
            ? ((e = q),
              (t = t.stateNode),
              e.nodeType === 8 ? e.parentNode.removeChild(t) : e.removeChild(t))
            : q.removeChild(t.stateNode));
      break;
    case 18:
      q !== null &&
        (Le
          ? ((e = q),
            (t = t.stateNode),
            e.nodeType === 8
              ? Dl(e.parentNode, t)
              : e.nodeType === 1 && Dl(e, t),
            It(e))
          : Dl(q, t.stateNode));
      break;
    case 4:
      (r = q),
        (l = Le),
        (q = t.stateNode.containerInfo),
        (Le = !0),
        Ge(e, n, t),
        (q = r),
        (Le = l);
      break;
    case 0:
    case 11:
    case 14:
    case 15:
      if (
        !re &&
        ((r = t.updateQueue), r !== null && ((r = r.lastEffect), r !== null))
      ) {
        l = r = r.next;
        do {
          var o = l,
            u = o.destroy;
          (o = o.tag),
            u !== void 0 && (o & 2 || o & 4) && Ro(t, n, u),
            (l = l.next);
        } while (l !== r);
      }
      Ge(e, n, t);
      break;
    case 1:
      if (
        !re &&
        (Hn(t, n),
        (r = t.stateNode),
        typeof r.componentWillUnmount == "function")
      )
        try {
          (r.props = t.memoizedProps),
            (r.state = t.memoizedState),
            r.componentWillUnmount();
        } catch (i) {
          B(t, n, i);
        }
      Ge(e, n, t);
      break;
    case 21:
      Ge(e, n, t);
      break;
    case 22:
      t.mode & 1
        ? ((re = (r = re) || t.memoizedState !== null), Ge(e, n, t), (re = r))
        : Ge(e, n, t);
      break;
    default:
      Ge(e, n, t);
  }
}
function Oi(e) {
  var n = e.updateQueue;
  if (n !== null) {
    e.updateQueue = null;
    var t = e.stateNode;
    t === null && (t = e.stateNode = new fd()),
      n.forEach(function (r) {
        var l = kd.bind(null, e, r);
        t.has(r) || (t.add(r), r.then(l, l));
      });
  }
}
function Pe(e, n) {
  var t = n.deletions;
  if (t !== null)
    for (var r = 0; r < t.length; r++) {
      var l = t[r];
      try {
        var o = e,
          u = n,
          i = u;
        e: for (; i !== null; ) {
          switch (i.tag) {
            case 5:
              (q = i.stateNode), (Le = !1);
              break e;
            case 3:
              (q = i.stateNode.containerInfo), (Le = !0);
              break e;
            case 4:
              (q = i.stateNode.containerInfo), (Le = !0);
              break e;
          }
          i = i.return;
        }
        if (q === null) throw Error(y(160));
        Aa(o, u, l), (q = null), (Le = !1);
        var s = l.alternate;
        s !== null && (s.return = null), (l.return = null);
      } catch (c) {
        B(l, n, c);
      }
    }
  if (n.subtreeFlags & 12854)
    for (n = n.child; n !== null; ) Va(n, e), (n = n.sibling);
}
function Va(e, n) {
  var t = e.alternate,
    r = e.flags;
  switch (e.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
      if ((Pe(n, e), Oe(e), r & 4)) {
        try {
          Pt(3, e, e.return), al(3, e);
        } catch (S) {
          B(e, e.return, S);
        }
        try {
          Pt(5, e, e.return);
        } catch (S) {
          B(e, e.return, S);
        }
      }
      break;
    case 1:
      Pe(n, e), Oe(e), r & 512 && t !== null && Hn(t, t.return);
      break;
    case 5:
      if (
        (Pe(n, e),
        Oe(e),
        r & 512 && t !== null && Hn(t, t.return),
        e.flags & 32)
      ) {
        var l = e.stateNode;
        try {
          jt(l, "");
        } catch (S) {
          B(e, e.return, S);
        }
      }
      if (r & 4 && ((l = e.stateNode), l != null)) {
        var o = e.memoizedProps,
          u = t !== null ? t.memoizedProps : o,
          i = e.type,
          s = e.updateQueue;
        if (((e.updateQueue = null), s !== null))
          try {
            i === "input" && o.type === "radio" && o.name != null && as(l, o),
              ro(i, u);
            var c = ro(i, o);
            for (u = 0; u < s.length; u += 2) {
              var m = s[u],
                h = s[u + 1];
              m === "style"
                ? ms(l, h)
                : m === "dangerouslySetInnerHTML"
                ? ds(l, h)
                : m === "children"
                ? jt(l, h)
                : Qo(l, m, h, c);
            }
            switch (i) {
              case "input":
                ql(l, o);
                break;
              case "textarea":
                cs(l, o);
                break;
              case "select":
                var p = l._wrapperState.wasMultiple;
                l._wrapperState.wasMultiple = !!o.multiple;
                var g = o.value;
                g != null
                  ? Qn(l, !!o.multiple, g, !1)
                  : p !== !!o.multiple &&
                    (o.defaultValue != null
                      ? Qn(l, !!o.multiple, o.defaultValue, !0)
                      : Qn(l, !!o.multiple, o.multiple ? [] : "", !1));
            }
            l[Vt] = o;
          } catch (S) {
            B(e, e.return, S);
          }
      }
      break;
    case 6:
      if ((Pe(n, e), Oe(e), r & 4)) {
        if (e.stateNode === null) throw Error(y(162));
        (l = e.stateNode), (o = e.memoizedProps);
        try {
          l.nodeValue = o;
        } catch (S) {
          B(e, e.return, S);
        }
      }
      break;
    case 3:
      if (
        (Pe(n, e), Oe(e), r & 4 && t !== null && t.memoizedState.isDehydrated)
      )
        try {
          It(n.containerInfo);
        } catch (S) {
          B(e, e.return, S);
        }
      break;
    case 4:
      Pe(n, e), Oe(e);
      break;
    case 13:
      Pe(n, e),
        Oe(e),
        (l = e.child),
        l.flags & 8192 &&
          ((o = l.memoizedState !== null),
          (l.stateNode.isHidden = o),
          !o ||
            (l.alternate !== null && l.alternate.memoizedState !== null) ||
            (xu = Q())),
        r & 4 && Oi(e);
      break;
    case 22:
      if (
        ((m = t !== null && t.memoizedState !== null),
        e.mode & 1 ? ((re = (c = re) || m), Pe(n, e), (re = c)) : Pe(n, e),
        Oe(e),
        r & 8192)
      ) {
        if (
          ((c = e.memoizedState !== null),
          (e.stateNode.isHidden = c) && !m && e.mode & 1)
        )
          for (k = e, m = e.child; m !== null; ) {
            for (h = k = m; k !== null; ) {
              switch (((p = k), (g = p.child), p.tag)) {
                case 0:
                case 11:
                case 14:
                case 15:
                  Pt(4, p, p.return);
                  break;
                case 1:
                  Hn(p, p.return);
                  var w = p.stateNode;
                  if (typeof w.componentWillUnmount == "function") {
                    (r = p), (t = p.return);
                    try {
                      (n = r),
                        (w.props = n.memoizedProps),
                        (w.state = n.memoizedState),
                        w.componentWillUnmount();
                    } catch (S) {
                      B(r, t, S);
                    }
                  }
                  break;
                case 5:
                  Hn(p, p.return);
                  break;
                case 22:
                  if (p.memoizedState !== null) {
                    Ii(h);
                    continue;
                  }
              }
              g !== null ? ((g.return = p), (k = g)) : Ii(h);
            }
            m = m.sibling;
          }
        e: for (m = null, h = e; ; ) {
          if (h.tag === 5) {
            if (m === null) {
              m = h;
              try {
                (l = h.stateNode),
                  c
                    ? ((o = l.style),
                      typeof o.setProperty == "function"
                        ? o.setProperty("display", "none", "important")
                        : (o.display = "none"))
                    : ((i = h.stateNode),
                      (s = h.memoizedProps.style),
                      (u =
                        s != null && s.hasOwnProperty("display")
                          ? s.display
                          : null),
                      (i.style.display = ps("display", u)));
              } catch (S) {
                B(e, e.return, S);
              }
            }
          } else if (h.tag === 6) {
            if (m === null)
              try {
                h.stateNode.nodeValue = c ? "" : h.memoizedProps;
              } catch (S) {
                B(e, e.return, S);
              }
          } else if (
            ((h.tag !== 22 && h.tag !== 23) ||
              h.memoizedState === null ||
              h === e) &&
            h.child !== null
          ) {
            (h.child.return = h), (h = h.child);
            continue;
          }
          if (h === e) break e;
          for (; h.sibling === null; ) {
            if (h.return === null || h.return === e) break e;
            m === h && (m = null), (h = h.return);
          }
          m === h && (m = null), (h.sibling.return = h.return), (h = h.sibling);
        }
      }
      break;
    case 19:
      Pe(n, e), Oe(e), r & 4 && Oi(e);
      break;
    case 21:
      break;
    default:
      Pe(n, e), Oe(e);
  }
}
function Oe(e) {
  var n = e.flags;
  if (n & 2) {
    try {
      e: {
        for (var t = e.return; t !== null; ) {
          if ($a(t)) {
            var r = t;
            break e;
          }
          t = t.return;
        }
        throw Error(y(160));
      }
      switch (r.tag) {
        case 5:
          var l = r.stateNode;
          r.flags & 32 && (jt(l, ""), (r.flags &= -33));
          var o = Mi(e);
          Oo(e, o, l);
          break;
        case 3:
        case 4:
          var u = r.stateNode.containerInfo,
            i = Mi(e);
          Mo(e, i, u);
          break;
        default:
          throw Error(y(161));
      }
    } catch (s) {
      B(e, e.return, s);
    }
    e.flags &= -3;
  }
  n & 4096 && (e.flags &= -4097);
}
function pd(e, n, t) {
  (k = e), Ba(e);
}
function Ba(e, n, t) {
  for (var r = (e.mode & 1) !== 0; k !== null; ) {
    var l = k,
      o = l.child;
    if (l.tag === 22 && r) {
      var u = l.memoizedState !== null || hr;
      if (!u) {
        var i = l.alternate,
          s = (i !== null && i.memoizedState !== null) || re;
        i = hr;
        var c = re;
        if (((hr = u), (re = s) && !c))
          for (k = l; k !== null; )
            (u = k),
              (s = u.child),
              u.tag === 22 && u.memoizedState !== null
                ? Fi(l)
                : s !== null
                ? ((s.return = u), (k = s))
                : Fi(l);
        for (; o !== null; ) (k = o), Ba(o), (o = o.sibling);
        (k = l), (hr = i), (re = c);
      }
      Di(e);
    } else
      l.subtreeFlags & 8772 && o !== null ? ((o.return = l), (k = o)) : Di(e);
  }
}
function Di(e) {
  for (; k !== null; ) {
    var n = k;
    if (n.flags & 8772) {
      var t = n.alternate;
      try {
        if (n.flags & 8772)
          switch (n.tag) {
            case 0:
            case 11:
            case 15:
              re || al(5, n);
              break;
            case 1:
              var r = n.stateNode;
              if (n.flags & 4 && !re)
                if (t === null) r.componentDidMount();
                else {
                  var l =
                    n.elementType === n.type
                      ? t.memoizedProps
                      : ze(n.type, t.memoizedProps);
                  r.componentDidUpdate(
                    l,
                    t.memoizedState,
                    r.__reactInternalSnapshotBeforeUpdate
                  );
                }
              var o = n.updateQueue;
              o !== null && wi(n, o, r);
              break;
            case 3:
              var u = n.updateQueue;
              if (u !== null) {
                if (((t = null), n.child !== null))
                  switch (n.child.tag) {
                    case 5:
                      t = n.child.stateNode;
                      break;
                    case 1:
                      t = n.child.stateNode;
                  }
                wi(n, u, t);
              }
              break;
            case 5:
              var i = n.stateNode;
              if (t === null && n.flags & 4) {
                t = i;
                var s = n.memoizedProps;
                switch (n.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    s.autoFocus && t.focus();
                    break;
                  case "img":
                    s.src && (t.src = s.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (n.memoizedState === null) {
                var c = n.alternate;
                if (c !== null) {
                  var m = c.memoizedState;
                  if (m !== null) {
                    var h = m.dehydrated;
                    h !== null && It(h);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(y(163));
          }
        re || (n.flags & 512 && jo(n));
      } catch (p) {
        B(n, n.return, p);
      }
    }
    if (n === e) {
      k = null;
      break;
    }
    if (((t = n.sibling), t !== null)) {
      (t.return = n.return), (k = t);
      break;
    }
    k = n.return;
  }
}
function Ii(e) {
  for (; k !== null; ) {
    var n = k;
    if (n === e) {
      k = null;
      break;
    }
    var t = n.sibling;
    if (t !== null) {
      (t.return = n.return), (k = t);
      break;
    }
    k = n.return;
  }
}
function Fi(e) {
  for (; k !== null; ) {
    var n = k;
    try {
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          var t = n.return;
          try {
            al(4, n);
          } catch (s) {
            B(n, t, s);
          }
          break;
        case 1:
          var r = n.stateNode;
          if (typeof r.componentDidMount == "function") {
            var l = n.return;
            try {
              r.componentDidMount();
            } catch (s) {
              B(n, l, s);
            }
          }
          var o = n.return;
          try {
            jo(n);
          } catch (s) {
            B(n, o, s);
          }
          break;
        case 5:
          var u = n.return;
          try {
            jo(n);
          } catch (s) {
            B(n, u, s);
          }
      }
    } catch (s) {
      B(n, n.return, s);
    }
    if (n === e) {
      k = null;
      break;
    }
    var i = n.sibling;
    if (i !== null) {
      (i.return = n.return), (k = i);
      break;
    }
    k = n.return;
  }
}
var md = Math.ceil,
  Gr = Xe.ReactCurrentDispatcher,
  Eu = Xe.ReactCurrentOwner,
  Ce = Xe.ReactCurrentBatchConfig,
  R = 0,
  J = null,
  K = null,
  b = 0,
  me = 0,
  Wn = mn(0),
  X = 0,
  Yt = null,
  zn = 0,
  cl = 0,
  Cu = 0,
  zt = null,
  ae = null,
  xu = 0,
  rt = 1 / 0,
  $e = null,
  Zr = !1,
  Do = null,
  sn = null,
  vr = !1,
  nn = null,
  Jr = 0,
  Lt = 0,
  Io = null,
  Pr = -1,
  zr = 0;
function ue() {
  return R & 6 ? Q() : Pr !== -1 ? Pr : (Pr = Q());
}
function an(e) {
  return e.mode & 1
    ? R & 2 && b !== 0
      ? b & -b
      : Jf.transition !== null
      ? (zr === 0 && (zr = Ns()), zr)
      : ((e = M),
        e !== 0 || ((e = window.event), (e = e === void 0 ? 16 : Ms(e.type))),
        e)
    : 1;
}
function je(e, n, t, r) {
  if (50 < Lt) throw ((Lt = 0), (Io = null), Error(y(185)));
  Gt(e, t, r),
    (!(R & 2) || e !== J) &&
      (e === J && (!(R & 2) && (cl |= t), X === 4 && be(e, b)),
      pe(e, r),
      t === 1 && R === 0 && !(n.mode & 1) && ((rt = Q() + 500), ul && hn()));
}
function pe(e, n) {
  var t = e.callbackNode;
  Zc(e, n);
  var r = Or(e, e === J ? b : 0);
  if (r === 0)
    t !== null && Ku(t), (e.callbackNode = null), (e.callbackPriority = 0);
  else if (((n = r & -r), e.callbackPriority !== n)) {
    if ((t != null && Ku(t), n === 1))
      e.tag === 0 ? Zf(Ui.bind(null, e)) : qs(Ui.bind(null, e)),
        Kf(function () {
          !(R & 6) && hn();
        }),
        (t = null);
    else {
      switch (Ps(r)) {
        case 1:
          t = Zo;
          break;
        case 4:
          t = xs;
          break;
        case 16:
          t = Mr;
          break;
        case 536870912:
          t = _s;
          break;
        default:
          t = Mr;
      }
      t = Za(t, Ha.bind(null, e));
    }
    (e.callbackPriority = n), (e.callbackNode = t);
  }
}
function Ha(e, n) {
  if (((Pr = -1), (zr = 0), R & 6)) throw Error(y(327));
  var t = e.callbackNode;
  if (Zn() && e.callbackNode !== t) return null;
  var r = Or(e, e === J ? b : 0);
  if (r === 0) return null;
  if (r & 30 || r & e.expiredLanes || n) n = qr(e, r);
  else {
    n = r;
    var l = R;
    R |= 2;
    var o = Qa();
    (J !== e || b !== n) && (($e = null), (rt = Q() + 500), Cn(e, n));
    do
      try {
        yd();
        break;
      } catch (i) {
        Wa(e, i);
      }
    while (!0);
    au(),
      (Gr.current = o),
      (R = l),
      K !== null ? (n = 0) : ((J = null), (b = 0), (n = X));
  }
  if (n !== 0) {
    if (
      (n === 2 && ((l = so(e)), l !== 0 && ((r = l), (n = Fo(e, l)))), n === 1)
    )
      throw ((t = Yt), Cn(e, 0), be(e, r), pe(e, Q()), t);
    if (n === 6) be(e, r);
    else {
      if (
        ((l = e.current.alternate),
        !(r & 30) &&
          !hd(l) &&
          ((n = qr(e, r)),
          n === 2 && ((o = so(e)), o !== 0 && ((r = o), (n = Fo(e, o)))),
          n === 1))
      )
        throw ((t = Yt), Cn(e, 0), be(e, r), pe(e, Q()), t);
      switch (((e.finishedWork = l), (e.finishedLanes = r), n)) {
        case 0:
        case 1:
          throw Error(y(345));
        case 2:
          wn(e, ae, $e);
          break;
        case 3:
          if (
            (be(e, r), (r & 130023424) === r && ((n = xu + 500 - Q()), 10 < n))
          ) {
            if (Or(e, 0) !== 0) break;
            if (((l = e.suspendedLanes), (l & r) !== r)) {
              ue(), (e.pingedLanes |= e.suspendedLanes & l);
              break;
            }
            e.timeoutHandle = yo(wn.bind(null, e, ae, $e), n);
            break;
          }
          wn(e, ae, $e);
          break;
        case 4:
          if ((be(e, r), (r & 4194240) === r)) break;
          for (n = e.eventTimes, l = -1; 0 < r; ) {
            var u = 31 - Re(r);
            (o = 1 << u), (u = n[u]), u > l && (l = u), (r &= ~o);
          }
          if (
            ((r = l),
            (r = Q() - r),
            (r =
              (120 > r
                ? 120
                : 480 > r
                ? 480
                : 1080 > r
                ? 1080
                : 1920 > r
                ? 1920
                : 3e3 > r
                ? 3e3
                : 4320 > r
                ? 4320
                : 1960 * md(r / 1960)) - r),
            10 < r)
          ) {
            e.timeoutHandle = yo(wn.bind(null, e, ae, $e), r);
            break;
          }
          wn(e, ae, $e);
          break;
        case 5:
          wn(e, ae, $e);
          break;
        default:
          throw Error(y(329));
      }
    }
  }
  return pe(e, Q()), e.callbackNode === t ? Ha.bind(null, e) : null;
}
function Fo(e, n) {
  var t = zt;
  return (
    e.current.memoizedState.isDehydrated && (Cn(e, n).flags |= 256),
    (e = qr(e, n)),
    e !== 2 && ((n = ae), (ae = t), n !== null && Uo(n)),
    e
  );
}
function Uo(e) {
  ae === null ? (ae = e) : ae.push.apply(ae, e);
}
function hd(e) {
  for (var n = e; ; ) {
    if (n.flags & 16384) {
      var t = n.updateQueue;
      if (t !== null && ((t = t.stores), t !== null))
        for (var r = 0; r < t.length; r++) {
          var l = t[r],
            o = l.getSnapshot;
          l = l.value;
          try {
            if (!Me(o(), l)) return !1;
          } catch {
            return !1;
          }
        }
    }
    if (((t = n.child), n.subtreeFlags & 16384 && t !== null))
      (t.return = n), (n = t);
    else {
      if (n === e) break;
      for (; n.sibling === null; ) {
        if (n.return === null || n.return === e) return !0;
        n = n.return;
      }
      (n.sibling.return = n.return), (n = n.sibling);
    }
  }
  return !0;
}
function be(e, n) {
  for (
    n &= ~Cu,
      n &= ~cl,
      e.suspendedLanes |= n,
      e.pingedLanes &= ~n,
      e = e.expirationTimes;
    0 < n;

  ) {
    var t = 31 - Re(n),
      r = 1 << t;
    (e[t] = -1), (n &= ~r);
  }
}
function Ui(e) {
  if (R & 6) throw Error(y(327));
  Zn();
  var n = Or(e, 0);
  if (!(n & 1)) return pe(e, Q()), null;
  var t = qr(e, n);
  if (e.tag !== 0 && t === 2) {
    var r = so(e);
    r !== 0 && ((n = r), (t = Fo(e, r)));
  }
  if (t === 1) throw ((t = Yt), Cn(e, 0), be(e, n), pe(e, Q()), t);
  if (t === 6) throw Error(y(345));
  return (
    (e.finishedWork = e.current.alternate),
    (e.finishedLanes = n),
    wn(e, ae, $e),
    pe(e, Q()),
    null
  );
}
function _u(e, n) {
  var t = R;
  R |= 1;
  try {
    return e(n);
  } finally {
    (R = t), R === 0 && ((rt = Q() + 500), ul && hn());
  }
}
function Ln(e) {
  nn !== null && nn.tag === 0 && !(R & 6) && Zn();
  var n = R;
  R |= 1;
  var t = Ce.transition,
    r = M;
  try {
    if (((Ce.transition = null), (M = 1), e)) return e();
  } finally {
    (M = r), (Ce.transition = t), (R = n), !(R & 6) && hn();
  }
}
function Nu() {
  (me = Wn.current), F(Wn);
}
function Cn(e, n) {
  (e.finishedWork = null), (e.finishedLanes = 0);
  var t = e.timeoutHandle;
  if ((t !== -1 && ((e.timeoutHandle = -1), Qf(t)), K !== null))
    for (t = K.return; t !== null; ) {
      var r = t;
      switch ((uu(r), r.tag)) {
        case 1:
          (r = r.type.childContextTypes), r != null && $r();
          break;
        case 3:
          nt(), F(fe), F(le), hu();
          break;
        case 5:
          mu(r);
          break;
        case 4:
          nt();
          break;
        case 13:
          F($);
          break;
        case 19:
          F($);
          break;
        case 10:
          cu(r.type._context);
          break;
        case 22:
        case 23:
          Nu();
      }
      t = t.return;
    }
  if (
    ((J = e),
    (K = e = cn(e.current, null)),
    (b = me = n),
    (X = 0),
    (Yt = null),
    (Cu = cl = zn = 0),
    (ae = zt = null),
    kn !== null)
  ) {
    for (n = 0; n < kn.length; n++)
      if (((t = kn[n]), (r = t.interleaved), r !== null)) {
        t.interleaved = null;
        var l = r.next,
          o = t.pending;
        if (o !== null) {
          var u = o.next;
          (o.next = l), (r.next = u);
        }
        t.pending = r;
      }
    kn = null;
  }
  return e;
}
function Wa(e, n) {
  do {
    var t = K;
    try {
      if ((au(), (xr.current = Xr), Yr)) {
        for (var r = A.memoizedState; r !== null; ) {
          var l = r.queue;
          l !== null && (l.pending = null), (r = r.next);
        }
        Yr = !1;
      }
      if (
        ((Pn = 0),
        (Z = Y = A = null),
        (Nt = !1),
        (Wt = 0),
        (Eu.current = null),
        t === null || t.return === null)
      ) {
        (X = 1), (Yt = n), (K = null);
        break;
      }
      e: {
        var o = e,
          u = t.return,
          i = t,
          s = n;
        if (
          ((n = b),
          (i.flags |= 32768),
          s !== null && typeof s == "object" && typeof s.then == "function")
        ) {
          var c = s,
            m = i,
            h = m.tag;
          if (!(m.mode & 1) && (h === 0 || h === 11 || h === 15)) {
            var p = m.alternate;
            p
              ? ((m.updateQueue = p.updateQueue),
                (m.memoizedState = p.memoizedState),
                (m.lanes = p.lanes))
              : ((m.updateQueue = null), (m.memoizedState = null));
          }
          var g = _i(u);
          if (g !== null) {
            (g.flags &= -257),
              Ni(g, u, i, o, n),
              g.mode & 1 && xi(o, c, n),
              (n = g),
              (s = c);
            var w = n.updateQueue;
            if (w === null) {
              var S = new Set();
              S.add(s), (n.updateQueue = S);
            } else w.add(s);
            break e;
          } else {
            if (!(n & 1)) {
              xi(o, c, n), Pu();
              break e;
            }
            s = Error(y(426));
          }
        } else if (U && i.mode & 1) {
          var O = _i(u);
          if (O !== null) {
            !(O.flags & 65536) && (O.flags |= 256),
              Ni(O, u, i, o, n),
              iu(tt(s, i));
            break e;
          }
        }
        (o = s = tt(s, i)),
          X !== 4 && (X = 2),
          zt === null ? (zt = [o]) : zt.push(o),
          (o = u);
        do {
          switch (o.tag) {
            case 3:
              (o.flags |= 65536), (n &= -n), (o.lanes |= n);
              var d = Pa(o, s, n);
              gi(o, d);
              break e;
            case 1:
              i = s;
              var a = o.type,
                f = o.stateNode;
              if (
                !(o.flags & 128) &&
                (typeof a.getDerivedStateFromError == "function" ||
                  (f !== null &&
                    typeof f.componentDidCatch == "function" &&
                    (sn === null || !sn.has(f))))
              ) {
                (o.flags |= 65536), (n &= -n), (o.lanes |= n);
                var v = za(o, i, n);
                gi(o, v);
                break e;
              }
          }
          o = o.return;
        } while (o !== null);
      }
      Ya(t);
    } catch (E) {
      (n = E), K === t && t !== null && (K = t = t.return);
      continue;
    }
    break;
  } while (!0);
}
function Qa() {
  var e = Gr.current;
  return (Gr.current = Xr), e === null ? Xr : e;
}
function Pu() {
  (X === 0 || X === 3 || X === 2) && (X = 4),
    J === null || (!(zn & 268435455) && !(cl & 268435455)) || be(J, b);
}
function qr(e, n) {
  var t = R;
  R |= 2;
  var r = Qa();
  (J !== e || b !== n) && (($e = null), Cn(e, n));
  do
    try {
      vd();
      break;
    } catch (l) {
      Wa(e, l);
    }
  while (!0);
  if ((au(), (R = t), (Gr.current = r), K !== null)) throw Error(y(261));
  return (J = null), (b = 0), X;
}
function vd() {
  for (; K !== null; ) Ka(K);
}
function yd() {
  for (; K !== null && !Vc(); ) Ka(K);
}
function Ka(e) {
  var n = Ga(e.alternate, e, me);
  (e.memoizedProps = e.pendingProps),
    n === null ? Ya(e) : (K = n),
    (Eu.current = null);
}
function Ya(e) {
  var n = e;
  do {
    var t = n.alternate;
    if (((e = n.return), n.flags & 32768)) {
      if (((t = cd(t, n)), t !== null)) {
        (t.flags &= 32767), (K = t);
        return;
      }
      if (e !== null)
        (e.flags |= 32768), (e.subtreeFlags = 0), (e.deletions = null);
      else {
        (X = 6), (K = null);
        return;
      }
    } else if (((t = ad(t, n, me)), t !== null)) {
      K = t;
      return;
    }
    if (((n = n.sibling), n !== null)) {
      K = n;
      return;
    }
    K = n = e;
  } while (n !== null);
  X === 0 && (X = 5);
}
function wn(e, n, t) {
  var r = M,
    l = Ce.transition;
  try {
    (Ce.transition = null), (M = 1), gd(e, n, t, r);
  } finally {
    (Ce.transition = l), (M = r);
  }
  return null;
}
function gd(e, n, t, r) {
  do Zn();
  while (nn !== null);
  if (R & 6) throw Error(y(327));
  t = e.finishedWork;
  var l = e.finishedLanes;
  if (t === null) return null;
  if (((e.finishedWork = null), (e.finishedLanes = 0), t === e.current))
    throw Error(y(177));
  (e.callbackNode = null), (e.callbackPriority = 0);
  var o = t.lanes | t.childLanes;
  if (
    (Jc(e, o),
    e === J && ((K = J = null), (b = 0)),
    (!(t.subtreeFlags & 2064) && !(t.flags & 2064)) ||
      vr ||
      ((vr = !0),
      Za(Mr, function () {
        return Zn(), null;
      })),
    (o = (t.flags & 15990) !== 0),
    t.subtreeFlags & 15990 || o)
  ) {
    (o = Ce.transition), (Ce.transition = null);
    var u = M;
    M = 1;
    var i = R;
    (R |= 4),
      (Eu.current = null),
      dd(e, t),
      Va(t, e),
      Uf(ho),
      (Dr = !!mo),
      (ho = mo = null),
      (e.current = t),
      pd(t),
      Bc(),
      (R = i),
      (M = u),
      (Ce.transition = o);
  } else e.current = t;
  if (
    (vr && ((vr = !1), (nn = e), (Jr = l)),
    (o = e.pendingLanes),
    o === 0 && (sn = null),
    Qc(t.stateNode),
    pe(e, Q()),
    n !== null)
  )
    for (r = e.onRecoverableError, t = 0; t < n.length; t++)
      (l = n[t]), r(l.value, { componentStack: l.stack, digest: l.digest });
  if (Zr) throw ((Zr = !1), (e = Do), (Do = null), e);
  return (
    Jr & 1 && e.tag !== 0 && Zn(),
    (o = e.pendingLanes),
    o & 1 ? (e === Io ? Lt++ : ((Lt = 0), (Io = e))) : (Lt = 0),
    hn(),
    null
  );
}
function Zn() {
  if (nn !== null) {
    var e = Ps(Jr),
      n = Ce.transition,
      t = M;
    try {
      if (((Ce.transition = null), (M = 16 > e ? 16 : e), nn === null))
        var r = !1;
      else {
        if (((e = nn), (nn = null), (Jr = 0), R & 6)) throw Error(y(331));
        var l = R;
        for (R |= 4, k = e.current; k !== null; ) {
          var o = k,
            u = o.child;
          if (k.flags & 16) {
            var i = o.deletions;
            if (i !== null) {
              for (var s = 0; s < i.length; s++) {
                var c = i[s];
                for (k = c; k !== null; ) {
                  var m = k;
                  switch (m.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Pt(8, m, o);
                  }
                  var h = m.child;
                  if (h !== null) (h.return = m), (k = h);
                  else
                    for (; k !== null; ) {
                      m = k;
                      var p = m.sibling,
                        g = m.return;
                      if ((Ua(m), m === c)) {
                        k = null;
                        break;
                      }
                      if (p !== null) {
                        (p.return = g), (k = p);
                        break;
                      }
                      k = g;
                    }
                }
              }
              var w = o.alternate;
              if (w !== null) {
                var S = w.child;
                if (S !== null) {
                  w.child = null;
                  do {
                    var O = S.sibling;
                    (S.sibling = null), (S = O);
                  } while (S !== null);
                }
              }
              k = o;
            }
          }
          if (o.subtreeFlags & 2064 && u !== null) (u.return = o), (k = u);
          else
            e: for (; k !== null; ) {
              if (((o = k), o.flags & 2048))
                switch (o.tag) {
                  case 0:
                  case 11:
                  case 15:
                    Pt(9, o, o.return);
                }
              var d = o.sibling;
              if (d !== null) {
                (d.return = o.return), (k = d);
                break e;
              }
              k = o.return;
            }
        }
        var a = e.current;
        for (k = a; k !== null; ) {
          u = k;
          var f = u.child;
          if (u.subtreeFlags & 2064 && f !== null) (f.return = u), (k = f);
          else
            e: for (u = a; k !== null; ) {
              if (((i = k), i.flags & 2048))
                try {
                  switch (i.tag) {
                    case 0:
                    case 11:
                    case 15:
                      al(9, i);
                  }
                } catch (E) {
                  B(i, i.return, E);
                }
              if (i === u) {
                k = null;
                break e;
              }
              var v = i.sibling;
              if (v !== null) {
                (v.return = i.return), (k = v);
                break e;
              }
              k = i.return;
            }
        }
        if (
          ((R = l), hn(), Fe && typeof Fe.onPostCommitFiberRoot == "function")
        )
          try {
            Fe.onPostCommitFiberRoot(nl, e);
          } catch {}
        r = !0;
      }
      return r;
    } finally {
      (M = t), (Ce.transition = n);
    }
  }
  return !1;
}
function $i(e, n, t) {
  (n = tt(t, n)),
    (n = Pa(e, n, 1)),
    (e = un(e, n, 1)),
    (n = ue()),
    e !== null && (Gt(e, 1, n), pe(e, n));
}
function B(e, n, t) {
  if (e.tag === 3) $i(e, e, t);
  else
    for (; n !== null; ) {
      if (n.tag === 3) {
        $i(n, e, t);
        break;
      } else if (n.tag === 1) {
        var r = n.stateNode;
        if (
          typeof n.type.getDerivedStateFromError == "function" ||
          (typeof r.componentDidCatch == "function" &&
            (sn === null || !sn.has(r)))
        ) {
          (e = tt(t, e)),
            (e = za(n, e, 1)),
            (n = un(n, e, 1)),
            (e = ue()),
            n !== null && (Gt(n, 1, e), pe(n, e));
          break;
        }
      }
      n = n.return;
    }
}
function wd(e, n, t) {
  var r = e.pingCache;
  r !== null && r.delete(n),
    (n = ue()),
    (e.pingedLanes |= e.suspendedLanes & t),
    J === e &&
      (b & t) === t &&
      (X === 4 || (X === 3 && (b & 130023424) === b && 500 > Q() - xu)
        ? Cn(e, 0)
        : (Cu |= t)),
    pe(e, n);
}
function Xa(e, n) {
  n === 0 &&
    (e.mode & 1
      ? ((n = ur), (ur <<= 1), !(ur & 130023424) && (ur = 4194304))
      : (n = 1));
  var t = ue();
  (e = Ke(e, n)), e !== null && (Gt(e, n, t), pe(e, t));
}
function Sd(e) {
  var n = e.memoizedState,
    t = 0;
  n !== null && (t = n.retryLane), Xa(e, t);
}
function kd(e, n) {
  var t = 0;
  switch (e.tag) {
    case 13:
      var r = e.stateNode,
        l = e.memoizedState;
      l !== null && (t = l.retryLane);
      break;
    case 19:
      r = e.stateNode;
      break;
    default:
      throw Error(y(314));
  }
  r !== null && r.delete(n), Xa(e, t);
}
var Ga;
Ga = function (e, n, t) {
  if (e !== null)
    if (e.memoizedProps !== n.pendingProps || fe.current) ce = !0;
    else {
      if (!(e.lanes & t) && !(n.flags & 128)) return (ce = !1), sd(e, n, t);
      ce = !!(e.flags & 131072);
    }
  else (ce = !1), U && n.flags & 1048576 && bs(n, Br, n.index);
  switch (((n.lanes = 0), n.tag)) {
    case 2:
      var r = n.type;
      Nr(e, n), (e = n.pendingProps);
      var l = qn(n, le.current);
      Gn(n, t), (l = yu(null, n, r, e, l, t));
      var o = gu();
      return (
        (n.flags |= 1),
        typeof l == "object" &&
        l !== null &&
        typeof l.render == "function" &&
        l.$$typeof === void 0
          ? ((n.tag = 1),
            (n.memoizedState = null),
            (n.updateQueue = null),
            de(r) ? ((o = !0), Ar(n)) : (o = !1),
            (n.memoizedState =
              l.state !== null && l.state !== void 0 ? l.state : null),
            du(n),
            (l.updater = sl),
            (n.stateNode = l),
            (l._reactInternals = n),
            xo(n, r, e, t),
            (n = Po(null, n, r, !0, o, t)))
          : ((n.tag = 0), U && o && ou(n), oe(null, n, l, t), (n = n.child)),
        n
      );
    case 16:
      r = n.elementType;
      e: {
        switch (
          (Nr(e, n),
          (e = n.pendingProps),
          (l = r._init),
          (r = l(r._payload)),
          (n.type = r),
          (l = n.tag = Cd(r)),
          (e = ze(r, e)),
          l)
        ) {
          case 0:
            n = No(null, n, r, e, t);
            break e;
          case 1:
            n = Li(null, n, r, e, t);
            break e;
          case 11:
            n = Pi(null, n, r, e, t);
            break e;
          case 14:
            n = zi(null, n, r, ze(r.type, e), t);
            break e;
        }
        throw Error(y(306, r, ""));
      }
      return n;
    case 0:
      return (
        (r = n.type),
        (l = n.pendingProps),
        (l = n.elementType === r ? l : ze(r, l)),
        No(e, n, r, l, t)
      );
    case 1:
      return (
        (r = n.type),
        (l = n.pendingProps),
        (l = n.elementType === r ? l : ze(r, l)),
        Li(e, n, r, l, t)
      );
    case 3:
      e: {
        if ((ja(n), e === null)) throw Error(y(387));
        (r = n.pendingProps),
          (o = n.memoizedState),
          (l = o.element),
          oa(e, n),
          Qr(n, r, null, t);
        var u = n.memoizedState;
        if (((r = u.element), o.isDehydrated))
          if (
            ((o = {
              element: r,
              isDehydrated: !1,
              cache: u.cache,
              pendingSuspenseBoundaries: u.pendingSuspenseBoundaries,
              transitions: u.transitions,
            }),
            (n.updateQueue.baseState = o),
            (n.memoizedState = o),
            n.flags & 256)
          ) {
            (l = tt(Error(y(423)), n)), (n = Ti(e, n, r, t, l));
            break e;
          } else if (r !== l) {
            (l = tt(Error(y(424)), n)), (n = Ti(e, n, r, t, l));
            break e;
          } else
            for (
              he = on(n.stateNode.containerInfo.firstChild),
                ve = n,
                U = !0,
                Te = null,
                t = ra(n, null, r, t),
                n.child = t;
              t;

            )
              (t.flags = (t.flags & -3) | 4096), (t = t.sibling);
        else {
          if ((bn(), r === l)) {
            n = Ye(e, n, t);
            break e;
          }
          oe(e, n, r, t);
        }
        n = n.child;
      }
      return n;
    case 5:
      return (
        ua(n),
        e === null && ko(n),
        (r = n.type),
        (l = n.pendingProps),
        (o = e !== null ? e.memoizedProps : null),
        (u = l.children),
        vo(r, l) ? (u = null) : o !== null && vo(r, o) && (n.flags |= 32),
        Ra(e, n),
        oe(e, n, u, t),
        n.child
      );
    case 6:
      return e === null && ko(n), null;
    case 13:
      return Ma(e, n, t);
    case 4:
      return (
        pu(n, n.stateNode.containerInfo),
        (r = n.pendingProps),
        e === null ? (n.child = et(n, null, r, t)) : oe(e, n, r, t),
        n.child
      );
    case 11:
      return (
        (r = n.type),
        (l = n.pendingProps),
        (l = n.elementType === r ? l : ze(r, l)),
        Pi(e, n, r, l, t)
      );
    case 7:
      return oe(e, n, n.pendingProps, t), n.child;
    case 8:
      return oe(e, n, n.pendingProps.children, t), n.child;
    case 12:
      return oe(e, n, n.pendingProps.children, t), n.child;
    case 10:
      e: {
        if (
          ((r = n.type._context),
          (l = n.pendingProps),
          (o = n.memoizedProps),
          (u = l.value),
          D(Hr, r._currentValue),
          (r._currentValue = u),
          o !== null)
        )
          if (Me(o.value, u)) {
            if (o.children === l.children && !fe.current) {
              n = Ye(e, n, t);
              break e;
            }
          } else
            for (o = n.child, o !== null && (o.return = n); o !== null; ) {
              var i = o.dependencies;
              if (i !== null) {
                u = o.child;
                for (var s = i.firstContext; s !== null; ) {
                  if (s.context === r) {
                    if (o.tag === 1) {
                      (s = He(-1, t & -t)), (s.tag = 2);
                      var c = o.updateQueue;
                      if (c !== null) {
                        c = c.shared;
                        var m = c.pending;
                        m === null
                          ? (s.next = s)
                          : ((s.next = m.next), (m.next = s)),
                          (c.pending = s);
                      }
                    }
                    (o.lanes |= t),
                      (s = o.alternate),
                      s !== null && (s.lanes |= t),
                      Eo(o.return, t, n),
                      (i.lanes |= t);
                    break;
                  }
                  s = s.next;
                }
              } else if (o.tag === 10) u = o.type === n.type ? null : o.child;
              else if (o.tag === 18) {
                if (((u = o.return), u === null)) throw Error(y(341));
                (u.lanes |= t),
                  (i = u.alternate),
                  i !== null && (i.lanes |= t),
                  Eo(u, t, n),
                  (u = o.sibling);
              } else u = o.child;
              if (u !== null) u.return = o;
              else
                for (u = o; u !== null; ) {
                  if (u === n) {
                    u = null;
                    break;
                  }
                  if (((o = u.sibling), o !== null)) {
                    (o.return = u.return), (u = o);
                    break;
                  }
                  u = u.return;
                }
              o = u;
            }
        oe(e, n, l.children, t), (n = n.child);
      }
      return n;
    case 9:
      return (
        (l = n.type),
        (r = n.pendingProps.children),
        Gn(n, t),
        (l = xe(l)),
        (r = r(l)),
        (n.flags |= 1),
        oe(e, n, r, t),
        n.child
      );
    case 14:
      return (
        (r = n.type),
        (l = ze(r, n.pendingProps)),
        (l = ze(r.type, l)),
        zi(e, n, r, l, t)
      );
    case 15:
      return La(e, n, n.type, n.pendingProps, t);
    case 17:
      return (
        (r = n.type),
        (l = n.pendingProps),
        (l = n.elementType === r ? l : ze(r, l)),
        Nr(e, n),
        (n.tag = 1),
        de(r) ? ((e = !0), Ar(n)) : (e = !1),
        Gn(n, t),
        Na(n, r, l),
        xo(n, r, l, t),
        Po(null, n, r, !0, e, t)
      );
    case 19:
      return Oa(e, n, t);
    case 22:
      return Ta(e, n, t);
  }
  throw Error(y(156, n.tag));
};
function Za(e, n) {
  return Cs(e, n);
}
function Ed(e, n, t, r) {
  (this.tag = e),
    (this.key = t),
    (this.sibling =
      this.child =
      this.return =
      this.stateNode =
      this.type =
      this.elementType =
        null),
    (this.index = 0),
    (this.ref = null),
    (this.pendingProps = n),
    (this.dependencies =
      this.memoizedState =
      this.updateQueue =
      this.memoizedProps =
        null),
    (this.mode = r),
    (this.subtreeFlags = this.flags = 0),
    (this.deletions = null),
    (this.childLanes = this.lanes = 0),
    (this.alternate = null);
}
function Ee(e, n, t, r) {
  return new Ed(e, n, t, r);
}
function zu(e) {
  return (e = e.prototype), !(!e || !e.isReactComponent);
}
function Cd(e) {
  if (typeof e == "function") return zu(e) ? 1 : 0;
  if (e != null) {
    if (((e = e.$$typeof), e === Yo)) return 11;
    if (e === Xo) return 14;
  }
  return 2;
}
function cn(e, n) {
  var t = e.alternate;
  return (
    t === null
      ? ((t = Ee(e.tag, n, e.key, e.mode)),
        (t.elementType = e.elementType),
        (t.type = e.type),
        (t.stateNode = e.stateNode),
        (t.alternate = e),
        (e.alternate = t))
      : ((t.pendingProps = n),
        (t.type = e.type),
        (t.flags = 0),
        (t.subtreeFlags = 0),
        (t.deletions = null)),
    (t.flags = e.flags & 14680064),
    (t.childLanes = e.childLanes),
    (t.lanes = e.lanes),
    (t.child = e.child),
    (t.memoizedProps = e.memoizedProps),
    (t.memoizedState = e.memoizedState),
    (t.updateQueue = e.updateQueue),
    (n = e.dependencies),
    (t.dependencies =
      n === null ? null : { lanes: n.lanes, firstContext: n.firstContext }),
    (t.sibling = e.sibling),
    (t.index = e.index),
    (t.ref = e.ref),
    t
  );
}
function Lr(e, n, t, r, l, o) {
  var u = 2;
  if (((r = e), typeof e == "function")) zu(e) && (u = 1);
  else if (typeof e == "string") u = 5;
  else
    e: switch (e) {
      case On:
        return xn(t.children, l, o, n);
      case Ko:
        (u = 8), (l |= 8);
        break;
      case Yl:
        return (
          (e = Ee(12, t, n, l | 2)), (e.elementType = Yl), (e.lanes = o), e
        );
      case Xl:
        return (e = Ee(13, t, n, l)), (e.elementType = Xl), (e.lanes = o), e;
      case Gl:
        return (e = Ee(19, t, n, l)), (e.elementType = Gl), (e.lanes = o), e;
      case us:
        return fl(t, l, o, n);
      default:
        if (typeof e == "object" && e !== null)
          switch (e.$$typeof) {
            case ls:
              u = 10;
              break e;
            case os:
              u = 9;
              break e;
            case Yo:
              u = 11;
              break e;
            case Xo:
              u = 14;
              break e;
            case Ze:
              (u = 16), (r = null);
              break e;
          }
        throw Error(y(130, e == null ? e : typeof e, ""));
    }
  return (
    (n = Ee(u, t, n, l)), (n.elementType = e), (n.type = r), (n.lanes = o), n
  );
}
function xn(e, n, t, r) {
  return (e = Ee(7, e, r, n)), (e.lanes = t), e;
}
function fl(e, n, t, r) {
  return (
    (e = Ee(22, e, r, n)),
    (e.elementType = us),
    (e.lanes = t),
    (e.stateNode = { isHidden: !1 }),
    e
  );
}
function Hl(e, n, t) {
  return (e = Ee(6, e, null, n)), (e.lanes = t), e;
}
function Wl(e, n, t) {
  return (
    (n = Ee(4, e.children !== null ? e.children : [], e.key, n)),
    (n.lanes = t),
    (n.stateNode = {
      containerInfo: e.containerInfo,
      pendingChildren: null,
      implementation: e.implementation,
    }),
    n
  );
}
function xd(e, n, t, r, l) {
  (this.tag = n),
    (this.containerInfo = e),
    (this.finishedWork =
      this.pingCache =
      this.current =
      this.pendingChildren =
        null),
    (this.timeoutHandle = -1),
    (this.callbackNode = this.pendingContext = this.context = null),
    (this.callbackPriority = 0),
    (this.eventTimes = xl(0)),
    (this.expirationTimes = xl(-1)),
    (this.entangledLanes =
      this.finishedLanes =
      this.mutableReadLanes =
      this.expiredLanes =
      this.pingedLanes =
      this.suspendedLanes =
      this.pendingLanes =
        0),
    (this.entanglements = xl(0)),
    (this.identifierPrefix = r),
    (this.onRecoverableError = l),
    (this.mutableSourceEagerHydrationData = null);
}
function Lu(e, n, t, r, l, o, u, i, s) {
  return (
    (e = new xd(e, n, t, i, s)),
    n === 1 ? ((n = 1), o === !0 && (n |= 8)) : (n = 0),
    (o = Ee(3, null, null, n)),
    (e.current = o),
    (o.stateNode = e),
    (o.memoizedState = {
      element: r,
      isDehydrated: t,
      cache: null,
      transitions: null,
      pendingSuspenseBoundaries: null,
    }),
    du(o),
    e
  );
}
function _d(e, n, t) {
  var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
  return {
    $$typeof: Mn,
    key: r == null ? null : "" + r,
    children: e,
    containerInfo: n,
    implementation: t,
  };
}
function Ja(e) {
  if (!e) return dn;
  e = e._reactInternals;
  e: {
    if (Rn(e) !== e || e.tag !== 1) throw Error(y(170));
    var n = e;
    do {
      switch (n.tag) {
        case 3:
          n = n.stateNode.context;
          break e;
        case 1:
          if (de(n.type)) {
            n = n.stateNode.__reactInternalMemoizedMergedChildContext;
            break e;
          }
      }
      n = n.return;
    } while (n !== null);
    throw Error(y(171));
  }
  if (e.tag === 1) {
    var t = e.type;
    if (de(t)) return Js(e, t, n);
  }
  return n;
}
function qa(e, n, t, r, l, o, u, i, s) {
  return (
    (e = Lu(t, r, !0, e, l, o, u, i, s)),
    (e.context = Ja(null)),
    (t = e.current),
    (r = ue()),
    (l = an(t)),
    (o = He(r, l)),
    (o.callback = n ?? null),
    un(t, o, l),
    (e.current.lanes = l),
    Gt(e, l, r),
    pe(e, r),
    e
  );
}
function dl(e, n, t, r) {
  var l = n.current,
    o = ue(),
    u = an(l);
  return (
    (t = Ja(t)),
    n.context === null ? (n.context = t) : (n.pendingContext = t),
    (n = He(o, u)),
    (n.payload = { element: e }),
    (r = r === void 0 ? null : r),
    r !== null && (n.callback = r),
    (e = un(l, n, u)),
    e !== null && (je(e, l, u, o), Cr(e, l, u)),
    u
  );
}
function br(e) {
  if (((e = e.current), !e.child)) return null;
  switch (e.child.tag) {
    case 5:
      return e.child.stateNode;
    default:
      return e.child.stateNode;
  }
}
function Ai(e, n) {
  if (((e = e.memoizedState), e !== null && e.dehydrated !== null)) {
    var t = e.retryLane;
    e.retryLane = t !== 0 && t < n ? t : n;
  }
}
function Tu(e, n) {
  Ai(e, n), (e = e.alternate) && Ai(e, n);
}
function Nd() {
  return null;
}
var ba =
  typeof reportError == "function"
    ? reportError
    : function (e) {
        console.error(e);
      };
function Ru(e) {
  this._internalRoot = e;
}
pl.prototype.render = Ru.prototype.render = function (e) {
  var n = this._internalRoot;
  if (n === null) throw Error(y(409));
  dl(e, n, null, null);
};
pl.prototype.unmount = Ru.prototype.unmount = function () {
  var e = this._internalRoot;
  if (e !== null) {
    this._internalRoot = null;
    var n = e.containerInfo;
    Ln(function () {
      dl(null, e, null, null);
    }),
      (n[Qe] = null);
  }
};
function pl(e) {
  this._internalRoot = e;
}
pl.prototype.unstable_scheduleHydration = function (e) {
  if (e) {
    var n = Ts();
    e = { blockedOn: null, target: e, priority: n };
    for (var t = 0; t < qe.length && n !== 0 && n < qe[t].priority; t++);
    qe.splice(t, 0, e), t === 0 && js(e);
  }
};
function ju(e) {
  return !(!e || (e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11));
}
function ml(e) {
  return !(
    !e ||
    (e.nodeType !== 1 &&
      e.nodeType !== 9 &&
      e.nodeType !== 11 &&
      (e.nodeType !== 8 || e.nodeValue !== " react-mount-point-unstable "))
  );
}
function Vi() {}
function Pd(e, n, t, r, l) {
  if (l) {
    if (typeof r == "function") {
      var o = r;
      r = function () {
        var c = br(u);
        o.call(c);
      };
    }
    var u = qa(n, r, e, 0, null, !1, !1, "", Vi);
    return (
      (e._reactRootContainer = u),
      (e[Qe] = u.current),
      $t(e.nodeType === 8 ? e.parentNode : e),
      Ln(),
      u
    );
  }
  for (; (l = e.lastChild); ) e.removeChild(l);
  if (typeof r == "function") {
    var i = r;
    r = function () {
      var c = br(s);
      i.call(c);
    };
  }
  var s = Lu(e, 0, !1, null, null, !1, !1, "", Vi);
  return (
    (e._reactRootContainer = s),
    (e[Qe] = s.current),
    $t(e.nodeType === 8 ? e.parentNode : e),
    Ln(function () {
      dl(n, s, t, r);
    }),
    s
  );
}
function hl(e, n, t, r, l) {
  var o = t._reactRootContainer;
  if (o) {
    var u = o;
    if (typeof l == "function") {
      var i = l;
      l = function () {
        var s = br(u);
        i.call(s);
      };
    }
    dl(n, u, e, l);
  } else u = Pd(t, n, e, l, r);
  return br(u);
}
zs = function (e) {
  switch (e.tag) {
    case 3:
      var n = e.stateNode;
      if (n.current.memoizedState.isDehydrated) {
        var t = wt(n.pendingLanes);
        t !== 0 &&
          (Jo(n, t | 1), pe(n, Q()), !(R & 6) && ((rt = Q() + 500), hn()));
      }
      break;
    case 13:
      Ln(function () {
        var r = Ke(e, 1);
        if (r !== null) {
          var l = ue();
          je(r, e, 1, l);
        }
      }),
        Tu(e, 1);
  }
};
qo = function (e) {
  if (e.tag === 13) {
    var n = Ke(e, 134217728);
    if (n !== null) {
      var t = ue();
      je(n, e, 134217728, t);
    }
    Tu(e, 134217728);
  }
};
Ls = function (e) {
  if (e.tag === 13) {
    var n = an(e),
      t = Ke(e, n);
    if (t !== null) {
      var r = ue();
      je(t, e, n, r);
    }
    Tu(e, n);
  }
};
Ts = function () {
  return M;
};
Rs = function (e, n) {
  var t = M;
  try {
    return (M = e), n();
  } finally {
    M = t;
  }
};
oo = function (e, n, t) {
  switch (n) {
    case "input":
      if ((ql(e, t), (n = t.name), t.type === "radio" && n != null)) {
        for (t = e; t.parentNode; ) t = t.parentNode;
        for (
          t = t.querySelectorAll(
            "input[name=" + JSON.stringify("" + n) + '][type="radio"]'
          ),
            n = 0;
          n < t.length;
          n++
        ) {
          var r = t[n];
          if (r !== e && r.form === e.form) {
            var l = ol(r);
            if (!l) throw Error(y(90));
            ss(r), ql(r, l);
          }
        }
      }
      break;
    case "textarea":
      cs(e, t);
      break;
    case "select":
      (n = t.value), n != null && Qn(e, !!t.multiple, n, !1);
  }
};
ys = _u;
gs = Ln;
var zd = { usingClientEntryPoint: !1, Events: [Jt, Un, ol, hs, vs, _u] },
  vt = {
    findFiberByHostInstance: Sn,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom",
  },
  Ld = {
    bundleType: vt.bundleType,
    version: vt.version,
    rendererPackageName: vt.rendererPackageName,
    rendererConfig: vt.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: Xe.ReactCurrentDispatcher,
    findHostInstanceByFiber: function (e) {
      return (e = ks(e)), e === null ? null : e.stateNode;
    },
    findFiberByHostInstance: vt.findFiberByHostInstance || Nd,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426",
  };
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
  var yr = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!yr.isDisabled && yr.supportsFiber)
    try {
      (nl = yr.inject(Ld)), (Fe = yr);
    } catch {}
}
ge.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = zd;
ge.createPortal = function (e, n) {
  var t = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
  if (!ju(n)) throw Error(y(200));
  return _d(e, n, null, t);
};
ge.createRoot = function (e, n) {
  if (!ju(e)) throw Error(y(299));
  var t = !1,
    r = "",
    l = ba;
  return (
    n != null &&
      (n.unstable_strictMode === !0 && (t = !0),
      n.identifierPrefix !== void 0 && (r = n.identifierPrefix),
      n.onRecoverableError !== void 0 && (l = n.onRecoverableError)),
    (n = Lu(e, 1, !1, null, null, t, !1, r, l)),
    (e[Qe] = n.current),
    $t(e.nodeType === 8 ? e.parentNode : e),
    new Ru(n)
  );
};
ge.findDOMNode = function (e) {
  if (e == null) return null;
  if (e.nodeType === 1) return e;
  var n = e._reactInternals;
  if (n === void 0)
    throw typeof e.render == "function"
      ? Error(y(188))
      : ((e = Object.keys(e).join(",")), Error(y(268, e)));
  return (e = ks(n)), (e = e === null ? null : e.stateNode), e;
};
ge.flushSync = function (e) {
  return Ln(e);
};
ge.hydrate = function (e, n, t) {
  if (!ml(n)) throw Error(y(200));
  return hl(null, e, n, !0, t);
};
ge.hydrateRoot = function (e, n, t) {
  if (!ju(e)) throw Error(y(405));
  var r = (t != null && t.hydratedSources) || null,
    l = !1,
    o = "",
    u = ba;
  if (
    (t != null &&
      (t.unstable_strictMode === !0 && (l = !0),
      t.identifierPrefix !== void 0 && (o = t.identifierPrefix),
      t.onRecoverableError !== void 0 && (u = t.onRecoverableError)),
    (n = qa(n, null, e, 1, t ?? null, l, !1, o, u)),
    (e[Qe] = n.current),
    $t(e),
    r)
  )
    for (e = 0; e < r.length; e++)
      (t = r[e]),
        (l = t._getVersion),
        (l = l(t._source)),
        n.mutableSourceEagerHydrationData == null
          ? (n.mutableSourceEagerHydrationData = [t, l])
          : n.mutableSourceEagerHydrationData.push(t, l);
  return new pl(n);
};
ge.render = function (e, n, t) {
  if (!ml(n)) throw Error(y(200));
  return hl(null, e, n, !1, t);
};
ge.unmountComponentAtNode = function (e) {
  if (!ml(e)) throw Error(y(40));
  return e._reactRootContainer
    ? (Ln(function () {
        hl(null, null, e, !1, function () {
          (e._reactRootContainer = null), (e[Qe] = null);
        });
      }),
      !0)
    : !1;
};
ge.unstable_batchedUpdates = _u;
ge.unstable_renderSubtreeIntoContainer = function (e, n, t, r) {
  if (!ml(t)) throw Error(y(200));
  if (e == null || e._reactInternals === void 0) throw Error(y(38));
  return hl(e, n, t, !1, r);
};
ge.version = "18.3.1-next-f1338f8080-20240426";
function ec() {
  if (
    !(
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" ||
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"
    )
  )
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(ec);
    } catch (e) {
      console.error(e);
    }
}
ec(), (es.exports = ge);
var Td = es.exports,
  Bi = Td;
(Ql.createRoot = Bi.createRoot), (Ql.hydrateRoot = Bi.hydrateRoot);
function Rd({
  marcas: e,
  allBrandsText: n,
  searchPlaceholderText: t,
  noResultsText: r,
  image: l,
  title: o,
  url: u,
  buttonText: i,
}) {
  const s = Array.isArray(e) ? e.flat(1 / 0).filter(Boolean) : [],
    c = {};
  s.forEach((a) => {
    const f = a.name.charAt(0).toUpperCase();
    /[A-Z]/.test(f)
      ? (c[f] = [...(c[f] || []), a])
      : (c["#"] = [...(c["#"] || []), a]);
  });
  const m = ["#"].concat(Object.keys(c).filter((a) => a !== "#")).sort(),
    [h, p] = Tt.useState(""),
    [g, w] = Tt.useState(null),
    S = Object.fromEntries(
      Object.entries(c).map(([a, f]) => [
        a,
        g === null
          ? f.filter((v) => v.name.toLowerCase().includes(h.toLowerCase()))
          : g === a
          ? f.filter((v) => v.name.toLowerCase().includes(h.toLowerCase()))
          : [],
      ])
    ),
    O = Array.from("ABCDEFGHIJKLMNOPQRSTUVWXYZ");
  function d(a) {
    w((f) => (f === a ? null : a));
  }
  return j.jsxs("div", {
    className: "brands-wrapper",
    children: [
      j.jsxs("nav", {
        className: "alphabet-wrapper",
        children: [
          j.jsxs("ul", {
            className: "alphabet",
            children: [
              j.jsx("button", {
                onClick: () => d(null),
                className: `alphabet-button ${g === null ? "active" : null}`,
                children: j.jsx("p", {
                  className: "title",
                  children:
                    (n == null ? void 0 : n.textContent) ?? "Todas as marcas",
                }),
              }),
              j.jsx("p", { className: "point", children: "•" }),
              j.jsx("button", {
                onClick: () => d("#"),
                className: `alphabet-button ${g === "#" ? "active" : ""}`,
                disabled: !c["#"],
                children: "#",
              }),
              O.map((a) =>
                j.jsxs(j.Fragment, {
                  children: [
                    j.jsx("p", { className: "point", children: "•" }),
                    j.jsx(
                      "button",
                      {
                        onClick: () => d(a),
                        className: `alphabet-button ${g === a ? "active" : ""}`,
                        disabled: !c[a],
                        children: a,
                      },
                      a
                    ),
                  ],
                })
              ),
            ],
          }),
          j.jsxs("div", {
            className: "brand_input_wrapper",
            children: [
              j.jsx("svg", {
                width: "40",
                height: "40",
                viewBox: "0 0 40 40",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: j.jsx("path", {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M12.5 18.5C12.5 15.1863 15.1863 12.5 18.5 12.5C21.8137 12.5 24.5 15.1863 24.5 18.5C24.5 21.8137 21.8137 24.5 18.5 24.5C15.1863 24.5 12.5 21.8137 12.5 18.5ZM18.5 11.5C14.634 11.5 11.5 14.634 11.5 18.5C11.5 22.366 14.634 25.5 18.5 25.5C20.253 25.5 21.8556 24.8556 23.0836 23.7907L27.6464 28.3536L28.3536 27.6464L23.7907 23.0836C24.8556 21.8556 25.5 20.253 25.5 18.5C25.5 14.634 22.366 11.5 18.5 11.5Z",
                  fill: "#171616",
                }),
              }),
              j.jsx("input", {
                type: "text",
                placeholder:
                  (t == null ? void 0 : t.textContent) ?? "Pesquisa marcas...",
                value: h,
                onChange: (a) => p(a.target.value),
              }),
            ],
          }),
        ],
      }),
      j.jsxs("div", {
        className: "main-content",
        children: [
          j.jsxs("div", {
            className: "main-brands",
            children: [
              m == null
                ? void 0
                : m
                    .filter((a) => {
                      var f;
                      return ((f = S[a]) == null ? void 0 : f.length) > 0;
                    })
                    .map((a) =>
                      j.jsxs(
                        "div",
                        {
                          className: "marca-group",
                          children: [
                            j.jsx("h2", { className: "letter", children: a }),
                            j.jsx("ul", {
                              children: S[a].map((f) =>
                                j.jsx(
                                  "li",
                                  {
                                    children: j.jsx("span", {
                                      style: { cursor: "pointer" },
                                      children: j.jsx("a", {
                                        href: f.url,
                                        children: j.jsx("p", {
                                          className: "underline-animation__in",
                                          children: f.name,
                                        }),
                                      }),
                                    }),
                                  },
                                  f.name
                                )
                              ),
                            }),
                          ],
                        },
                        a
                      )
                    ),
              (m == null
                ? void 0
                : m.every((a) => {
                    var f;
                    return ((f = S[a]) == null ? void 0 : f.length) === 0;
                  })) &&
                j.jsx("p", {
                  children:
                    (r == null ? void 0 : r.textContent) ?? "Sem resultados",
                }),
            ],
          }),
          /* (l == null ? void 0 : l.textContent) &&
            j.jsx("div", {
              className: "main-image",
              children: j.jsx("div", {
                className: "card",
                style: {
                  backgroundImage: `url("${
                    l == null ? void 0 : l.textContent
                  }")`,
                },
                children: j.jsxs("div", {
                  className: "overlay",
                  children: [
                    (o == null ? void 0 : o.textContent) &&
                      j.jsx("h3", {
                        className: "title",
                        children: o == null ? void 0 : o.textContent,
                      }),
                    (u == null ? void 0 : u.textContent) &&
                      j.jsx("a", {
                        className: "button",
                        href: u == null ? void 0 : u.textContent,
                        children: i == null ? void 0 : i.textContent,
                      }),
                  ],
                }),
              }),
            }), */
        ],
      }),
    ],
  });
}
document.addEventListener("DOMContentLoaded", function () {
  const e = document.querySelector("scx-marcas-data"),
    n = document.querySelector("scx-marcas-brands"),
    t = document.querySelector("scx-marcas-search"),
    r = document.querySelector("scx-marcas-no-results"),
    l = document.querySelector("scx-marcas-image"),
    o = document.querySelector("scx-marcas-title"),
    u = document.querySelector("scx-marcas-url"),
    i = document.querySelector("scx-marcas-button");
  if (e) {
    console.log("Marcas Element:", e);
    let s = null,
      c = [];
    try {
      if (
        ((s = e.innerHTML.trim()),
        console.log("Parsed marcas data:", s),
        s && typeof s == "string")
      )
        try {
          (c = JSON.parse(s)), console.log("Try Parsed marcas:", c);
        } catch (m) {
          console.error("Error parsing JSON:", m),
            console.log("Raw marcas data:", e.textContent || "");
        }
      else console.error("Invalid marcas data");
      Ql.createRoot(document.getElementById("root")).render(
        j.jsx(gc.StrictMode, {
          children: j.jsx(Rd, {
            marcas: c,
            allBrandsText: n,
            searchPlaceholderText: t,
            noResultsText: r,
            image: l,
            title: o,
            url: u,
            buttonText: i,
          }),
        })
      );
    } catch (m) {
      console.error("Error processing marcas data:", m);
    }
  } else console.warn("Marcas data element not found");
});
